(function () {
  "use strict";

  /*
      Example HTML:

  <div class="Accordion" data-module="accordion" data-accordion="expandFirst: true">
    <h4 class="Accordion-header" data-name="panel1"><a href="#" class="Accordion-headerLink">Panel 1</a></h4>
    <div class="Accordion-panel">
      <p>
        Mauris mauris ante, blandit et, ultrices a, suscipit eget, quam. Integer
        ut neque. Vivamus nisi metus, molestie vel, gravida in, condimentum sit
        amet, nunc. Nam a nibh. Donec suscipit eros. Nam mi. Proin viverra leo ut
        odio. Curabitur malesuada. Vestibulum a velit eu ante scelerisque vulputate.
      </p>
    </div>
    <h4 class="Accordion-header" data-name="panel2"><a href="#" class="Accordion-headerLink">Panel 2</a></h4>
    <div class="Accordion-panel">
      <p>
        Sed non urna. Donec et ante. Phasellus eu ligula. Vestibulum sit amet
        purus. Vivamus hendrerit, dolor at aliquet laoreet, mauris turpis porttitor
        velit, faucibus interdum tellus libero ac justo. Vivamus non quam. In
        suscipit faucibus urna.
      </p>
    </div>
    <h4 class="Accordion-header" data-name="panel3"><a href="#" class="Accordion-headerLink">Panel 3</a></h4>
    <div class="Accordion-panel">
      <p>
        Sed non urna. Donec et ante. Phasellus eu ligula. Vestibulum sit amet
        purus. Vivamus hendrerit, dolor at aliquet laoreet, mauris turpis porttitor
        velit, faucibus interdum tellus libero ac justo. Vivamus non quam. In
        suscipit faucibus urna.
      </p>
    </div>
  </div>
  */

  var moduleObj = moduler('accordion', {
    defaults: {
      event: 'click',
      headers: '.Accordion-header',
      buttons: '.Accordion-headerLink',
      panels: '.Accordion-panel',
      activeClass: 'is-active',
      mode: 'toggle', // accordion|toggle
      slide: true,
      slideDelay: 400,
      expandFirst: false,
      selectedPanel: null, // the panel to show at page load (optional).
      closeOnClickOutside: false,
      expanded: false
    },

    init: function (module) {
      module.$headers = module.$element.find(module.settings.headers);
      module.$panels = module.$element.find(module.settings.panels);
      if (module.settings.slide) {
        module.$panels.hide();
      }
      module.$headers.on(module.settings.event, module, moduleObj.listen.expandPanel);
      module.$element.addClass('js-ready');
      if (module.settings.selectedPanel) {
        module.$headers.filter('[data-name=' + module.settings.selectedPanel + ']').trigger(module.settings.event);
      } else if (module.settings.expandFirst) {
        module.$headers.first().on('initExpand', module, moduleObj.listen.expandPanel);
        module.$headers.first().trigger('initExpand');
      }

      if (module.settings.closeOnClickOutside) {
        module.$panels.on(module.settings.event, module, moduleObj.listen.dontCollapsePanels);
        module.$headers.on(module.settings.event, module, moduleObj.listen.dontCollapsePanels);
        $('.Page-main').on(module.settings.event, module, moduleObj.listen.collapseAll);
      }
    },

    listen: {
      expandAll: mo.event(function (module) {
        module.$headers.addClass(module.settings.activeClass).trigger('Accordion-expand');
        module.$panels.addClass(module.settings.activeClass).trigger('Accordion-expand');

        if (module.settings.slide) {
          module.$panels.slideDown(module.settings.slideDelay);
        }
        module.settings.expanded = true;
      }),

      collapseAll: mo.event(function (module, e) {
        if (module.settings.expanded) {
          module.$headers.removeClass(module.settings.activeClass).trigger('Accordion-collapse');
          module.$panels.removeClass(module.settings.activeClass).trigger('Accordion-collapse');

          if (module.settings.slide) {
            module.$panels.slideUp(module.settings.slideDelay);
          }
          module.settings.expanded = false;
        }
      }),

      dontCollapsePanels: mo.event(function (module, e) {
        if (module.settings.expanded) {
          e.stopPropagation();
        }
      }),

      expandPanel: mo.event(function (module, e) {
        e.preventDefault();

        var $header;
        var $headerButton;
        
        var target = $(e.target);
        if (target.is("button")) {
          $headerButton = target;
          $header = target.parent();
        } else {
          $header = $(e.target);
          $headerButton = $header.find('button');
        }
      
        var settings = module.settings;
        var headerIndex = module.$headers.index($header);
        var $panel = module.$panels.eq(headerIndex);

        // if event was triggered on a link inside "headers" then we try to find the handle element now
        if (!$header.is(module.settings.handles)) {
          $header = $header.closest(module.settings.headers);
          headerIndex = module.$headers.index($header);
          $panel = module.$panels.eq(headerIndex);
        }

        if (settings.mode === 'accordion') {
          module.$headers.not(function () {
            return $(this).has($header).length > 0 || $(this) == $header;
          }).removeClass(settings.activeClass).trigger('Accordion-collapse');
          module.$panels.not(function () {
            return $(this).has($panel).length > 0 || $(this) == $panel;
          }).removeClass(settings.activeClass).trigger('Accordion-collapse');

          if (settings.slide) {
            module.$panels.not(function () {
              return $(this).has($panel).length > 0 || $(this) == $panel;
            }).slideUp(settings.slideDelay);
          }
        }

        $header.toggleClass(settings.activeClass).trigger('Accordion-expand');
        $headerButton.attr('aria-expanded', function(index, attr){
           return attr === "true" ? "false" : "true";
        });
        $panel.toggleClass(settings.activeClass).trigger('Accordion-expand');

        if (settings.slide) {
          $panel.stop(true).slideToggle(settings.slideDelay);
        }
        settings.expanded = true;
      })
    },

    destroy: function (module) {
      module.$headers.off(module.settings.event, moduleObj.listen.expandPanel);
    }
  });

})();
(function () {
	"use strict";
	var moduleObj = moduler('account-address', {
		defaults: {
			triggerElement: '.js-save-address',
			serviceUrl: null
		},

		init: function (module) {
			$(module.$element).on('click', '.js-billing-address', function (e) {
				$('.js-billing-address-section', module.$element).toggleClass('u-hidden');
			});

			$(module.$element).on('click', module.settings.triggerElement, function (e) {
				e.preventDefault();
				var antiForgeryToken = $(this).data('antiforgerytoken');
				var email = $('.js-address-email', module.$element).val();
				var phoneNumber = $('.js-address-phone', module.$element).val();
				var address = {
					firstName: $('.js-address-firstname', module.$element).val(),
					lastName: $('.js-address-lastname', module.$element).val(),
					streetAddress: $('.js-address-streetaddress', module.$element).val(),
					postalCode: $('.js-address-postalcode', module.$element).val(),
					city: $('.js-address-city', module.$element).val()
				};
				var billingAddress = null;
				if($('.js-billing-address', module.$element).is(':checked')){
					billingAddress = {
						firstName: $('.js-address-billing-firstname', module.$element).val(),
						lastName: $('.js-address-billing-lastname', module.$element).val(),
						streetAddress: $('.js-address-billing-streetaddress', module.$element).val(),
						postalCode: $('.js-address-billing-postalcode', module.$element).val(),
						city: $('.js-address-billing-city', module.$element).val()
					};
				} else {
					$('.js-address-billing-firstname', module.$element).val('');
					$('.js-address-billing-lastname', module.$element).val('');
					$('.js-address-billing-streetaddress', module.$element).val('');
					$('.js-address-billing-postalcode', module.$element).val('');
					$('.js-address-billing-city', module.$element).val('');
				}
				moduleObj.saveAddress(module, address, billingAddress, email, phoneNumber, antiForgeryToken);
			});
		},
		saveAddress: function (module, address, billingAddress, email, phoneNumber, antiForgeryToken) {
			$.ajax({
				url: module.settings.serviceUrl,
				data: { address: address, billingAddress: billingAddress, email: email, phoneNumber: phoneNumber, __RequestVerificationToken: antiForgeryToken },
				method: 'POST',
				cache: false
			}).done(function (data) {
				
			});
		},

		destroy: function (module) { }
	});
})();
(function () {
	"use strict";

	var moduleObj = moduler('ajax-loader', {
		defaults: {
			delay: 500
		},
		loaderTimeoutId: null,
		init: function (module) {
			$(document).on('click', '.inStore a.js-header-logo-link, .inStore a.SubNav-link, .inStore a.js-productLink, .inStore .inStore-back a, .inStore a.js-show-more', function () {
				if (loadingBoxEnabled(event)) {
					if (moduleObj.loaderTimeoutId == null) {
						moduleObj.loaderTimeoutId = window.setTimeout(function () {
							module.$element.show();
						}, module.settings.delay);
					}
				}
			});

			$(document).bind('ajaxStart', function (event) {
				if (loadingBoxEnabled(event))
					if (moduleObj.loaderTimeoutId == null) {
						moduleObj.loaderTimeoutId = window.setTimeout(function () {
							module.$element.show();
						}, module.settings.delay);
					}
			});

			$(document).submit(function (event) {
				if (loadingBoxEnabled(event) && submitLoadingBoxEnabled(event)) {
					if (moduleObj.loaderTimeoutId == null) {
						moduleObj.loaderTimeoutId = window.setTimeout(function () {
							module.$element.show();
						}, module.settings.delay);
					}
				}
			});

			$(document).bind('ajaxComplete', function () {
				window.clearTimeout(moduleObj.loaderTimeoutId);
				moduleObj.loaderTimeoutId = null;
				module.$element.hide();
			});

			$(document).bind('ajaxError', function () {
				window.clearTimeout(moduleObj.loaderTimeoutId);
				moduleObj.loaderTimeoutId = null;
				module.$element.hide();
			});

			function loadingBoxEnabled(e) {
				return !$(e.target).hasClass("js-no-ajax-loader");
			};

			function submitLoadingBoxEnabled(e) {
				return !$(e.target).hasClass("js-no-submit-ajax-loader");
			}
		},
		listen: {},
		destroy: function (module) { }
	});
})();
(function () {
  "use strict";

  var moduleObj = moduler('anti-forgary-form', {
    defaults: {},
    init: function (module) {
      var fields = $('form.EPiServerForms input[name="__RequestVerificationToken"], form.js-anti-forgary input[name="__RequestVerificationToken"]');
      if (fields.length > 0) {
        fields.each(function (index, item) {
          $('input', item.closest('form')).focus(function () {
            if ($(item).data('tokenUpdated') == null) {
              $.getJSON('/tools/token?_=' + new Date().getTime(), function (data) {
                $(item).val(data.value);
                $(item).data('tokenUpdated', true);
              });
            }
          });
        });
      }
    },
  });
})();
(function () {
  "use strict";
  var moduleObj = moduler('ar-object', {
		defaults: {
			button: true
		},
    init: function (module) {
			var ar = new ARObject({
				arButton: module.settings.button,
				arOnlyShowOnMobile: true,
				arSupportedDevices: false,
				arClickHere: false,
				arSoundIcon: false,
				img: {
					arButton: '/assets/images/ar/ar-button-with-background-with-pulse.png',
					arSoundIcon: '/assets/images/ar/ar-link-sound.png'
				},
				translations: {
					requestClick: 'Click here for AR',
					supportedDevices: 'Supported Devices'
				}
			});
			ar.init();
    },
  });
})();
(function () {
	"use strict";

	var moduleObj = moduler('brandfilter', {
		defaults: {
			productServiceUrl: null
		},
		init: function (module) {
			$(module.$element).on('change', '.js-filter-checkbox', function (e) {
				moduleObj.updateFilterQueryString(module);
			
				$('.active-filters').html('');
				var selectedValues = $('.js-filter-checkbox:checked', module.$element);
				var categoryList = $('div.active-filters');
			
				$.each(selectedValues, function (index, item) {
					var div = $('<div/>')
						.addClass('List-item')
						.appendTo(categoryList);
					$('<span/>')
						.addClass('activeFilters-item js-filter-checkbox-selected-item')
						.attr('data-value', item.value)
						.text($(item).data('text'))
						.appendTo(div);
				});
			});

			$(document).on('click', '.js-filter-checkbox-selected-item', function (e) {
				var $checkbox = $('.js-filter-checkbox[value=' + $(this).data('value') + ']');
				$checkbox.prop('checked', false);
				$checkbox.trigger('change');
			});

			$(document).on(electrolux.events.filterUpdated, function (e, currentFilter) {
				moduleObj.currentPage = 1;
				var url = moduleObj.updateQueryStringParam('page', null);
				window.history.replaceState(null, document.title, url);
				moduleObj.loadProducts(module, false);
			});
		},

		loadProducts: function (module, append) {
			var url = moduleObj.updateQueryStringParam('partial', true);
			$.ajax({
				type: 'GET',
				url: url
			}).done(function (data, status, xhr) {
				var productCount = parseInt(xhr.getResponseHeader('X-ProductCount'));
				var lastPage = xhr.getResponseHeader('X-LastPage');
				var totalItems = parseInt(xhr.getResponseHeader('X-TotalItems'));
				$('.js-products').html(data.html);
				$('.js-total-products').text(totalItems);
				if (lastPage == true) {
					$('.js-product-load-more').hide();
				} else {
					$('.js-product-load-more').show();
				}
			});
		},

		updateFilterQueryString: function (module) {
			var selectedValues = $('.js-filter-checkbox:checked', module.$element);
			var values = '';
			$.each(selectedValues, function () {
				values += this.value + '|';
			});
			var hash = values.substring(0, values.length - 1);
			var url = moduleObj.updateQueryStringParam('filter', encodeURIComponent(hash));
			history.replaceState(null, document.title, url);
			$(document).trigger(electrolux.events.filterUpdated);
			return 'filter=' + encodeURIComponent(hash);
		},

		getParameterByName: function (name, url) {
			if (!url) {
				url = window.location.href;
			}
			name = name.replace(/[\[\]]/g, '\\$&');
			var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
				results = regex.exec(url);
			if (!results) {
				return null;
			} else if (!results[2]) {
				return '';
			} else {
				return decodeURIComponent(results[2].replace(/\+/g, ' '));
			}
		},

		updateQueryStringParam: function (key, value) {
			var baseUrl = [location.protocol, '//', location.host, location.pathname].join('');
			var urlQueryString = location.search;
			var newParam = key + '=' + value;
			var params = '?';

			// If the "search" string exists, then build params from it
			if (urlQueryString) {
				var updateRegex = new RegExp('([\?&])' + key + '[^&]*');
				var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');

				if (typeof value == 'undefined' || value == null || value == '') {
					params = urlQueryString.replace(removeRegex, "$1");
					params = params.replace(/[&;]$/, "");
				} else if (urlQueryString.match(updateRegex) !== null) {
					params = urlQueryString.replace(updateRegex, "$1" + newParam);
				} else {
					params = urlQueryString + '&' + newParam;
				}
			} else if (typeof value != 'undefined' && value != null && value != '') {
				params = '?' + newParam;
			}
			params = params == '?' ? '' : params;
			return baseUrl + params + location.hash;
		},

	
	});
})();
(function () {
	"use strict";
	var moduleObj = moduler('button-trigger', {
		defaults: {
			keyCode: 13,
			event: 'click',
			eventTarget: null
		},
		init: function (module) {
			if (module.settings.keyCode != null) {
				$(module.$element).keyup(function (event) {
					if (event.keyCode == module.settings.keyCode) {
						event.stopPropagation();
						event.preventDefault();
						$(module.settings.eventTarget).trigger(module.settings.event);
					}
				});
			} else {
				$(module.$element).click(function (event) {
					event.preventDefault();
					$(module.settings.eventTarget).trigger(module.settings.event);
				});
			}
		},
		listen: {},
		destroy: function (module) { }
	});
})();
(function () {
	"use strict";

	var moduleObj = moduler('chat', {
		defaults: {},

		init: function (module) {
			$(module.$element).on('click', function (e) {
                e.preventDefault();
				var newWindow = window.open(
								this.href,
								"targetWindow",
								"toolbar=0,location=0,status=0,menubar=0,scrollbars=1,resizable=0," +
								"width=" + 306 + "," +
								"height=" + 510 + "," +
								"top=" + ($(window).height() - 380) + "," +
								"left=" + ($(window).width() - 280) + ""
						);
				newWindow.focus();
				return false;
			});
		},

		listen: {},

		destroy: function (module) { }
	});

})();
(function () {
    "use strict";

    var moduleObj = moduler('confirm', {
        defaults: {
            message: 'Are you sure you want to perform this action?',
            event: 'click'
        },
        
        init: function (module) {
            module.$element.on(module.settings.event, module, moduleObj.listen.showConfirm);
        },

        listen: {
            showConfirm: mo.event(function (module, e) {
                e.preventDefault();

                if (window.confirm(module.settings.message)) {
                    module.$element.trigger('confirm-yes');
                } else {
                    module.$element.trigger('confirm-no');
                }
            })
        },
        
        destroy: function (module) {
            module.$element.off(module.settings.event, moduleObj.listen.showConfirm);
        }
    });
    
})();
(function () {
    "use strict";

    var moduleObj = moduler('datepicker', {
        defaults: {},

        init: function (module) {

            Pikaday.prototype.toString = function () {
                var yyyy = this._d.getFullYear().toString();
                var mm = (this._d.getMonth() + 1).toString(); // getMonth() is zero-based
                var dd = this._d.getDate().toString();
                return yyyy + '-' + (mm[1] ? mm : "0" + mm[0]) + '-' + (dd[1] ? dd : "0" + dd[0]); 
            };

            var currentYear = new Date().getFullYear();
            var picker = new Pikaday(
             {
                 numberOfMonths: 1,
                 field: module.element,
                 firstDay: 1,
                 format: 'MM YY',
                 minDate: new Date(),
                 maxDate: new Date(currentYear+1, 12, 31),
                 yearRange: [currentYear, currentYear+1],
                
                 i18n: {
                     previousMonth: 'Föregående månad',
                     nextMonth: 'Nästa måndad',
                     months: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
                     weekdays: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Söndag'],
                     weekdaysShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör']
                 }

             });
        },

        listen: {},

        destroy: function (module) { }
    });

})();
(function ($) {
  "use strict";
  var moduleObj = moduler('devicenav', {
    defaults: {
    },

    init: function () {
      var self = this;

      var nav = $('.DeviceNav');
      var menu = $('.DeviceNav-list');
      var menuContainer = $('.DeviceNav-container');
      var subMenu = $('.submenu');
      var toggle = $('.toggle');
      var subToggle = $('.has-children span');
      var back = '<div class="hide-submenu"></div>';
      var logo = $('.DeviceNav-header .Header-logo');
      var options = $('.DeviceNav-option');
      var subHide = $(back);
      var header = $('.DeviceNav-header');
      var subListToggler = $('.js-openChildList')
      var site = $('body');

      // Toggle menu
			toggle.on("click", function () {
        nav.toggleClass('is-visible');
				if (menu.hasClass('visually-hidden')) {
					electrolux.utils.toggleScroll(true)
          document.getElementById("search-container").classList.add("hide")
          menu.toggleClass('visually-hidden is-visible')
          site.addClass('no-scroll');
          site.css("max-width", "100%");
          options.removeClass('u-hidden');
				} else {
					electrolux.utils.toggleScroll(false)
          document.getElementById("search-container").classList.remove("hide")
          menu.removeClass('is-visible');
          // Wait for CSS animation
          setTimeout(function () {
            nav.removeClass('view-submenu');
            menu.addClass('visually-hidden');
            site.removeClass('no-scroll');
            options.addClass('u-hidden');
          }, 200);
        }
      });

      // Add submenu hide bar
      subHide.prependTo(options);
      var subHideToggle = $('.hide-submenu');

      // Show submenu
      subToggle.on("click", function () {
        nav.addClass('view-submenu');

        var title = $(this).data('title');
        var url = $(this).data('url');
        if (url != null && url != '') {
          $(".DeviceNav-parentName span").html('<a href="' + url + '">' + title + '</a>');
        } else if (title != null && title != '') {
          $(".DeviceNav-parentName span").html(title);
        }

        // Hide all the submenus...
        subMenu.hide();
        // ...except for the one being called
        $(this).parents('li').find('.submenu').show();
      });
      // Hide submenu
      subHideToggle.on("click", function () {
        nav.removeClass('view-submenu');
      });

      // Open childrenList
      subListToggler.on("click", function () {
        if ($(this).hasClass('is-open')) {
          var $parent = $('.js-mobile-menu-parent', $(this).closest('.js-mobile-menu-top'));
          if (parent.length > 0) {
            var title = $parent.data('title');
            var url = $parent.data('url');
            if (url != null && url != '') {
              $(".DeviceNav-parentName span").html('<a href="' + url + '">' + title + '</a>');
            } else if (title != null && title != '') {
              $(".DeviceNav-parentName span").html(title);
            }
          }
        }
        $(this).next().slideToggle();
        $(this).toggleClass('is-open');
      });

    }
  });
})(jQuery);
(function () {
	"use strict";

	var moduleObj = moduler('dialog', {
		defaults: {},

		init: function (module) {
			$(document).on(electrolux.events.dialogShowMessage, function (event, title, message) {
				moduleObj.showDialog(module, title, message);
			});
			$(document).on(electrolux.events.showConfirmDialog, function (event, title, message, callback) {
				moduleObj.showConfirmDialog(module, title, message, callback);
			});
			$(document).on(electrolux.events.dialogShowAjax, function (event, title, url, type) {
				moduleObj.showAjaxDialog(module, title, url, type);
			});
		},

		showAjaxDialog: function (module, title, url, type) {
			$.get(url)
				.done(function (message) {
					var dialog = [];
					if (type === "dynamic") {
						dialog.push('<section class="Modal Modal--dynamic js-custom-message-dialog">');
						dialog.push('<div class="Modal-dialog">');
						dialog.push('<div class="Modal-content">');
						if (title !== null && title !== '') {
							dialog.push('<h2>' + title + '</h2>');
						}
						dialog.push('<a class="Modal-close js-close" href="#" aria-label="Close"><span>&times;</span></a>');
						if (typeof message === 'string' || message instanceof String) {
							if (message.substring(0, 1) === '.' || message.substring(0, 1) === '#') {
								dialog.push('<p>' + $(message).html() + '</p>');
							} else if (message.trim().substring(0, 1) === '<') {
								dialog.push(message);
							} else {
								dialog.push('<p>' + message + '</p>');
							}
						} else {
							dialog.push(message.html);
						}
						dialog.push('</div>');
						dialog.push('</div>');
						dialog.push('</section>');
					} else {
						dialog.push('<section class="Modal js-custom-message-dialog">');
						dialog.push('<div class="Modal-dialog">');
						if (title != null && title != '') {
							dialog.push('<h2>' + title + '</h2>');
						}
						dialog.push('<a class="Modal-close js-close" href="#" aria-label="Close"><span>&times;</span></a>');
						if (message.substring(0, 1) == '.' || message.substring(0, 1) == '#') {
							dialog.push('<p>' + $(message).html() + '</p>');
						} else {
							dialog.push('<p>' + message + '</p>');
						}
						dialog.push('</div>');
						dialog.push('</section>');
					}

					$('.js-custom-message-dialog', 'body').remove();
					$('body').append(dialog.join(''));
					var eventName = 'showCustomMessageDialog';
					mo.utils.addModuleToElement($('.js-custom-message-dialog'), 'modal', { contentElement: '.js-custom-message-dialog', event: eventName, lockBody: true });
					$('.js-custom-message-dialog').trigger(eventName);
				});
		},

		showDialog: function (module, title, message) {
			var dialog = [];
			dialog.push('<section class="Modal js-custom-message-dialog">');
			dialog.push('<div class="Modal-dialog">');
			if (title != null && title != '') {
				dialog.push('<h2>' + title + '</h2>');
			}
			dialog.push('<a class="Modal-close js-close" href="#" aria-label="Close"><span>&times;</span></a>');
			if (message.substring(0, 1) == '.' || message.substring(0, 1) == '#') {
				dialog.push('<p>' + $(message).html() + '</p>');
			} else {
				dialog.push('<p>' + message + '</p>');
			}
			dialog.push('</div>');
			dialog.push('</section>');
			console.log(" sie pokazuje dialog sralog");
			$('.js-custom-message-dialog', 'body').remove();
			$('body').append(dialog.join(''));

			var eventName = 'showCustomMessageDialog';
			mo.utils.addModuleToElement($('.js-custom-message-dialog'), 'modal', { contentElement: '.js-custom-message-dialog', event: eventName });
			$('.js-custom-message-dialog').trigger(eventName);
		},

		showConfirmDialog: function (module, title, message, callback) {
			var dialog = [];
			
			dialog.push('<section class="Modal js-custom-message-dialog">');
			dialog.push('<div class="Modal-dialog">');
			if (title != null && title != '') {
				dialog.push('<h2>' + title + '</h2>');
			}
			dialog.push('<a class="Modal-close js-close" href="#" aria-label="Close"><span>&times;</span></a>');
			if (message.substring(0, 1) == '.' || message.substring(0, 1) == '#') {
				dialog.push('<p>' + $(message).html() + '</p>');
			} else {
				dialog.push('<p>' + message + '</p>');
			}
			dialog.push('<div>');
			dialog.push('<button class="Button u-marginRsm js-ok-button js-close">Ok</button>');
			dialog.push('<button class="Button js-close">Avbryt</button>');
			dialog.push('</div>');
			dialog.push('</div>');
			dialog.push('</section>');

			$('.js-custom-message-dialog', 'body').remove();
			$('body').append(dialog.join(''));
			if (callback != null) {
				$(document).off('click', '.js-ok-button');
				$(document).on('click', '.js-ok-button', callback);
			}

			var eventName = 'showCustomMessageDialog';
			mo.utils.addModuleToElement($('.js-custom-message-dialog'), 'modal', { contentElement: '.js-custom-message-dialog', event: eventName });
			$('.js-custom-message-dialog').trigger(eventName);
		},

		listen: {},

		destroy: function (module) { }
	});

})();
(function () {
    "use strict";

    var moduleObj = moduler('dispatcher', {
        defaults: {
            listenEvent: 'click', // the event to listen for. (required)
            listenSelector: null, // selector for elements to listen for the event (optional)

            triggerEvent: '', // event name to trigger when listenEvent fires. (required)
            triggerSelector: null, // selector for elements to trigger the event. (optional)
            triggerContext: null, // the context in which it will try to find elements through triggerSelector. (optional)

            preventDefault: true // whether to preventDefault when event fires.
        },
        
        init: function (module) {
            var settings = module.settings;

            module.$element.on(settings.listenEvent, settings.listenSelector, module, moduleObj.eventFired);
        },

        eventFired: mo.event(function (module, e) {
            var settings = module.settings;

            if (settings.preventDefault) {
                e.preventDefault();
            }

            if (settings.triggerSelector) {
                var $container = moduleObj.getContext(module);
                $container.find(settings.triggerSelector).trigger(settings.triggerEvent);
            } else {
                module.$element.trigger(settings.triggerEvent);
            }
        }),

        getContext: function (module) {
            var triggerContext = module.settings.triggerContext;
            
            if (triggerContext) {
                if (triggerContext == 'parent') {
                    return module.$element.parent(); 
                }
                return $(triggerContext);
            }
            return module.$element;
        },
        
        destroy: function (module) { 
            module.$element.off(settings.listenEvent, moduleObj.eventFired);
        }
    });
    
})();
(function () {
	"use strict";
	var moduleObj = moduler('dropmenu', {
		defaults: {},
		init: function (module) {
			$(module.$element).on('mouseenter', 'li', function (e) {
				if (!$('.js-dropmenu', $(this)).hasClass('down')) {
					$(this).data('trigger-down', 'false');
					$('.js-dropmenu', $(this)).slideDown('fast', function () {
						$(this).removeClass('up');
						$(this).addClass('down');
						var $li = $(this).closest('li');
						if ($li.data('trigger-down')=='true') {
							$li.trigger('mouseleave');
						}
					});
				}
			});

			$(module.$element).on('mouseleave', 'li', function (e) {
				if (!$('.js-dropmenu', $(this)).hasClass('up')) {
					$('.js-dropmenu', $(this)).slideUp('fast', function () {
						$(this).data('trigger-down', 'false');
						$(this).removeClass('down');
						$(this).addClass('up');
					});
				} else {
					$(this).data('trigger-down', 'true');
				}
			});
		}
	});
})();

(function () {
	"use strict";

	var moduleObj = moduler('email-link', {
		defaults: {},

		init: function (module) {
			$(module.$element).click(function (e) {
				moduleObj.showEmailAddress(module, $(this));
			});

			$(module.$element).hover(function (e) {
				moduleObj.showEmailAddress(module, $(this));
			});
		},

		showEmailAddress: function(module, $element){
			if (!$element.hasClass('shown')) {
				var href = $element.attr('href');
				var parts = href.split(':');
				if (parts.length == 2) {
					var emailAddress = parts[1].split('').reverse().join('');
					$element.attr('href', 'mailto:' + emailAddress);
					$element.addClass('shown');
				}
			}
		},

		listen: {},

		destroy: function (module) { }
	});

})();
(function () {
	"use strict";

	var moduleObj = moduler('flowbox-filter', {
		defaults: {
			buttonSelector: 'button.js-flowbox-filter',
			container: '',
			flowKey: '',
			fixedTag: ''
		},

		init: function (module) {
			let allTags = [];
			$(module.settings.buttonSelector, module.$element).each(function (index, item) {
				let tag = $(item).data('tag');
				if (tag != '') {
					allTags.push(tag);
				}
			});

			if (allTags.length > 0) {
				window.flowbox('init', {
					container: module.settings.container,
					key: module.settings.flowKey,
					locale: 'sv-SE',
					tags: allTags,
					tagsOperator: "any"
				});
			} else if (module.settings.fixedTag != '') {
				window.flowbox('init', {
					container: module.settings.container,
					key: module.settings.flowKey,
					locale: 'sv-SE',
					tags: [module.settings.fixedTag],
					tagsOperator: "any"
				});
			} else {
				window.flowbox('init', {
					container: module.settings.container,
					key: module.settings.flowKey,
					locale: 'sv-SE'
				});
			}

			$(module.settings.buttonSelector, module.$element).click(function (e) {
				let tag = $(this).data('tag');
				$(e.target).addClass('active').siblings().removeClass('active');
				if (tag != '') {
					moduleObj.updateFlow(module, tag, "all");
				} else {
					moduleObj.updateFlow(module, allTags, "any");
				}
			});
		},

		updateFlow: function(module, tag, tagsOperator) {
			window.flowbox('update', {
				container: module.settings.container,
				key: module.settings.flowKey,
				tags: [tag],
				tagsOperator: tagsOperator
			});
		},

		listen: {},

		destroy: function (module) { }
	});

})();
(function ($) {
  "use strict";

  var moduleObj = moduler('form-poster', {
    defaults: {
      submitButton: 'input[type=submit], button[type=submit]',
      url: null, // override the form's url. in case you want different url for ajax requests.
      data: null, /* extra data to send along the request to server */
      event: 'submit',
      contentElement: null,
      responseModule: null,
      loadingCssClass: 'form-loading',
      responseSegment: false, // update only a segment of the response (contentElement segment)
      validate: false
    },

    init: function (module) {
      module.$element.on(module.settings.event, module, moduleObj.listen.sendForm);
    },

    listen: {
      sendForm: mo.event(function (module, e) {
        var $form = module.$element.is('form') ? module.$element : module.$element.find('form'),
          $submitButton = $form.find(module.settings.submitButton),
          $contentElement = module.settings.contentElement !== null ? $(module.settings.contentElement) : module.$element,
          formMethod = $form.attr('method') || 'POST',
          url = module.settings.url || $form.attr('action');

        e.preventDefault();
        if (module.settings.validate) {
          $.validator.unobtrusive.parse($form);
          $form.validate();
          if (!$form.valid()) {
            return;
          }
        }

        // disable button while request is processing
        $submitButton.prop('disabled', true);
        module.$element.addClass(module.settings.loadingCssClass);

        // send request
        $.ajax({
          type: formMethod,
          url: url,
          data: $.extend(moduleObj.serializeFormObject($form), module.settings.data)
        }).always(function () {
          $submitButton.prop('disabled', false);
          module.$element.removeClass(module.settings.loadingCssClass);
        }).done(function (response, status, xhr) {
          if (module.settings.responseModule) {
            mo.utils.removeModuleFromElement($contentElement, module.settings.responseModule);
            mo.utils.addModuleToElement($contentElement, module.settings.responseModule, { response: response });
          } else if ($contentElement.length) {
            if (module.settings.responseSegment) {
              response = $($.parseHTML(response)).find(module.settings.contentElement).html();
            }
            $contentElement.html(response);
          }

          module.$element.trigger('form-poster-done', { response: response });
        }).error(function () {
          module.$element.trigger('form-poster-error');
        });
      })
    },

    serializeFormObject: function ($element) {
      var obj = {};
      $.each($element.serializeArray(), function (_, item) {
        if (obj.hasOwnProperty(item.name)) {
          obj[item.name] = $.makeArray(obj[item.name]);
          obj[item.name].push(item.value);
        }
        else {
          obj[item.name] = item.value;
        }
      });
      return obj;
    },

    destroy: function (module) {
      module.$element.off(module.settings.event, moduleObj.listen.sendForm);
    }
  });

})(jQuery);
(function () {
	"use strict";

	var moduleObj = moduler('ga4', {
		defaults: {
			serviceUrl: '/misc/ga4'
		},
		localDataLayer:[],
		init: function (module) {
			$('.js-ga4-triggeronload').each(function (index, value) {
				let dataObject = moduleObj.extractDataObject(value);
				if (dataObject != null) {
					moduleObj.push(dataObject);
				}
			});

			$(document).on('click', '.js-ga4-click', function () {
				let id = $(this).data('ga4-click-id');
				moduleObj.loadDataItem(module, id);
			});

			$(document).bind('ajaxComplete', function (event, xhr, settings) {
				if (xhr.responseJSON != null) {
					if (xhr.responseJSON.hasOwnProperty('ga4string')) {
						if (xhr.responseJSON.ga4string != '') {
							let ga4Items = JSON.parse(xhr.responseJSON.ga4string);
							if (!Array.isArray(ga4Items)) {
								ga4Items = [ga4Items];
							}
							$(ga4Items).each(function (index, value) {
								moduleObj.push(value);
							});
						}
					} else if (xhr.responseJSON.hasOwnProperty('ga4')) {
						let ga4Data = xhr.responseJSON.ga4;
						if (!Array.isArray(ga4Data)) {
							ga4Data = [ga4Data];
						}
						$(ga4Data).each(function (index, value) {
							let dataItem = value;
							if (dataItem.hasOwnProperty('event') || dataItem.hasOwnProperty('Event')) {
								let event = dataItem.hasOwnProperty('event') ? dataItem.event : dataItem.Event;
								if (dataItem.hasOwnProperty('parameters') || dataItem.hasOwnProperty('Parameters')) {
									let parameters = dataItem.hasOwnProperty('parameters') ? dataItem.parameters : dataItem.Parameters;
									$(document).trigger(electrolux.events.ga4DataPush, [event, parameters]);
								} else {
									$(document).trigger(electrolux.events.ga4DataPush, dataItem.event);
								}
							}
						});
					}
				}
				moduleObj.loadDataItems();
			});

			$(document).on(electrolux.events.ga4DataPush, function (e, event, parameters) {
				if (event != null) {
					let dataObject = { ...{ event: event }, ...parameters };
					moduleObj.push(dataObject);
				}
			});

			$(document).on('click', 'a[href^="mailto:"], a[href^="tel:"]', function (e) {
				let event = 'contact_click';
				let parts = $(this).attr('href').split(':');
				if (parts.length == 2) {
					moduleObj.push({
						event: event,
						parameter1: parts[1]
					});
				}
			});

			moduleObj.loadDataItems(module);
			moduleObj.loadGA4EventsFromServer(module);

			$(document).on(electrolux.events.cookieConcentChanged, function () {
				if (electrolux.utils.checkConcentStatistics()) {
					$(moduleObj.localDataLayer).each(function (index, value) {
						moduleObj.push(value);
					});
					moduleObj.localDataLayer = [];
				}
			});
		},

		loadGA4EventsFromServer: function (module) {
			$.ajax({
				url: module.settings.serviceUrl,
				method: 'GET',
				cache: false
			}).done(function (data) {

			});
		},

		loadDataItems: function (module) {
			$('.js-ga4-data-item').each(function (index, value) {
				if ($(value).data('loaded') != true) {
					let dataItem = JSON.parse($(value).text());
					moduleObj.push(dataItem);
					$(value).data('loaded', true);
				}
			});
		},

		loadDataItem: function (module, id) {
			let $element = $('.js-ga4-click-data-item[data-id=' + id + ']');
			if ($element != null && $element.length > 0) {
				if ($element.data('loaded') != true) {
					let dataItem = JSON.parse($element.text());
					moduleObj.push(dataItem);
					$element.data('loaded', true);
				}
			}
		},

		extractDataObject: function (element) {
			let $element = $(element);
			if ($element != null) {
				let event = $element.data('ga4-event');
				if (event != null) {
					let dataObject = { event: event };

					dataObject.parameter1 = $element.data('ga4-parameter1');
					dataObject.parameter2 = $element.data('ga4-parameter2');
					dataObject.parameter3 = $element.data('ga4-parameter3');
					dataObject.parameter4 = $element.data('ga4-parameter4');

					return dataObject;
				}
			}
			return null;
		},

		push: function (data) {
			if (data != null && typeof data != "undefined") {
				let dataObject = electrolux.utils.removeEmptyFields(data);
				if (electrolux.utils.checkConcentStatistics()) {
					//console.debug('GA4 push', dataObject);
					//dataLayer.push({ ecommerce: null });
					dataLayer.push(dataObject);
				} else {
					moduleObj.localDataLayer.push(dataObject);
				}
			}
		}
	});
})();
(function () {
	"use strict";
	var moduleObj = moduler('gallery-video', {
		defaults: {},
		init: function (module) {
			let $videoPlayer = $('video', module.$element);
			let $playButton = $('.js-play-pause', module.$element);
			$videoPlayer.get(0).onplay = function (e) {
				$playButton.fadeOut();
			};
			$videoPlayer.get(0).onpause = function (e) {
				$playButton.fadeIn();
			};
			$(module.$element).click(function (e) {
				if ($videoPlayer.get(0).paused) {
					$videoPlayer.get(0).play();
				} else {
					$videoPlayer.get(0).pause();
				}
			});
		},
	});
})();
(function () {
	"use strict";

	var moduleObj = moduler('geolocation', {
		defaults: {
			serviceUrl: '/api/favoritestore/SetLocation'
		},
		init: function (module) {
			if (document.cookie.indexOf('_jsla=true') != -1 || document.cookie.indexOf('favoriteStore=') != -1) {
				return;
			}
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(function (position) {
					$.ajax({
						url: module.settings.serviceUrl,
						type: 'POST',
						data: { longitude: position.coords.longitude, latitude: position.coords.latitude, accuracy: position.coords.accuracy }
					}).done(function (response) {
						if (electrolux.utils.checkConcentStrictlyNecessary()) {
							var cookie = [
								'_jsla=true',
								'path=/',
								(location.protocol == 'https:') ? 'secure' : '',
							];
							document.cookie = cookie.join(';');
						}
						if (response.updated) {
							window.location.href = window.location.href;
						}
					});
				}, function () {
					if (electrolux.utils.checkConcentStrictlyNecessary()) {
						var cookie = [
							'_jsla=true',
							'path=/',
							(location.protocol == 'https:') ? 'secure' : '',
						];
						document.cookie = cookie.join(';');
					}
				});
			}
		},

		destroy: function (module) { }
	});
})();
(function () {
	"use strict";
	var moduleObj = moduler('glossary', {
		defaults: {
			baseUrl: null,
		},
		wordList: [],
		init: function (module) {
			$(document).on(electrolux.events.productListUpdated, function (e) {
				moduleObj.markWords(module);
			});
			moduleObj.markWords(module);
			$('body').on('click', '.js-glossary-word', function (e) {
				e.preventDefault();
				var term = $(this).data('term');
				var word = moduleObj.wordList[term.toLowerCase()];
				if (word != null) {
					$(document).trigger(electrolux.events.dialogShowMessage, [word.Word, word.Definition + '<br /><br /><a class="js-more-words" href="' + module.settings.baseUrl + '" target="_blank">Se fler ord under lexikon</a>']);
				}
			});
		},
		markWords: function (module) {
			$.ajax({
				url: module.settings.baseUrl + 'GetWords',
				method: 'GET',
				dataType: 'json'
			}).done(function (data) {
				var words = [];
				moduleObj.wordList = data;
				var text = $('.Page-container').not('.u-printHide, .js-no-glossary').text().toLowerCase();
				$.each(data, function (index, value) {
					if (text.indexOf(value.Word.toLowerCase()) > -1) {
						words.push(value.Word);
					}
				});
				$('.Page-container').not('.u-printHide, .js-no-glossary').mark(words, {
					'accuracy': {
						'value': 'exactly',
						'limiters': [',', '.', '?', ':'],
					},
					'separateWordSearch': false,
					'className': 'glossary-word js-glossary-word',
					'filter': function (node, term, totalCounter, counter) {
						var $this = $(node);
						if ($this.closest('.js-no-glossary, .u-printHide').length == 0) {
							return true;
						}
						return false;
					}
				});
			});
		},
		destroy: function (module) { }
	});
})();
(function () {
	"use strict";

	var moduleObj = moduler('group-switching', {
		defaults: {
			serviceUrl: '/GroupSwitching',
			headerSelector: '.js-groupswitching-header'
		},
		init: function (module) {
			$.ajax({
				url: module.settings.serviceUrl,
				method: 'GET',
				cache: false
			}).done(function (data) {
				$(module.$element).prepend(data);
				var selectedValue = $('#groupSwitchingList', module.$element).val();
				if (selectedValue != null && selectedValue != '') {
					var selectedText = $('#groupSwitchingList option:selected', module.$element).text();
					$(module.settings.headerSelector).prepend('<div class="groupSwitchWarning"><span>Kundgruppsvy: ' + selectedText + '</span></div>');
				}
				$('#groupSwitchingList', module.$element).change(function (e) {
					$.ajax({
						url: module.settings.serviceUrl,
						method: 'POST',
						data: { priceGroup: $(this).val() },
						dataType: 'json'
					}).done(function (data) {
						window.location.href = '/';
					});
				});
			});
		},

		destroy: function (module) { }
	});
})();
(function () {
	"use strict";

	var moduleObj = moduler('heart-toggler', {
		defaults: {
			emptyCssClass: 'Icon--wish-empty',
			activeCssClass: 'Icon--wish-active',
			imageContentId: null,
			targetContentId: null,
			productCode: null
		},

		init: function (module) {
			module.$element.on('click', module, moduleObj.listen.toggle);
		},

		listen: {
			toggle: mo.event(function (module, e) {
				e.preventDefault();
				var $this = $(this);

				var data = {
					FavoriteItemId: module.$element.data('favorite-item-id'),
					ImageContentId: module.settings.imageContentId,
					TargetContentId: module.settings.targetContentId,
					ProductCode: module.settings.productCode
				};

				if ($this.hasClass(module.settings.emptyCssClass)) {
					$(document).trigger(electrolux.events.addToHeart, data);
					$this.removeClass(module.settings.emptyCssClass).addClass(module.settings.activeCssClass);
				} else if ($this.hasClass(module.settings.activeCssClass)) {
					$(document).trigger(electrolux.events.removeFromHeart, data);
					$this.removeClass(module.settings.activeCssClass).addClass(module.settings.emptyCssClass);
				}
			})
		},
		destroy: function (module) { }
	});
})();
(function () {
	"use strict";
	var moduleObj = moduler('heatpump', {
		defaults: {
			inputSelector: '.js-heatpump-input',
			buttonSelector: '.js-heatpump-submit',
			selectorSuccess: '.js-heatpump-success',
			selectorFailure: '.js-heatpump-failure',
			serviceUrl: null
		},
		init: function (module) {
			$(module.settings.buttonSelector).click(function (e) {
				e.preventDefault();
				var inputValue = $(module.settings.inputSelector).val();
				$.get(module.settings.serviceUrl, { postalcode: inputValue })
					.done(function (data) {
						if (data.IsValid) {
							$(module.settings.selectorFailure).hide();
							$(module.settings.selectorSuccess).show();
						} else {
							$(module.settings.selectorSuccess).hide();
							$(module.settings.selectorFailure).show();
						}
					});
			});
		},
		destroy: function (module) { }
	});
})();
(function () {
    "use strict";

    var moduleObj = moduler('kitchen-breadcrumb', {
        defaults: {
            transparentClass: 'Breadcrumb-transparent',
        },
        
        init: function (module) {
            module.$element.addClass(module.settings.transparentClass);
        },
        
        listen: { },
        
        destroy: function (module) { }
    });
    
})();
(function () {
	"use strict";

	var moduleObj = moduler('kitchen-header', {
		defaults: {
			transparentClass: 'Sticky-transparent-header',
			zeorHeightClass: 'Sticky-zeroHeight-header',
			scrollTopThreshold: 5,
		},

		init: function (module) {
			module.$element.addClass(module.settings.transparentClass);
			module.$element.addClass(module.settings.zeorHeightClass);
			moduleObj.initEvents(module);
		},

		initEvents: function (module) {
			module.$element.on('mouseover', function (e) {
				module.$element.removeClass(module.settings.transparentClass);
			});
			module.$element.on('mouseout', function (e) {
				var y = $(document).scrollTop();

				if (y < module.settings.scrollTopThreshold) {
					module.$element.addClass(module.settings.transparentClass);
				}

			});

			$(document).scroll(function () {
				var y = $(this).scrollTop();
				if (y > module.settings.scrollTopThreshold) {
					module.$element.removeClass(module.settings.transparentClass);
				} else {
					module.$element.addClass(module.settings.transparentClass);
				}
			});
		},

		listen: {},

		destroy: function (module) { }
	});

})();
(function () {
    "use strict";

    var moduleObj = moduler('lazy', {
        defaults: {},
        
        init: function (module) {
            module.$lazyElements = moduleObj.getLazyElements(module);

            moduleObj.listenOnScroll(module, function () {
                moduleObj.checkElements(module);
            });

            $(document).on('domChanged', function () {
                module.$lazyElements = moduleObj.getLazyElements(module);
                moduleObj.checkElements(module);
            });
        },

        checkElements: function (module) {
            if (module.$lazyElements.length === 0) {
                return;
            }
            
            var $window = $(window),
                windowHeight = $window.height(),
                windowWidth = $window.width();

            module.$lazyElements.each(function (i, element) {
                var $element = $(element);
                if (!$element.is(':visible')) {
                    return;
                }

                if (moduleObj.isElementInViewport(element, windowHeight, windowWidth)) {
                    $element.trigger('lazy').prop('_mo-lazy-loaded', true);
                }
            });

            // update list of elements that needs to be initialized.
            module.$lazyElements = moduleObj.getLazyElements(module);
        },

        getLazyElements: function (module) {
            var $elements = $('[data-module*=":lazy"]', module.element).filter(function (i, element) {
                return !moduleObj.isElementLoaded(element);
            });
            return $elements;
        },

        isElementInViewport: function (element, windowHeight, windowWidth) {
            var rect = element.getBoundingClientRect();

            // returns true if any part of the element is visible within the viewport.
            return (
                rect.right >= 0 &&
                rect.left <= windowWidth &&
                rect.bottom >= 0 &&
                rect.top <= windowHeight
            );
        },
        
        isElementLoaded: function (element) {
            return $(element).prop('_mo-lazy-loaded');
        },

        listenOnScroll: function (module, callback) {
            $(window).on('scroll.lazy', function () {
                module.hasScrolled = true;
            }).trigger('scroll.lazy');

            module.checkTimer = setInterval(function () {
                if (module.hasScrolled) {
                    module.hasScrolled = false;
                    callback();
                }
            }, 100);
        },

        destroy: function (module) { 
            $(window).off('scroll.lazy');
            clearInterval(module.checkTimer);
        }
    });
    
})();
(function () {
	"use strict";
	var moduleObj = moduler('lazyload-image', {
		defaults: {
			selector: 'img.lazy'
		},

		init: function (module) {
			$(document).on(electrolux.events.lazyLoadImages, function () {
				moduleObj.loadImages(module);
			});
			moduleObj.loadImages(module);
		},

		loadImages: function(module){
			if (typeof $(module.settings.selector).lazyload == 'function') {
				$(module.settings.selector).removeClass('u-hidden');
				$(module.settings.selector).lazyload();
			}
		},

		destroy: function (module) { }
	});
})();
(function () {
	"use strict";

	/*
			Example HTML:

			<div class="products">
					<!-- list products for page one. -->
			</div>

			<p>
					<a href="?page=2" data-module="load-more" data-load-more="url: '/api/products', contentElement: '.products'">Load results {from}-{to}</a>
			</p>
	*/

	var moduleObj = moduler('load-more', {
		defaults: {
			url: null,
			event: 'click',
			data: null, /* extra data to send along the request to server */
			contentElement: null, /* selector for element where content should be appended or replaced */
			page: 1, /* the page currently on */
			insertMode: 'append', /* append|replace */
			loadingCssClass: 'loading',
			pageSize: null, // size of each page, used when displaying page range in button. ("Results from 11-20")
			dataType: 'html'
		},

		init: function (module) {
			if (!module.settings.url) {
				if (module.$element.is('a[href]')) {
					module.settings.url = module.$element.attr('href');
				} else {
					module.settings.url = window.location.href;
				}
			}

			$(document).on(electrolux.events.filterUpdated, function () {
				module.settings.url = window.location.href;
			});

			// save a reference to contentElement
			module.$contentElement = module.settings.contentElement !== null ? $(module.settings.contentElement) : module.$element;

			module.$element.on(module.settings.event, module, moduleObj.listen.loadMore);

			var linkHtml = module.$element.html();
			var shouldDisplayPageRange = linkHtml.indexOf('{from}') != -1;

			if (shouldDisplayPageRange) {
				module.shouldDisplayPageRange = true;
				module.linkHtml = linkHtml;

				moduleObj.updateLinkText(module);
			}
			module.$element.on('load-more-set-page', module, function (e, data) {
				module.settings.page = data.page;
			});
		},

		loadPage: function (module) {
			module.$element.addClass(module.settings.loadingCssClass);
			module.isLoading = true;

			$.ajax({
				type: 'GET',
				url: module.settings.url.replace('{page}', module.settings.page),
				data: $.extend({
					partial: true,
					page: module.settings.page
				}, module.settings.data)
			})
			.always(function () {
				module.$element.removeClass(module.settings.loadingCssClass);
				module.isLoading = false;
			})
			.done(function (response, status, xhr) {
				if (module.settings.insertMode == 'replace') {
					if (module.settings.dataType == 'json') {
						module.$contentElement.html(response.html);
					} else {
						module.$contentElement.html(response);
					}
				} else if (module.settings.insertMode == 'append') {
					if (module.settings.dataType == 'json') {
						module.$contentElement.append(response.html);
					} else {
						module.$contentElement.append(response);
					}
				}
				if (xhr.getResponseHeader('X-LastPage')) {
					// hide the load more button instead of removing it so that 
					// other modules can still trigger events
					module.$element.hide();
				}

				if (module.shouldDisplayPageRange) {
					moduleObj.updateLinkText(module);
				}

				module.$element.trigger('load-more-done', { response: response, page: module.settings.page });
			})
			.error(function () {
				module.$element.trigger('load-more-error');
			});
		},

		updateLinkText: function (module) {
			var from = (module.settings.page * module.settings.pageSize);
			var newLinkText = module.linkHtml
					.replace('{from}', from + 1)
					.replace('{to}', from + module.settings.pageSize);

			module.$element.html(newLinkText);
		},

		listen: {
			loadFirstPage: mo.event(function (module) {
				module.settings.page = 1;

				module.$element.show();
				module.$contentElement.empty();

				moduleObj.loadPage(module);
			}),

			loadMore: mo.event(function (module, e) {
				e.preventDefault();

				// prevent additional requests when user spam-clicks
				if (module.isLoading) {
					return;
				}

				// increase page by one
				module.settings.page += 1;
				moduleObj.loadPage(module);
			})
		},

		destroy: function (module) {
			module.$element.off(module.settings.event, moduleObj.listen.loadMore);
		}
	});

})();
(function () {
    "use strict";

    var moduleObj = moduler('loader', {
        defaults: {
            url: '',
            contentElement: null,
            event: 'click',
            once: true,
            responseModule: null,
            loadOnInit: false,
            loadingCssClass: 'loading',
            insertMode: 'replace', /* replace|append */
        },
        
        init: function (module) {
            var settings = module.settings;
            
            module.$contentElement = moduleObj.getContentElement(module);

            if (settings.event) {
                module.$element.on(settings.event + '.loader', module, moduleObj.listen.sendRequest);
            }

            if (settings.loadOnInit) {
                moduleObj.listen.sendRequest(module);
            }
        },

        updateElementContent: function (html, module) {
            if (module.settings.insertMode == 'replace') {
                module.$contentElement.html(html);
            } else if (module.settings.insertMode == 'append') {
                module.$contentElement.append(html);
            }
        },

        getContentElement: function (module) {
            return module.settings.contentElement !== null ? 
                $(module.settings.contentElement) : 
                module.$element;
        },
        
        listen: {
            sendRequest: mo.event(function(module) {
                // refresh reference to contentElement
                module.$contentElement = moduleObj.getContentElement(module);
                 
                var settings = module.settings,
                    element = module.$element,
                    $contentElement = module.$contentElement;

                if (settings.once && module.isLoaded)
                    return;

                element.addClass(settings.loadingCssClass);

                $.ajax({
                    url: settings.url
                }).always(function () {
                    element.removeClass(settings.loadingCssClass);
                    
                    // trigger the module prefixed event that other modules can use it.
                    element.trigger('loader-' + settings.event);
                }).done(function (response, status, xhr) {
                    if (module.settings.responseModule) {
                        mo.utils.removeModuleFromElement($contentElement, module.settings.responseModule);
                        mo.utils.addModuleToElement($contentElement, module.settings.responseModule, { response: response });
                    } else if (xhr.getResponseHeader('content-type').indexOf('text/html') !== -1) {
                        moduleObj.updateElementContent(response, module);
                    }

                    module.isLoaded = true;
                    element.trigger('loader-done', { response: response });
                }).error(function(response) {
                    if (!module.settings.responseModule) {
                        moduleObj.updateElementContent(response, module);
                    }

                    element.trigger('loader-error', { response: response });
                });

                if (settings.once && settings.event) {
                    $(this).off(settings.event + '.loader').on(settings.event + '.loader', function () {
                        element.trigger('loader.' + settings.event);
                    });
                }
            })
        }
    });
})();
(function () {
  "use strict";

  var moduleObj = moduler('main-menu', {
    defaults: {},
    init: function (module) {
			var timeoutId = null;
			var searchClicked = false;
      $('.js-menu-top-item').mouseenter(function () {
        var self = this;
        timeoutId = window.setTimeout(function () {
          $(self).addClass('is-active');
          timeoutId = null;
        }, 200);
      });
      $('.js-menu-top-item').mouseleave(function () {
        if (timeoutId != null) {
          window.clearTimeout(timeoutId);
          timeoutId = null;
				}
        $(this).removeClass('is-active');
			});

			$('.js-main-menu-search-button').click(function (e) {
				var currentVisibility = $('.js-showSearch').css('visibility');
				if (currentVisibility === 'hidden' || !searchClicked) {
					$('.js-showSearch').css('visibility', 'visible');
					$('#search-container').addClass('Search-visible');
					$('.Search-input')[0].focus();
					searchClicked = true;
				} else {
					$('.js-showSearch').css('visibility', 'hidden');
					$('#search-container').removeClass('Search-visible');
				}
			});
    },
  });
})();
(function () {
	"use strict";

	var moduleObj = moduler('map', {
		defaults: {
			apiKey: '', // optional
			apiScriptUrl: 'https://maps.googleapis.com/maps/api/js?key=&sensor=false&callback={callback}',
			markerClustererUrl: '../vendor/markerclusterer-2.1.2.js',
			data: null, // object or array of location:{ address, lat, lng }
			dataUrl: null, // url to json endpoint returning array of location:{ address, lat, lng }
			showMarkers: true,
			showInfoWindow: false,
			useMarkerClusterer: false,
			center: null, // point of center for map, { address, lat, lng }, (optional)
			zoom: 12,
			maxZoom: null, // can be used when displaying multiple markers (optional)
			infoWindowTemplate: '<div><h4><a href="{url}">{title}</a></h4><p>{description}</p></div>',
			map: null,
			styles: {
				pinImage: null,
				mapStyle: null, // paste in map style code, e.g. http://snazzymaps.com/style/150/old-school-maps-posters

				// docs: http://google-maps-utility-library-v3.googlecode.com/svn/tags/markerclustererplus/2.1.2/docs/reference.html
				clusterStyles: [{
					url: 'http://localhost:50188/../../Images/Icons/5_years_warranty.png',
					height: 52,
					width: 52,
					textColor: '#fff'
				}]
			}
		},

		DataType: {
			multiple: 'multiple',
			single: 'single',
			service: 'service'
		},

		init: function (module) {
			var apiScriptPromise = mo.utils.loadScript(module.settings.apiScriptUrl, function () {
				return ('google' in window && 'maps' in google);
			}),
					markerClustererPromise = module.settings.useMarkerClusterer ? mo.utils.loadScript(module.settings.markerClustererUrl, function () {
						return ('MarkerClusterer' in window);
					}) : {};

			// markerClusterer will only be loaded when useMarkerClusterer is set to true.
			$.when(apiScriptPromise, markerClustererPromise).done(function () {
				moduleObj.mapsReady(module);
			});

			$(document).on(electrolux.events.refreshMap, function (e) {
				var center = moduleObj.map.getCenter();
				google.maps.event.trigger(moduleObj.map, 'resize');
				moduleObj.map.setCenter(center);
			});
		},

		mapsReady: function (module) {
			module.dataType = moduleObj.getDataType(module);

			if (module.dataType === moduleObj.DataType.single) {
				var positions = [module.settings.data];
				moduleObj.displayPositions(module, positions);
			}
			else if (module.dataType === moduleObj.DataType.multiple) {
				moduleObj.displayPositions(module, module.settings.data);
			}
			else if (module.dataType === moduleObj.DataType.service) {
				$.getJSON(module.settings.dataUrl).done(function (response) {
					moduleObj.displayPositions(module, response);
				});
			}
		},

		displayPositions: function (module, data) {
			var deferres = [];

			for (var i in data) {
				var item = data[i];
				deferres.push(moduleObj.getPosition(item));
			}

			$.when.apply($, deferres).done(function () {
				var positions = $.makeArray(arguments);
				var isSinglePosition = positions.length == 1;

				var mapOptions = {
					zoom: module.settings.zoom,
					maxZoom: module.settings.maxZoom,
					styles: module.settings.styles.mapStyle
				};

				if (isSinglePosition && !module.settings.center) {
					mapOptions.center = positions[0];
				}

				moduleObj.map = new google.maps.Map(module.element, mapOptions);
				var bounds = new google.maps.LatLngBounds();
				var infoWindow = new google.maps.InfoWindow();
				var markers = []; // array is only needed when using markerClusterer

				for (var i in positions) {
					var position = positions[i];

					bounds.extend(position);

					if (module.settings.showMarkers) {
						var marker = moduleObj.addMarkerAndOverlayToMap(module, position, infoWindow, moduleObj.map);
						markers.push(marker);
					}
				}

				if (module.settings.useMarkerClusterer) {
					var clusterOptions = {
						styles: module.settings.styles.clusterStyles
					};
					var markerCluster = new MarkerClusterer(moduleObj.map, markers, clusterOptions);
				}

				if (module.settings.center) {
					moduleObj.getPosition(module.settings.center).done(function (position) {
						moduleObj.map.setCenter(position);
					});
				} else if (!isSinglePosition) {
					moduleObj.map.fitBounds(bounds);
				}
			});
		},

		addMarkerAndOverlayToMap: function (module, position, infoWindow, map) {
			var marker = new google.maps.Marker({
				position: position,
				title: position.title,
				map: map,
				clickable: module.settings.showInfoWindow,
				icon: module.settings.styles.pinImage
			});

			if (module.settings.showInfoWindow) {
				google.maps.event.addListener(marker, 'click', function () {
					infoWindow.setContent(moduleObj.transformTemplate(module.settings.infoWindowTemplate, position));
					infoWindow.open(map, marker);
					$(document).trigger('map-marker-selected', position);
				});
			}

			return marker;
		},

		getPosition: function (location) {
			var dfd = $.Deferred();

			if (location.lat && location.lng) {
				var position = new google.maps.LatLng(location.lat, location.lng);
				dfd.resolve(moduleObj.extendPositionWithData(position, location));
			}
			else if (location.address) {
				var geocoder = new google.maps.Geocoder();
				var requestInfo = {
					address: decodeURIComponent(location.address)
				};

				geocoder.geocode(requestInfo, function (results, status) {
					if (status == google.maps.GeocoderStatus.OK) {
						var position = results[0].geometry.location;

						if (position) {
							dfd.resolve(moduleObj.extendPositionWithData(position, location));
							return dfd;
						}
					}

					console.warn('geocoder lookup failed', status, location.address);
					dfd.reject({ error: status, address: location.address });
				});
			}

			return dfd.promise();
		},

		extendPositionWithData: function (position, locationInfo) {
			locationInfo.lat = undefined;
			locationInfo.lng = undefined;

			return $.extend(position, locationInfo);
		},

		getDataType: function (module) {
			var dataType = module.settings.data && $.isArray(module.settings.data) ?
													moduleObj.DataType.multiple : moduleObj.DataType.single;

			if (module.settings.dataUrl) {
				dataType = moduleObj.DataType.service;
			}

			return dataType;
		},

		transformTemplate: function (template, data) {
			var result = template;
			for (var key in data) {
				result = result.replace('{' + key + '}', decodeURIComponent(data[key]));
			}
			return result;
		}
	});
})();
(function ($) {
	"use strict";

	var moduleObj = moduler('menu', {
		defaults: {
			event: 'click',
			contentElement: null,
			cssClass: 'is-active',
			preventDefault: true,
			addClassToSelf: true,
			once: false,
			closeOthers: true,
			blurClose: true,
			documentSelector: '.Page'
		},

		init: function (module) {
			module.$element.on(module.settings.event, module, moduleObj.listen.toggleVisibility);
			module.$contentElement = $(module.settings.contentElement ? module.settings.contentElement : module.element);

			if (module.settings.blurClose) {
				//module.$contentElement.on('click', function (e) {
					// changes to make filter work /Viktor 2016-08-01
					//e.stopPropagation();
				//});
				$(module.settings.documentSelector).on('click', function (e) {
					if ($(module.$contentElement).has(e.target).length == 0) {
						moduleObj.listen.hide(module);
					}
				});
			}
		},

		listen: {
			show: mo.event(function (module) {
				if (!module.$contentElement.hasClass(module.settings.cssClass)) {
					if (module.settings.addClassToSelf) {
						module.$element.removeClass(module.settings.cssClass);
					}
					module.$contentElement.addClass(module.settings.cssClass);
					module.$contentElement.trigger('menu-shown');
				}

				if (module.settings.focusElementOnShow != null) {
				    $(module.settings.focusElementOnShow).focus();
				}

			}),

			hide: mo.event(function (module) {
				if (module.$contentElement.hasClass(module.settings.cssClass)) {
					if (module.settings.addClassToSelf) {
						module.$element.removeClass(module.settings.cssClass);
					}	
					module.$contentElement.removeClass(module.settings.cssClass);
					module.$contentElement.trigger('menu-hidden');
				}
			}),

			toggleVisibility: mo.event(function (module, e) {
				if (module.settings.preventDefault) {
					e.preventDefault();
				}

				e.stopPropagation();

				if (module.settings.once && module.toggled) {
					return;
				} else if (module.settings.once) {
					module.toggled = true;
				}

				if (module.settings.closeOthers) {
					$('[data-module*="menu"]').not(module.element).trigger('hide');
				}

				if (module.settings.addClassToSelf) {
					module.$element.toggleClass(module.settings.cssClass);
				}

				module.$contentElement.toggleClass(module.settings.cssClass);
				module.$contentElement.trigger('menu-toggled');
				if (module.settings.focusElement != null) {
				    $(module.settings.focusElement).focus();
				}
			})
		}
	});
})(jQuery);
//(function () {
//    "use strict";
//    var moduleObj = moduler('mobile-menu-btn', {
//        defaults: {},
        
//        init: function (module) {
//        	module.$element.on('click', function (e) {
//        	    e.preventDefault();
//        	    if ($("html").hasClass("no-scroll")) {
//        	        $('.Sticky-element').trigger('enable')
//        	    }
//        		$('.Sticky-element').trigger('disable')
//        		$('.StickyWrapper').toggleClass('is-active')
//        		$('.js-showMenu').toggleClass('is-active')
//        		$('html').toggleClass('no-scroll')
//        		$('.c-hamburger').toggleClass('is-active')
//        	});
//        } 
//    });
//})();
//(function () {
//	"use strict";

//	var moduleObj = moduler('mobile-menu', {
//		defaults: {
//			slideDelay: 100,
//			fullCollapseOnClose: true,
//			toggler: '.js-iconToggler',
//			menuContainerSelector: 'li ul:not(.is-active)',
//			subMenuSiblingSelector: '.js-subMenu',
//			togglerActiveClass: 'is-active'
//		},

//		init: function (module) {
//			var $container = module.settings.menuContainerSelector;
//			var $subMenuSelector = module.settings.subMenuSiblingSelector;
//			var $slideDelay = module.settings.slideDelay;

//			$($container, module.$element).slideToggle();            
//			$(module.settings.toggler, module.$element).click(function () {
//				var $parentThis = $(this);
//				$(this).toggleClass(module.settings.togglerActiveClass);
//				$(this).next($subMenuSelector).slideToggle($slideDelay);
//				$($subMenuSelector, $(this).next($subMenuSelector)).hide($slideDelay);
//				$(module.settings.toggler, $(this).next($subMenuSelector)).removeClass(module.settings.togglerActiveClass);
//			});
//		},

//		listen: {},

//		destroy: function (module) {
//		}
//	});
//})();
//(function () {
//    "use strict";
//    var moduleObj = moduler('mobile-search-btn', {
//        defaults: {},
        
//        init: function (module) {
//        	module.$element.on('click', function (e) {
//        	    e.preventDefault();
//                if ($(".HeaderSecondary--mobile").hasClass("is-active")) {
//                    $(".HeaderSecondary--mobile").removeClass('is-active')
//                    $(".c-hamburger").removeClass('is-active')
//                    $('html').removeClass('no-scroll')
//                    $('.StickyWrapper').removeClass('is-active')
//                }               
//        	});
//        } 
//    });
//})();
(function () {
	"use strict";

	var moduleObj = moduler('modal-message', {
		defaults: {
			event: 'click',
			url: null,
			preventDefault: false,
			showOnLoad: false,
			showOnLoadHash: null,
			modalMessageSelector: '.js-soonInStockModalMessage'
		},
		storeId: null,
		init: function (module) {
			module.$element.on(module.settings.event, module.settings.$element, module, moduleObj.listen.showModal);
			if (module.settings.showOnLoad && '#' + module.settings.showOnLoadHash == location.hash) {
				$(this).trigger(module.settings.event);
			}
		},

		listen: {
			showModal: mo.event(function (module, e) {
				if (module.settings.preventDefault) {
					e.preventDefault();
				}
				if (module.settings.url == null) {
					$(document).trigger(electrolux.events.dialogShowMessage, [null, module.settings.modalMessageSelector]);
				} else {
					$(document).trigger(electrolux.events.dialogShowAjax, [null, module.settings.url, "dynamic"]);
				}
			}),
		},
	});
})();
(function () {
	"use strict";

	var moduleObj = moduler('modal', {
		defaults: {
			event: 'click', // the event to open the modal on
			contentElement: null, // selector for the  Modal component
			replaceHtmlAfterClose: true, // if true will restore the html to the initial state
			activeCssClass: 'is-active',
			closeOnOverlayClick: true,
			lockBody: false
		},

		init: function (module) {
			module.$contentElement = $(module.settings.contentElement);
			module.contentElementHtml = module.$contentElement.html();

			moduleObj.initEvents(module);

			$(document).keydown(function (event) {
				if (event.keyCode == 27) {
					moduleObj.closeDialog(module);
				}
			});
		},

		initEvents: function (module) {
			// opening the modal
			module.$element.on(module.settings.event, function (e) {
				e.preventDefault();
				// move modal element to body to avoid z-index issues.
				if (!module.$contentElement.parent().is('body')) {
					module.$contentElement.detach().appendTo('body');
				}

				module.$contentElement.addClass(module.settings.activeCssClass);
				module.$contentElement.add(module.$element).trigger('modal-open');

				if (module.settings.lockBody) {
					$('body').css('overflow', 'hidden');
				}
			});

			module.$element.on('closeDialog', function () {
				moduleObj.closeDialog(module);
			});

			// closing window by clicking close link
			module.$contentElement.on('click', '.js-close', function (e) {
				e.preventDefault();
				moduleObj.closeDialog(module);
			});

			// closing window by clicking overlay
			module.$contentElement.on('click', function (e) {
				if (!$(e.target).is('.Modal') || !module.settings.closeOnOverlayClick)
					return;

				e.preventDefault();
				moduleObj.closeDialog(module);
			});
		},

		closeDialog: function (module) {
			module.$contentElement.removeClass(module.settings.activeCssClass);

			if (module.settings.lockBody) {
				$('body').css('overflow', '');
			}

			if (module.settings.replaceHtmlAfterClose) {
				module.$contentElement.html(module.contentElementHtml);

				if ('validator' in $ && 'unobtrusive' in $.validator) {
					$.validator.unobtrusive.parse(module.settings.contentElement);
				}
			}

			module.$contentElement.add(module.$element).trigger('modal-close');
		}
	});
})();
(function () {
	"use strict";

	var moduleObj = moduler('newsletter', {
		defaults: {
			addSubscriberButtonSelector: '.js-addSubscriber',
			emailAddressTextboxSelector: '.js-emailAddress',
			signupViewSelector: '.js-signupView',
			successViewSelector: '.js-successView',
			serviceUrl: '/api/Newsletter',
			checkboxselector: '.js-newslettercheckbox',
			mustCheckCheckboxSelector: '.js-mustCheckCheckbox',
			neverShowAgainSelector: '.js-newsletter-never-show-again',
			popupTriggerTimeSeconds: 0,
			isPopup: false
		},

		init: function (module) {
			var self = this;
			module.$element.on('click', module.settings.addSubscriberButtonSelector, module, moduleObj.listen.addSubscriber);

			if (moduleObj.isPopupActive(module)) {
				module.$element.on('click', module.settings.neverShowAgainSelector, function (e) {
					e.preventDefault();
					if (electrolux.utils.checkConcentStrictlyNecessary()) {
						var d = new Date();
						d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
						var expires = "expires=" + d.toUTCString();
						var cookie = [
							'_nlp=true',
							'path=/',
							(location.protocol == 'https:') ? 'secure' : '',
							'expires=' + expires
						];
						document.cookie = cookie.join(';');
					}
					module.$element.trigger('closeDialog');
				});
				module.$element.on('modal-close', function () {
					if (electrolux.utils.checkConcentStrictlyNecessary()) {
						var cookie = [
							'_nlps=true',
							'path=/',
							(location.protocol == 'https:') ? 'secure' : '',
						];
						document.cookie = cookie.join(';');
					}
				});
				window.setTimeout(function () {
					// Check if search is active, if it's active dont show popup
					if ($('.js-showSearch.is-active').length == 0 && $('.onetrust-pc-dark-filter.ot-fade-in:visible').length == 0) {
						moduleObj.openPopup(module);
					}
				}, (module.settings.popupTriggerTimeSeconds * 1000));
			}
		},

		isPopupActive: function (module) {
			return module.settings.isPopup && document.cookie.indexOf('_nlp=true') == -1 && document.cookie.indexOf('_nlps=true') == -1;
		},

		openPopup: function (module) {
			if (moduleObj.isPopupActive(module)) {
				$(module.$element).trigger('openModal');
			}
		},

		listen: {
			addSubscriber: mo.event(function (module, e) {
				var $checkboxselector = module.$element.find(module.settings.checkboxselector);
				if (!$($checkboxselector).is(':checked')) {
					//module.$element.find(module.settings.mustCheckCheckboxSelector).show();
					$(document).trigger(electrolux.events.dialogShowMessage,
						['Fel', 'Du måste godkänna villkoren']);
				} else {
					var data = {
						'': module.$element.find(module.settings.emailAddressTextboxSelector).val()
					}
					$.ajax({
						type: 'POST',
						url: module.settings.serviceUrl,
						data: data
					}).done(function (response) {
						$(document).trigger(electrolux.events.ga4DataPush, 'newsletter_signup');
						module.$element.find(module.settings.signupViewSelector).hide();
						module.$element.find(module.settings.successViewSelector).show();
						module.$element.find(module.settings.mustCheckCheckboxSelector).hide();
						module.$element.trigger('subscriptionRequestSent');
					}).fail(function (xhr, status, errorThrown) {
						$(document).trigger(electrolux.events.dialogShowMessage,
							['Fel', JSON.parse(xhr.responseText).Message]);
					});
				}
			})
		},

		destroy: function (module) { }
	});

})();
(function () {
    "use strict";

    var moduleObj = moduler('partpayment-information-modal', {
        defaults: {
            modalSelector: '.js-partpayment-information-modal'
        },

        init: function (module) {
            module.$element.on('click',
                function (e) {
                    e.preventDefault();
                    $(module.settings.modalSelector).trigger('openModal');
                    var heading = $(this).attr('data-partpayment-information-heading');
                    var bodyText = $(this).attr('data-partpayment-information-bodytext');
                    $('.js-partpayment-information-heading').append(heading);
                    $('.js-partpayment-information-bodytext').append(bodyText);
                });
        },

        listen: {},

        destroy: function (module) { }
    });

})();
(function () {
    "use strict";

    var moduleObj = moduler('poster', {
        defaults: {
            url: null,
            event: 'click',
            data: undefined,
            once: false,
            contentElement: null,
            responseModule: null,
            httpMethod: 'POST',
            loadingCssClass: 'loading'
        },
        
        init: function (module) {
            var bindMethod = module.settings.once ? "one" : "on";
            module.$element[bindMethod](module.settings.event, module, moduleObj.listen.fireRequest);
        },

        listen: {
            fireRequest: mo.event(function (module, e) {
                var settings = module.settings,
                    $contentElement = settings.contentElement !== null ? $(settings.contentElement) : module.$element;

                e.preventDefault();
                module.$element.addClass(settings.loadingCssClass);

                // send request
                $.ajax({
                    type: settings.httpMethod,
                    url: settings.url,
                    data: settings.data ? settings.data : {}
                }).always(function () {
                    module.$element.removeClass(settings.loadingCssClass);
                }).done(function (response, status, xhr) {
                    if (settings.responseModule) {
                        mo.utils.removeModuleFromElement($contentElement, settings.responseModule);
                        mo.utils.addModuleToElement($contentElement, settings.responseModule, { response: response });
                    } else if ($contentElement.length && xhr.getResponseHeader('content-type').indexOf('text/html') !== -1) {
                        $contentElement.html(response);
                    }

                    module.$element.trigger('poster-done', { response: response });
                }).error(function () {
                    module.$element.trigger('poster-error');
                });
    
            })
        },

        destroy: function (module) {
            module.$element.off(module.settings.event, moduleObj.listen.fireRequest);
        }
    });
    
})();
(function () {
	"use strict";

	var moduleObj = moduler('rangeSlider', {
		defaults: {
			min: 0,
			max: 100,
			start: null,
			end: null,
			selectorSufix: ''
		},
		init: function (module) {
			var sliderElement = document.getElementById('slider-' + module.settings.selectorSufix);
			var start = module.settings.start == null ? module.settings.min : module.settings.start;
			var end = module.settings.end == null ? module.settings.max : module.settings.end;
			var minInput = $('#js-filter-min-' + module.settings.selectorSufix);
			var maxInput = $('#js-filter-max-' + module.settings.selectorSufix);
			if (minInput != null && minInput.val() != '') {
				start = minInput.val();
			}
			if (maxInput != null && maxInput.val() != '') {
				end = maxInput.val();
			}
			if (sliderElement.noUiSlider == null) {
				var min = module.settings.min;
				var max = module.settings.max;
				if (min == max) {
					module.$element.data('disabled', 'true');
					noUiSlider.create(sliderElement, {
						start: [start, end],
						margin: 0,
						step: 1,
						behaviour: 'fixed',
						steps: module.settings.max - module.settings.min,
						range: {
							'min': min - 1,
							'max': max + 1
						}
					});
				} else {
					noUiSlider.create(sliderElement, {
						start: [start, end],
						margin: 0,
						step: 1,
						steps: module.settings.max - module.settings.min,
						range: {
							'min': min,
							'max': max
						}
					});
				}

				if (minInput != null && maxInput != null) {
					minInput.val(start);
					maxInput.val(end);
					sliderElement.noUiSlider.on('change', function (e) {
						minInput.val(e[0]);
						maxInput.val(e[1]);
					});
				}
			}
			var marginMin = document.getElementById('slider-margin-value-min-' + module.settings.selectorSufix);
			var marginMax = document.getElementById('slider-margin-value-max-' + module.settings.selectorSufix);

			sliderElement.noUiSlider.on('update', function (values, handle) {
				if (handle) {
					marginMax.innerHTML = values[handle];
				} else {
					marginMin.innerHTML = values[handle];
				}
			});
		},

		listen: {},

		destroy: function (module) { }
	});
})();
(function () {
	"use strict";

	var moduleObj = moduler('read-more', {
		defaults: {
			event: 'click',
			title: null,
			message: null
		},

		init: function (module) {
			$(module.$element).on(module.settings.event, function (e) {
				e.preventDefault();
				$(document).trigger(electrolux.events.dialogShowMessage, [module.settings.title, module.settings.message]);
			});
		},

		listen: {},

		destroy: function (module) { }
	});

})();
(function () {
    "use strict";

    var moduleObj = moduler('savetols', {
        defaults: {
            saveobj: null
        },

        init: function (module) { 
                if (module.settings.saveobj !== null) {
                    window.sessionStorage.setItem('scrollto', module.settings.saveobj);
                }              
        },

        listen: {},

        destroy: function (module) {
        }
    });
})();
(function () {
    "use strict";

    var moduleObj = moduler('scroll-hide', {
        defaults: {},

        init: function (module) {
            $(document).scroll(function () {
                var scroll = $(this).scrollTop();

                var scrollStop = 450;

                if (module.$element.attr('data-scroll-start')) {
                    scrollStop += parseInt(module.$element.attr('data-scroll-start'));
                }
                if (scroll > scrollStop) {
                    
                    $(".js-scrollHide").removeClass("is-active is-opend is-newItem");
                }
            }); //missing );
        },

        listen: {},

        destroy: function (module) { }
    });

})();


(function () {
    "use strict";

    var moduleObj = moduler('scroll-to', {
        defaults: {},
        
        init: function (module) {
            $(document).scroll(function () {
                var y = $(this).scrollTo();
                if (y > 1000) {
                    $('.js-scrollTo').addClass('is-active');
                } else {
                    $('.js-scrollTo').removeClass('is-active');
                }
            });

            $('.js-scrollTo').click(function () {
                $("html, body").animate({ scrollTop: 0 }, "slow");
            })
        },
        
        listen: { },
        
        destroy: function (module) { }
    });
    
})();


(function () {
    "use strict";

    var moduleObj = moduler('scroll-toggler', {
        defaults: {
            cssClass: 'fadeOut'
        },
        
        init: function (module) {

        

            module.$element.show(); //show your div initially
            var topOfOthDiv = $(".js-scroll-toggler").offset().top;
            $(window).scroll(function () {
                if ($(window).scrollTop() + $(window).height() > topOfOthDiv) { //scrolled past the other div?
                    module.$element.addClass(module.settings.cssClass); //reached the desired point -- hide div
                }

                else {
                    // Scroll Up
                    if (topOfOthDiv + $(window).height() < $(document).height()) {
                        module.$element.removeClass(module.settings.cssClass);
                    }

                    };

            });
        },
        
        listen: { },
        
        destroy: function (module) { }
    });
    
})();



(function () {
    "use strict";

    var moduleObj = moduler('scroll-top', {
        defaults: {
            target: '.js-scrollTop'
        },
        
        init: function (module) {
            $(document).scroll(function () {
                var y = $(this).scrollTop();
                if (y > 250) {
                    $('.js-show-on-scroll-item', $(this)).addClass('is-active');
                } else {
                    $('.js-show-on-scroll-item', $(this)).removeClass('is-active');
                }
            });

            $(module.settings.target, module.$element).click(function () {
                $("html, body").animate({ scrollTop: 0 }, "slow");
            })
        },
        
        listen: { },
        
        destroy: function (module) { }
    });
    
})();


(function () {
    "use strict";

    var moduleObj = moduler('scroll-indicator', {
        defaults: {},

        init: function (module) {
            // Cache selectors
            var lastId,
                topMenu = $(".js-scrollIndicator"),
                topMenuHeight = topMenu.outerHeight() + 80,
                // All list items
                menuItems = topMenu.find("a"),
                // Anchors corresponding to menu items
                scrollItems = menuItems.map(function () {
                    var item = $($(this).attr("href"));
                    if (item.length) { return item; }
                });

            // Bind click handler to menu items
            // so we can get a fancy scroll animation
            menuItems.click(function (e) {
                var href = $(this).attr("href"),
                    offsetTop = href === "#" ? 0 : $(href).offset().top - topMenuHeight + 1;
                $('html, body').stop().animate({
                    scrollTop: offsetTop
                }, 300);
                e.preventDefault();
            });

            // Bind to scroll
            $(window).scroll(function () {
                // Get container scroll position
                var fromTop = $(this).scrollTop() + topMenuHeight;

                // Get id of current scroll item
                var cur = scrollItems.map(function () {
                    if ($(this).offset().top < fromTop)
                        return this;
                });
                // Get the id of the current element
                cur = cur[cur.length - 1];
                var id = cur && cur.length ? cur[0].id : "";

                if (lastId !== id) {
                    lastId = id;
                    // Set/remove active class
                    menuItems
                      .parent().removeClass("is-active")
                      .end().filter("[href='#" + id + "']").parent().addClass("is-active");
                }
            });
        },

        listen: {},

        destroy: function (module) { }
    });

})();

//$(document).ready(function () {
   
//});

(function () {
    "use strict";
    var moduleObj = moduler('search-bar', {
        defaults: {},
        
        init: function (module) {
        	module.$element.on('click', function (e) {
        	    e.preventDefault();
        	  
        		
                $('.js-showSearch').addClass('is-active Search-show')
        		
        	});
        } 
    });
})();
(function () {
	"use strict";
	var moduleObj = moduler('search', {
		defaults: {
			searchBoxSelector: '.js-searchBox',
			serviceUrl: null,
			searchButton: null,
		},

		init: function (module) {
			if (module.settings.searchButton) {
				$(module.settings.searchButton, module.$element).click(() => {
					location.href = module.settings.serviceUrl + '?query=' + $(module.settings.searchBoxSelector, module.$element).val();
				});
			}
			module.$element.on('keyup', module.settings.searchBoxSelector, module, function (e) {
				if (e.keyCode == 13) {
					location.href = module.settings.serviceUrl + '?query=' + $(module.settings.searchBoxSelector, module.$element).val();
				}
			});
		}
	})
})();
(function () {
    "use strict";

    var moduleObj = moduler('select', {
        defaults: {},
        
        init: function (module) {
            moduleObj.initEvents(module);
            moduleObj.resizeSelect(this);
        },

        initEvents: function (module) {
            module.$element.change(function (e) {
                moduleObj.resizeSelect(e.target);
            }); 
        },
        
        resizeSelect: function (sel) {
            let tempOption = document.createElement('option');
            tempOption.textContent = sel.selectedOptions[0].textContent;

            let tempSelect = document.createElement('select');
            tempSelect.style.visibility = "hidden";
            tempSelect.style.position = "fixed"
            tempSelect.appendChild(tempOption);
            
            sel.after(tempSelect);
            sel.style.width = `${+tempSelect.clientWidth}px`;
            tempSelect.remove();
        },
        listen: { },
        
        destroy: function (module) { }
    });
    
})();
(function () {
    "use strict";

    var moduleObj = moduler('sentens-list', {
        defaults: {
            filterName: null,
            filterElementSelector: null,
            event: 'change',
            listItemSelector: '.js-listItem',
            showAllButtonSelector: '.js-showAll',
            showMoreButtonSelector: '.js-showMore',
            itemsPerPage: 10,
            pageName: 'page',
            gridSelector: '.js-grid',
            getListItemsServiceUrl: null,
            predefinedGroupId: null
        },

        init: function (module) {
            if (module.settings.filterElementSelector != null) {
                module.$element.on(module.settings.event, module.settings.filterElementSelector, module, moduleObj.listen.updateFilterHash);
            }

            var updatePageHashSelectors = module.settings.showAllButtonSelector + ', ' + module.settings.showMoreButtonSelector;
            module.$element.on('click', updatePageHashSelectors, module, moduleObj.listen.updatePageHash);

            $(window).on('hashchange', module, moduleObj.listen.filter);
            $(window).trigger('hashchange');
        },

        listen: {
            updatePageHash: mo.event(function (module, e) {
                var $this = $(e.currentTarget);
                var page = 0;

                if ($this.hasClass(module.settings.showAllButtonSelector.replace('.', '')) == false) {
                    page = moduleObj.getHashParameter(module.settings.pageName, 1);
                    page++;
                }

                moduleObj.setHashParameter(module.settings.pageName, page);
            }),

            updateFilterHash: mo.event(function (module, e) {
                var $filterElement = $(e.currentTarget);
                moduleObj.setHashParameter(module.settings.filterName, $filterElement.val(), true);
            }),

            filter: mo.event(function (module) {
                var filterValue = moduleObj.getHashParameter(module.settings.filterName) || 0;
                if (module.settings.predefinedGroupId !== null) {
                    filterValue = module.settings.predefinedGroupId;
                }
                module.$element.find(module.settings.filterElementSelector + '[value="' + filterValue + '"]').prop('checked', true);

                if (module.$element.data('grouppageid') != filterValue) {
                    var data = {
                        groupPageId: filterValue
                    };
                    $.ajax({
                        type: 'POST',
                        url: module.settings.getListItemsServiceUrl,
                        data: data
                    })
                        .done(function (response) {
                            module.$element.find(module.settings.gridSelector).replaceWith(response);
                            module.$element.data('grouppageid', filterValue);

                            var hiddenListItems = 0;

                            if (filterValue == 0) {
                                module.$element.find(module.settings.listItemSelector + ':lt(' + module.settings.itemsPerPage + ')').show();

                                hiddenListItems = module.$element.find(module.settings.listItemSelector + ':hidden').length;
                            } else {
                                module.$element.find(module.settings.listItemSelector + ':lt(' + module.settings.itemsPerPage + ')').show();

                                hiddenListItems = module.$element.find(module.settings.listItemSelector + ':hidden').length;
                            }
                            moduleObj.renderButtons(module, hiddenListItems);
                        });
                }
                else {
                    var page = moduleObj.getHashParameter(module.settings.pageName, 1);
                    var itemsToShow = page == 0 ? 1000 : (module.settings.itemsPerPage * page);
                    var hiddenListItems = 0;

                    if (filterValue == 0) {
                        module.$element.find(module.settings.listItemSelector + ':lt(' + itemsToShow + ')').show();

                        hiddenListItems = module.$element.find(module.settings.listItemSelector + ':hidden').length;
                    } else {
                        module.$element.find(module.settings.listItemSelector + ':lt(' + itemsToShow + ')').show();

                        hiddenListItems = module.$element.find(module.settings.listItemSelector + ':hidden').length;
                    }

                    moduleObj.renderButtons(module, hiddenListItems);
                }
            }),
        },

        renderButtons: function (module, hiddenListItems) {
            var $showMoreButton = module.$element.find(module.settings.showMoreButtonSelector);
            var $showAllButton = module.$element.find(module.settings.showAllButtonSelector);
            if (hiddenListItems == 0) {
                $showMoreButton.hide();
                $showAllButton.hide();
            } else {
                $showMoreButton.show();
                $showAllButton.show();
            }
        },

        getHashParameter: function (key, fallback) {
            key = key.replace(/[\[\]]/g, "\\$&");

            var hash = location.hash;
            var regex = new RegExp("[#|&]" + key + "(=([^&#]*)|&|#|$)"), results = regex.exec(hash);

            if (!results || !results[2]) {
                if (fallback != null) {
                    return fallback;
                }
                return '';
            }

            return decodeURIComponent(results[2].replace(/\+/g, " "));
        },

        setHashParameter: function (key, value, isReset) {
            key = encodeURI(key);
            value = encodeURI(value);

            if (isReset) {
                location.hash = key + '=' + value;
            }
            else {
                var keyValuePair = location.hash.replace('#', '').split('&');
                var index = keyValuePair.length;
                var item;
                while (index--) {
                    item = keyValuePair[index].split('=');
                    if (item[0] == key) {
                        item[1] = value;
                        keyValuePair[index] = item.join('=');
                        break;
                    }
                }

                if (index < 0) {
                    keyValuePair[keyValuePair.length] = [key, value].join('=');
                }

                location.hash = keyValuePair.join('&');
            }
        },

        destroy: function (module) { }
    });

})();
(function () {
    "use strict";

    var moduleObj = moduler('setHoliday', {
        defaults: {},
        
        init: function (module) {
            if ($("body.Holiday").length > 0) {
            	var HolidayFrameLeft = $("<div></div>").addClass("Holiday-frame HolidayFrame--left"),
					HolidayFrameRight = $("<div></div>").addClass("Holiday-frame HolidayFrame--right");
            	$(".Page-main").before(HolidayFrameLeft, HolidayFrameRight);
				setTimeout(function () {
					var pageHeight = $(document).outerHeight();//$("#RegionFooter").offset().top;
					$(".Holiday-frame").css({ height: pageHeight });
				}, 3000); // enough time to let dynamic content load before execution
			}
        },
        
        listen: { },
        
        destroy: function (module) { }
    });
    
})();
(function () {
  "use strict";

  var moduleObj = moduler('slider', {
    defaults: {
      baseClass: "",
      itemClass: "",
      autoPlay: false,
      items: 1,
      singleItem: true,
			pagination: true,
			navigation: true
    },

    init: function (module) {
			module.$element.owlCarousel({
				navigation: module.settings.navigation,
        autoPlay: module.settings.autoPlay,
        stopOnHover: true,
        pagination: module.settings.pagination,
        slideSpeed: 300,
        paginationSpeed: 400,
        autoplayTimeout: 12000,
        items: module.settings.items,
        singleItem: module.settings.singleItem,
        baseClass: "owl-carousel " + module.settings.baseClass,
          itemClass: "owl-item " + module.settings.itemClass,
          loop: false,
          margin: 10,
          navRewind: false,
          rewind: false
      });
    }
  });
})();
(function () {
  "use strict";

  var moduleObj = moduler('sticky', {
    defaults: {
      wrapper: '<div class="Sticky" />', // set to false to disable wrapper element
      wrapperClass: null, // additional css class for wrapper
      stickyActiveClass: 'is-sticky', // css class to add when actively sticky
      stickyActiveBodyClass: false, // css class to add to body element when sticky is active
      stickyHiddenClass: 'is-stickyHidden',
      stickyHiddenBodyClass: false, // css class to add to body element when sticky is hidden
      stickyBottomClass: 'is-stickyBottom',
      transparencyClass: 'Header-transparent',
      scrollTopBodyClass: false, // css class to add to body when scroll is less than scrollTopOffset
      scrollTopOffset: false, // used combined with scrollTopBodyClass to set css class if scroll position less than this value (pixels)
      widthFromWrapper: true, // the fixed element will have its width from wrapper element
      innerScrolling: true, // scroll the sticky element if it is taller than the viewport
      contained: false, // keep element sticky within its container
      autoHide: false, // will hide sticky element when scrolling down, and show on scroll up
      autoHideOffset: 100, // extra pixels offset until hidden
      autoShowOffset: 250, // offset until scrolling up will show element. set to 0 to disable. 
      minScreenWidth: null, // mininum screen width when sticky is active
      maxScreenWidth: null, // maxium screen width when sticky is active
      transparent: false
    },

    init: function (module) {


      var self = module;

      self.$doc = $(document);
      self.$body = $(document.body);
      self.$window = $(window);
      self.$wrapper = self.$el; // default if wrapper is disabled
      self.isSticky = false; // if element is currently fixed/sticky
      self.isDisabled = false;
      self.cache = {};
      self.offset = 0; // used for inner scrolling offsets
      self.forceShow = false; // force show an auto-hidden sticky element

      if (self.settings.wrapper) {
        self.$element.addClass('Sticky-element');
        self.$element.wrap(self.settings.wrapper);
        self.$wrapper = self.$element.parent();

        if (self.settings.wrapperClass) {
          self.$wrapper.addClass(self.settings.wrapperClass);
        }
      }

      self.$container = self.$wrapper.parent();

      if (self.settings.contained) {
        // container element has to be relative for "is-stickyBottom" to work
        self.$container.css('position', 'relative');
      }

      function recalcAndTick() {
        //self.obj.recalc()???
        moduleObj.recalc.call(self);

        if (!self.isDisabled) {
          moduleObj.tick.call(self)
        }
      }

      self.viewportChanges = new ViewportChanges();
      self.viewportChanges.watchScroll(moduleObj.tick.bind(self));
      self.viewportChanges.watchResize(moduleObj.recalc.bind(self));

      ViewportChanges.requestAnimationFrame(recalcAndTick.bind(self));

      self.$element.on('recalc', recalcAndTick.bind(self));
      self.$element.on('tick', moduleObj.tick.bind(self));
      self.$element.on('show', moduleObj.tick.bind(self));
      self.$element.on('enable', moduleObj.enable.bind(self));
      self.$element.on('disable', moduleObj.disable.bind(self));
    },

    /*
     * Recalculates the cached properties.
     * This is an expensive method and is only called on resize event 
     * and when height of document changes.
     */
    recalc: function () {
      var self = this,
        cache = self.cache;

      cache.previousScrollTop = 0;

      // document/window
      cache.documentHeight = self.$doc.height();
      cache.windowHeight = self.$window.height();

      // element
      cache.elementHeight = self.$element.outerHeight();

      // wrapper
      cache.wrapperWidth = self.$wrapper.outerWidth();
      cache.wrapperOffsetTop = self.$wrapper.offset().top;

      // container
      cache.containerOffsetTop = self.$container.offset().top;
      cache.containerHeight = self.$container.outerHeight();
      cache.containerEndOffsetTop = self.cache.containerHeight + self.cache.containerOffsetTop - self.cache.elementHeight;

      // auto hide
      cache.autoHideOffsetTop = self.cache.wrapperOffsetTop + self.cache.elementHeight + self.settings.autoHideOffset;

      if (!self.isDisabled) {
        // set wrapper to same height as content to take space when content is sticky/fixed.
        self.$wrapper.css('height', cache.elementHeight);

        if (self.settings.widthFromWrapper) {
          // update width of sticky element
          self.$element.css('width', cache.wrapperWidth);
        }
      }

      if (self.settings.minScreenWidth || self.settings.maxScreenWidth) {
        var windowWidth = self.$window.width(),
          isWiderThanMinWidth = !self.settings.minScreenWidth || windowWidth > self.settings.minScreenWidth,
          isSmallerThanMaxWidth = !self.settings.maxScreenWidth || windowWidth < self.settings.maxScreenWidth,
          isAllowedSpan = isWiderThanMinWidth && isSmallerThanMaxWidth;

        if (isAllowedSpan && self.isDisabled) {
          self.enable();
        } else if (!isAllowedSpan && !self.isDisabled) {
          self.disable();
        }
      }
    },

    /*
     * Tick is called on every scroll event.
     */
    tick: function () {
      var self = this,
        newDocHeight = self.$doc.height();

      if (self.cache.documentHeight != newDocHeight) {
        self.cache.documentHeight = newDocHeight;
        moduleObj.recalc.call(self);
      }

      document.getElementById("search-container").classList.remove("Search-visible");

      var scrollTop = self.$window.scrollTop(),
        shouldStick = self.cache.wrapperOffsetTop < scrollTop,
        deltaScrollTop = scrollTop - self.cache.previousScrollTop,
        isScrollingDown = deltaScrollTop > 0,
        isScrollEnd = scrollTop >= (self.cache.documentHeight - self.cache.windowHeight);

      if (isScrollingDown != self.cache.previousScrollingDown) {
        self.cache.lastDirectionChangePosition = scrollTop;
      }

      if (shouldStick && !self.isSticky) {
        self.$element.addClass(self.settings.stickyActiveClass);

        if (self.settings.stickyActiveBodyClass) {
          self.$body.addClass(self.settings.stickyActiveBodyClass);
        }
        self.isSticky = true;
        if (self.settings.transparent) {
          self.$element.removeClass(self.settings.transparencyClass);
        }
      } else if (!shouldStick && self.isSticky) {
        self.$element.removeClass(self.settings.stickyActiveClass);
        if (self.settings.stickyActiveBodyClass)
          self.$body.removeClass(self.settings.stickyActiveBodyClass);
        self.isSticky = false;
        if (self.settings.transparent) {
          self.$element.addClass(self.settings.transparencyClass);
        }
      }

      if (self.settings.autoHide) {
        var shouldAutoHide = self.cache.autoHideOffsetTop < scrollTop && !isScrollEnd;
        var deltaScrollChangePos = Math.abs(scrollTop - self.cache.lastDirectionChangePosition);

        if (isScrollingDown && shouldAutoHide && !self.forceShow) {
          self.$element.addClass(self.settings.stickyHiddenClass);
        } else if (deltaScrollChangePos >= self.settings.autoShowOffset || !shouldAutoHide || self.forceShow) {
          self.$element.removeClass(self.settings.stickyHiddenClass);
          self.forceShow = false;
        }
      }

      if (self.settings.innerScrolling) {
        var needsInnerScrolling = self.cache.elementHeight > self.cache.windowHeight;

        if (needsInnerScrolling && self.isSticky) {
          self.offset -= deltaScrollTop;
          self.offset = Math.max(self.offset, (self.cache.windowHeight - self.cache.elementHeight));
          self.offset = Math.min(self.offset, 0);

          self.$element.css('top', self.offset + 'px');
        }
      }

      if (self.settings.contained) {
        var hasReachedEnd = (self.cache.containerEndOffsetTop - self.offset) < scrollTop;

        if (hasReachedEnd) {
          self.$element.addClass(self.settings.stickyBottomClass);
        } else {
          self.$element.removeClass(self.settings.stickyBottomClass);
        }
      }

      if (self.settings.stickyHiddenBodyClass) {
        if (!shouldStick && !self.forceShow) {
          self.$body.addClass(self.settings.stickyHiddenBodyClass);
        } else {
          self.$body.removeClass(self.settings.stickyHiddenBodyClass);
        }
      }

      if (self.settings.scrollTopBodyClass && self.settings.scrollTopOffset) {
        if (scrollTop < self.settings.scrollTopOffset) {
          self.$body.addClass(self.settings.scrollTopBodyClass);
        } else {
          self.$body.removeClass(self.settings.scrollTopBodyClass);
        }
      }

      self.cache.previousScrollTop = scrollTop;
      self.cache.previousScrollingDown = isScrollingDown;
    },

    /*
     * To show an auto-hidden sticky element, 
     * trigger the "show" event on the module element.
     */
    show: function () {
      var self = this;

      self.forceShow = true;
      moduleObj.tick.call(self);
    },

    enable: function () {
      var self = this;

      if (self.isDisabled) {
        self.isDisabled = false;

        self.viewportChanges.watchScroll(moduleObj.tick.bind(self));
        moduleObj.recalc.call(self);
        moduleObj.tick.call(self);
      }
    },

    disable: function () {
      var self = this;

      if (!self.isDisabled) {
        self.isDisabled = true;
        self.isSticky = false;
        self.offset = 0;
        self.$element.css({ top: '', width: '' }).removeClass(self.settings.stickyActiveClass + ' ' + self.settings.stickyBottomClass + ' ' + self.settings.stickyHiddenClass);
        self.$body.removeClass(self.settings.stickyActiveBodyClass);
        self.$wrapper.css('height', '');

        self.viewportChanges.watchScroll(false);
      }
    }
  });

  var instanceId = 0;

  function ViewportChanges() {
    var noop = function () { };

    this.id = instanceId++;
    this.$window = $(window);
    this.handleScroll = noop;
    this.handleResize = noop;
  }

  ViewportChanges.prototype.watchResize = function (handler) {
    if (handler === undefined) {
      throw new Error('Missing parameter in ViewportChanges.watchResize function.');
    }

    if (handler) {
      this.handleResize = handler;
      this.createResizeHandler();
    } else {
      this.$window.off('resize.ViewportChanges' + this.id);
    }
  };

  ViewportChanges.prototype.watchScroll = function (handler) {
    if (handler === undefined) {
      throw new Error('Missing parameter in ViewportChanges.watchScroll function.');
    }

    if (handler) {
      this.handleScroll = handler;
      this.createScrollHandler();
    } else {
      this.$window.off('scroll.ViewportChanges' + this.id);
    }
  };

  ViewportChanges.prototype.createResizeHandler = function () {
    var self = this;

    function resizeHandler() {
      self.handleResize();
      self.hasResized = false;
    }

    this.$window.on('resize.ViewportChanges' + this.id, function resizeEventListener() {
      if (!self.hasResized) {
        self.hasResized = true;
        ViewportChanges.requestAnimationFrame(resizeHandler);
      }
    });
  };

  ViewportChanges.prototype.createScrollHandler = function () {
    var self = this;

    function scrollHandler() {
      self.handleScroll();
      self.hasScrolled = false;
    }

    this.$window.on('scroll.ViewportChanges' + this.id, function scrollEventListener() {
      if (!self.hasScrolled) {
        self.hasScrolled = true;
        ViewportChanges.requestAnimationFrame(scrollHandler);
      }
    });
  };

  ViewportChanges.requestAnimationFrame = function (callback) {
    var requestAnimationFrame = window.requestAnimationFrame
      || window.webkitRequestAnimationFrame
      || window.mozRequestAnimationFrame
      || window.msRequestAnimationFrame
      || function (callback) { return setTimeout(callback, 1000 / 60); };

    return requestAnimationFrame(callback);
  };

})();

(function () {
  "use strict";

  var moduleObj = moduler('stock-notification-modal', {
    defaults: {
      productCode: null,
      modalSelector: '.js-stock-modal',
      serviceUrl: '/api/stocknotification/addemail',
    },

    init: function (module) {
      var invalidateInput = function (i) {
        i.addClass('FormField--error');
        $('.email-validation-message').show();
        $('.js-add-stock-notification').addClass('Button--inactive Button-keep-padding');
        $('.js-add-stock-notification').attr('disabled', true);
        $('.Modal-footer').addClass('Modal-footer--noMargin');
      }
      var validateInput = function (i) {
        i.removeClass('FormField--error');
        $('.email-validation-message').hide();
        $('.js-add-stock-notification').removeClass('Button--inactive Button-keep-padding');
        $('.js-add-stock-notification').attr('disabled', false);
        $('.Modal-footer').removeClass('Modal-footer--noMargin');
      }

      $(module.$element).on('click', function () {
        var button = $('.btn-' + module.settings.productCode);
        $('.js-add-stock-notification').off('click');
        $(module.settings.modalSelector).trigger('openModal');

        $('.user-email').on('input', function () {
          var input = $(this);
          var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
          var is_email = re.test(input.val());
          if (is_email) {
            validateInput(input);
          }
          else {
            invalidateInput(input);
          }
        });

        $('.js-add-stock-notification').click(function () {
          if (!$('.user-email').val()) {
            invalidateInput($('.user-email'));
          }
          else {
            $.ajax({
              url: module.settings.serviceUrl,
              type: 'POST',
              data: {
                productCode: module.settings.productCode,
                userEmail: $('.user-email').val()
              },
              success: function (data, textStatus, jqXHR) {
                $(module.settings.modalSelector).trigger('closeDialog');
                $('.js-success-modal').trigger('openModal');
                setTimeout(function () {
                  $('.js-success-modal').trigger('closeDialog');
                }, 1000);
              },
              error: function (jqXHR, textStatus, error) {
                console.log("Something went wrong");
              }
            })
          }
        });
      });
    },

    listen: {},

    destroy: function (module) { }
  });

})();
(function () {
	"use strict";

	var moduleObj = moduler('store-promotion', {
		defaults: {
			serviceUrl: '/StorePromotions'
		},
		init: function (module) {
			$(document).on(electrolux.events.locationUpdated, function (e) {
				moduleObj.reload(module);
			});
		},

		reload: function (module) {
			$.ajax({
				type: 'GET',
				url: module.settings.serviceUrl,
				datatype: 'html',
				cache: false,
				success: function (response) {
					if (response) {
						$(module.$element).replaceWith(response);
					}
				}
			});
		},

		destroy: function (module) { }
	});
})();
(function () {
	"use strict";

	/*
			Example HTML:

			<div class="Tabs" data-module="tabs">
					<ul class="Tabs-list">
							<li class="Tabs-item" data-name="tab-one">Tab One</li>
							<li class="Tabs-item" data-name="tab-two">Tab Two</li>
					</ul>

					<div class="Tabs-panels">
							<div class="Tabs-panel">
									<!-- panel 1 -->
							</div>

							<div class="Tabs-panel">
									<!-- panel 2 -->
							</div>
					</div>
			</div>
	*/

	var moduleObj = moduler('tabs', {
		defaults: {
			event: 'click',
			handles: '.Tabs-item',
			panels: '.Tabs-panel',
			activeClass: 'is-active',
			togglable: false, // whether to allow a panel to close if you click on its handle again.
			showFirst: true, // whether to show first panel on load.
			selectedPanel: null // the panel to show at page load (optional).
		},

		init: function (module) {
			module.$handles = module.$element.find(module.settings.handles);
			module.$panels = module.$element.find(module.settings.panels);

			module.$handles.on(module.settings.event, module, moduleObj.listen.showPanel);

			if (module.settings.selectedPanel) {
				module.$handles.filter('[data-name=' + module.settings.selectedPanel + ']').trigger(module.settings.event);
				module.settings.selectedPanel.setAttribute('aria-selected', 'true');
			} else if (module.settings.showFirst) {
				module.$handles.first().trigger(module.settings.event);
			}
		},

		listen: {
			showPanel: mo.event(function (module, e) {
				e.preventDefault();

				var $handle = $(e.target),
						settings = module.settings,
						handleIndex = module.$handles.index($handle),
						$panel = module.$panels.eq(handleIndex);

				// if event was triggered on a link inside "handles" then we try to find the handle element now
				if (!$handle.is(module.settings.handles)) {
					$handle = $handle.closest(module.settings.handles);
					handleIndex = module.$handles.index($handle);
					$panel = module.$panels.eq(handleIndex);
				}
				module.$handles.not($handle).removeClass(settings.activeClass).attr('aria-selected', 'false').trigger('Tab-hide');
				module.$panels.not($panel).removeClass(settings.activeClass).trigger('Tab-hide');

				var classFuncName = settings.togglable ? 'toggleClass' : 'addClass';
				$handle[classFuncName](settings.activeClass).attr('aria-selected', 'true').trigger('Tab-show');
				$panel[classFuncName](settings.activeClass).trigger('Tab-show');
			})
		},

		destroy: function (module) {
			module.$handles.off(module.settings.event, moduleObj.listen.showPanel);
		}
	});

})();
(function () {
    "use strict";

    var moduleObj = moduler('toggleAttr', {
        defaults: {
            event: 'click'
        },

        init: function (module) {

            $(module.$element).on('click', module, function () {
                moduleObj.toggleAttr(module);
            });
        },

        toggleAttr: function (module) {
            $(module.$element).attr('data-shouldvalidate', "true");
        },

        destroy: function (module) { }

    });
})();

(function ($) {
	"use strict";

	var moduleObj = moduler('toggler', {
		defaults: {
			event: 'click',
			contentElement: null,
			cssClass: 'hide',
			preventDefault: true,
			addClassToSelf: false,
			once: false,
			headerClass: null,
			focusElement: null
		},

		init: function (module) {
			module.$contentElement = $(module.settings.contentElement ? module.settings.contentElement : module.element);
			module.$element.on(module.settings.event, module, moduleObj.listen.toggleVisibility);

			//$('body').click(function (e) {              
			//    if (!module.$element.has($(e.target.nodeName)).length)
			//        moduleObj.listen.hide(module);
			//});
		},

		listen: {
			show: mo.event(function (module) {
				module.$contentElement.removeClass(module.settings.cssClass);
				module.$contentElement.trigger('toggler-shown');
				if (module.settings.focusElementOnShow != null) {
					$(module.settings.focusElementOnShow).focus();
				}
			}),

			hide: mo.event(function (module) {
				module.$contentElement.addClass(module.settings.cssClass);
				module.$contentElement.trigger('toggler-hidden');
			}),

			toggleVisibility: mo.event(function (module, e) {
				if (module.settings.preventDefault) {
					e.preventDefault();
				}
				if (module.settings.once && module.toggled) {
					return;
				} else if (module.settings.once) {
					module.toggled = true;
				}

				if (module.settings.addClassToSelf) {
					module.$element.toggleClass(module.settings.cssClass);
				}

				module.$contentElement.toggleClass(module.settings.cssClass);
				module.$contentElement.trigger('toggler-toggeled');
				if (module.settings.focusElement != null) {
					$(module.settings.focusElement).focus();
				}

				module.$element.attr('aria-expanded', module.$contentElement.hasClass(module.settings.cssClass) ? 'true' : 'false');
			})
		}
	});
})(jQuery);
(function () {
	"use strict";
	/**
	 * A module for generating tooltips
	 */

	var moduleObj = moduler('tooltip', {
		defaults: {
			trigger: 'hover', // Tooltip trigger
			placement: 'n', // Placement values: n, s, w, e, nw, ne, sw, se, auto |  auto, top, bottom, left, right, top-left, top-right, botom-left, bottom-right  
			tooltipTemplate: '<div class="Tooltip" role="tooltip"><div class="Tooltip-content"></div><div class="Tooltip-arrow"></div></div>', // Tooltip markup
			activeClass: 'is-tooltipVisible',
			title: ''
		},

		init: function (module) {
			var title = module.$element.attr('title');

			if (title) {
				module.$element.attr('data-title', title);
				module.$element.removeAttr('title');
				module.settings.title = title;
			}

			// If 'hover' is used as a trigger, set it to mouseover so that binding is made possible.
			if (module.settings.trigger === 'hover') {
				module.settings.trigger = 'mouseover';
			}

			module.settings.tooltipId = 'tooltip-' + moduleObj.randomString(10);
			if (module.settings.tooltipTemplate != null && (module.settings.tooltipTemplate.indexOf('.') == 0 || module.settings.tooltipTemplate.indexOf('#') == 0)) {
				module.$tooltipTemplate = $($(module.settings.tooltipTemplate).html());
			} else {
				module.$tooltipTemplate = $(module.settings.tooltipTemplate);
			}

			// ARIA tags
			module.$element.attr('aria-haspopup', 'true');
			module.$element.attr('aria-describedby', module.settings.tooltipId);
			module.$tooltipTemplate.find('.Tooltip-content').attr('id', module.settings.tooltipId);

			moduleObj.initEvents(module);
		},

		randomString: function (length) {
			var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'.split('');

			if (!length) {
				length = Math.floor(Math.random() * chars.length);
			}

			var str = '';
			for (var i = 0; i < length; i++) {
				str += chars[Math.floor(Math.random() * chars.length)];
			}
			return str;
		},

		initEvents: function (module) {
			/**
			 * Trigger binding
			 */
			module.$element.on(module.settings.trigger, function (e) {
				e.preventDefault();

				// Remove all tooltip elements
				// $('.Tooltip').remove();

				// Gives the trigger element an 'active' status class
				module.$element.addClass(module.settings.activeClass);

				// Sets initial styling, hides the tooltip template, and populates its content
				module.$tooltipTemplate.css({
					top: 0,
					left: 0,
					visibility: 'hidden',
					display: 'block'
				});//.find('.Tooltip-content').html(module.settings.title);

				// Appends the tooltip template to the document body
				if (!module.$tooltipTemplate.parent().is('body')) {
					module.$tooltipTemplate.detach().appendTo('body');
				}

				// Triggers the positioning of the tooltip element
				moduleObj.position(module);
			});

			/**
			 * Removes the tooltip upon blur or mouseout
			 * depending on a few condition scenarios
			 */
			module.$element.on('blur mouseout', function (e) {
				// If the trigger is 'focus' and the current event includes a 'blur'
				if (module.settings.trigger === 'focus' && e.type === 'blur') {
					$('.Tooltip').remove();
				}
				// If the trigger is 'mouseover' and the current event includes a 'mouseout'
				if (module.settings.trigger === 'mouseover' && e.type === 'mouseout') {
					$('.Tooltip').remove();
				}
				// If the current event includes a 'blur' and the trigger element is an <input>
				if (module.$element.prev().is("input, textarea, select") && e.type === 'blur') {
					$('.Tooltip').remove();
				}
			});

			/**
			 * Removes the tooltip if we click or touch anywhere other
			 * than the trigger element and the tooltip itself
			 */
			$(document).on('click touchstart', function (e) {
				if ($(e.target).closest("." + module.settings.activeClass).length === 0 && $(e.target).closest(".Tooltip").length === 0) {
					$('.Tooltip').remove();
				}
			});

			/**
			 * Re-positions the tooltip if the window is resized
			 * or the orientation is altered
			 */
			$(window).on('resize orientationchange', function () {
				moduleObj.position(module);
			});
		},
		/**
		 * Positions the tooltip
		 */
		position: function (module) {
			// Gets the width and height of the trigger element
			var elementPosition = $.extend({}, module.$element.offset(), {
				width: module.$element[0].offsetWidth,
				height: module.$element[0].offsetHeight
			}),
				tooltipWidth = module.$tooltipTemplate[0].offsetWidth,
				tooltipHeight = module.$tooltipTemplate[0].offsetHeight,
				tooltipPlacement = module.settings.placement, // Placement of the tooltip: n, s, w, e, nw, ne, sw, se, auto
				tooltipPosition; // The absolute positioning coordinates of the tooltip

			// Checks if value is less than 0, if so, return 0 otherwise, return the value
			function isLessThenZero(value) {
				return (value < 0) ? 0 : value;
			}

			// Automatically calculates where the tooltip is optimally displayed
			if (tooltipPlacement === 'auto') {
				// North and south handler
				tooltipPlacement = elementPosition.top > ($(document).scrollTop() + $(window).height() / 2) ? 'n' : 's';
				// West and east handler
				tooltipPlacement += elementPosition.left > ($(document).scrollLeft() + $(window).width() / 2) ? 'w' : 'e';
			}

			// Prevents tooltips from disappearing off the screen on narrow devices when 'e' or 'w' are selected.
			if ((tooltipPlacement === 'e' || tooltipPlacement === 'w') && elementPosition.left - tooltipWidth < 0) {
				module.settings.placement = 'auto';
				moduleObj.position(module);
			}

			// Calculates the top and left absolute positioning of the
			// tooltip based on the supplied placement value
			switch (tooltipPlacement.charAt(0)) {
				case 'n':
					tooltipPosition = {
						top: elementPosition.top - tooltipHeight,
						left: isLessThenZero(elementPosition.left + elementPosition.width / 2 - tooltipWidth / 2)
					};

					break;
				case 's':
					tooltipPosition = {
						top: elementPosition.top + elementPosition.height,
						left: isLessThenZero(elementPosition.left + elementPosition.width / 2 - tooltipWidth / 2)
					};

					break;
				case 'w':
					tooltipPosition = {
						top: elementPosition.top + elementPosition.height / 2 - tooltipHeight / 2,
						left: elementPosition.left - tooltipWidth
					};
					break;
				case 'e':
					tooltipPosition = {
						top: elementPosition.top + elementPosition.height / 2 - tooltipHeight / 2,
						left: elementPosition.left + elementPosition.width
					};
					break;
			}

			// Calculates the left absolute position of the
			// tooltip if a double-character placement was supplied
			if (tooltipPlacement.length === 2) {
				if (tooltipPlacement.charAt(1) === 'w') {
					tooltipPosition.left = isLessThenZero(elementPosition.left);
				} else {
					tooltipPosition.left = isLessThenZero(elementPosition.left + elementPosition.width - tooltipWidth);
				}
			}

			// Reposition tooltip arrow if the tooltip is n or s and the left positioning is 0
			if ((tooltipPlacement === 'n' || tooltipPlacement === 's') && tooltipPosition.left === 0) {
				$('.Tooltip-arrow').css({ left: ($('.Tooltip').width() / 100) * elementPosition.left + 20 });
			}

			// Replaces the hidden styling of the tooltip with the
			// absolute position coordinates, apply the placement class
			module.$tooltipTemplate.removeAttr('style').css(tooltipPosition).attr('class', 'Tooltip Tooltip--arrow' + tooltipPlacement.toUpperCase());
		}
	});
})();
(function () {
    "use strict";

    /*
    *Simple module to trigger an event when another event happens
    */
    var moduleObj = moduler('trigger', {
        defaults: {
            listenEvent: 'click',
            triggerEvent: undefined,
            data: undefined,
            preventDefault: false,
            triggerTarget: document
        },

        init: function (module) {
            var data = typeof module.settings.data === 'array' ? module.settings.data : [module.settings.data];
            module.$element.on(module.settings.listenEvent, function (event) {
                $(module.settings.triggerTarget).trigger(module.settings.triggerEvent, data)
                return !module.settings.preventDefault;
            });
        }
    });
})();
(function () {
    "use strict";

    var moduleObj = moduler('video', {
        defaults: {},
        
        init: function (module) {
            // Basic FitVids Test
            $(module.$element).fitVids();
            // Custom selector and No-Double-Wrapping Prevention Test
            $(module.$element).fitVids({ customSelector: "iframe[src^='http://socialcam.com']" });
        },
        
        listen: { },
        
        destroy: function (module) { }
    });
    
})();
(function () {
	"use strict";

	var moduleObj = moduler('zmags', {
		defaults: {
			desktopParentElementSelector: '.js-zmags-desktop',
			desktopPublicationId: '',
			mobileParentElementSelector: '.js-zmags-mobile',
			mobilePublicationId: '',
			fullScreenView: false
		},

		viewerStyle: '',
		viewer: null,
		$parentElement: null,

		init: function (module) {
			moduleObj.loadViewer(module);
			moduleObj.setupFullScreenView(module);
			$(window).resize(function () {
				moduleObj.setupFullScreenView(module);
				moduleObj.loadViewer(module);
			});
		},

		loadViewer: function (module) {
			if (module.settings.desktopPublicationId != '' || module.settings.mobilePublicationId != '') {
				var $desktopParentElement = module.$element.find(module.settings.desktopParentElementSelector);
				var $mobileParentElement = module.$element.find(module.settings.mobileParentElementSelector);

				if (module.settings.mobilePublicationId != '') {
					if ($desktopParentElement.is(':visible') && $desktopParentElement.children().length == 0) {
						moduleObj.$parentElement = $desktopParentElement;

						moduleObj.viewer = new com.zmags.api.Viewer();
						moduleObj.viewer.setPublicationID(module.settings.desktopPublicationId);
						moduleObj.viewer.setParentElementID($desktopParentElement.attr('id'));
						moduleObj.viewer.show();
					} else if ($mobileParentElement.is(':visible') && $mobileParentElement.children().length == 0) {
						moduleObj.$parentElement = $mobileParentElement;

						moduleObj.viewer = new com.zmags.api.Viewer();
						moduleObj.viewer.setPublicationID(module.settings.mobilePublicationId);
						moduleObj.viewer.setParentElementID($mobileParentElement.attr('id'));
						moduleObj.viewer.setFullscreenMode(com.zmags.api.Viewer.FullscreenMode.API_ONLY);
						moduleObj.viewer.addEventListener(com.zmags.api.Viewer.TOOLBAR_BUTTON_ACTIVATE, moduleObj.mobileFullscreen);
						moduleObj.viewer.show();
					}
				} else if ($desktopParentElement.children().length == 0) {
					if ($desktopParentElement.is(':visible') && $desktopParentElement.children().length == 0) {
						moduleObj.$parentElement = $desktopParentElement;

						moduleObj.viewer = new com.zmags.api.Viewer();
						moduleObj.viewer.setPublicationID(module.settings.desktopPublicationId);
						moduleObj.viewer.setParentElementID($desktopParentElement.attr('id'));
						moduleObj.viewer.setFullscreenMode(com.zmags.api.Viewer.FullscreenMode.API_ONLY);
						moduleObj.viewer.addEventListener(com.zmags.api.Viewer.TOOLBAR_BUTTON_ACTIVATE, moduleObj.mobileFullscreen);
						moduleObj.viewer.show();
					}
					else if ($mobileParentElement.is(':visible') && $mobileParentElement.children().length == 0) {
						moduleObj.$parentElement = $mobileParentElement;

						moduleObj.viewer = new com.zmags.api.Viewer();
						moduleObj.viewer.setPublicationID(module.settings.desktopPublicationId);
						moduleObj.viewer.setParentElementID($mobileParentElement.attr('id'));
						moduleObj.viewer.setFullscreenMode(com.zmags.api.Viewer.FullscreenMode.API_ONLY);
						moduleObj.viewer.addEventListener(com.zmags.api.Viewer.TOOLBAR_BUTTON_ACTIVATE, moduleObj.mobileFullscreen);
						moduleObj.viewer.show();
					}
				}
			}
		},

		setupFullScreenView: function (module) {
			if (module.settings.fullScreenView) {
				var headerHeight = $('.js-header').height();
				var viewportHeight = $(window).height();
				var height = viewportHeight - headerHeight;
				if (height > 0) {
					console.log('height', height, headerHeight, viewportHeight);
					$(module.settings.desktopParentElementSelector).css('height', height + 'px');
					$(module.settings.mobileParentElementSelector).css('height', height + 'px');
				}
			}
		},

		mobileFullscreen: function (event) {
			if (event.buttonID === "fullscreen") {
				if (moduleObj.viewerStyle == "") {
					document.body.style.overflow = "hidden";
					moduleObj.viewerStyle = moduleObj.$parentElement.attr('style');
					moduleObj.$parentElement.attr('style', 'position:fixed; top:0px; left:0px; height:100%; width:100%; z-index:9001;');
				}
				else {
					document.body.style.overflow = "auto";
					moduleObj.$parentElement.attr('style', moduleObj.viewerStyle);
					moduleObj.viewerStyle = "";
				}
				moduleObj.viewer.resize();
			}
		},
		listen: {},
		destroy: function (module) { }
	});
})();
(function () {
    "use strict";

    var moduleObj = moduler('module-name', {
        defaults: {},
        
        init: function (module) {
            
        },
        
        listen: { },
        
        destroy: function (module) { }
    });
    
})();
(function () {
	"use strict";

	var moduleObj = moduler('booking-form', {
		defaults: {
			event: 'click',
			currentBlockId: null,
			option: '.Select-input',
			optionvalueText: '.Select-input option:selected',
			desiredDate: '.js-desiredDate',
			desiredTime: '.js-desiredTime',
			fullname: '.js-fullName',
			email: '.js-email',
			isStorePageDropDown: true,
			currentPageId: null,
			sendStatus: '.js-status',
			statuslabel: '.js-statusLabel',
			form: '.Form',
			errorLabel: '.js-errorLabel',
			messageFieldSelector: '.js-messageField',
			phoneNumberSelector: '.js-phoneNumber',
			gdprAgree: '.js-gdprAgree',
			storeServiceUrl: '/api/favoritestore',
			storeSelect: '.js-storeList',
			originPageName: '.js-originpagename'
		},

		init: function (module) {
			module.$element.on('submit', module.settings.form, module, moduleObj.listen.selected);
			var $storeSelect = $(module.settings.storeSelect, module.$element);
			module.$element.on('change', $storeSelect, function () {
				if ($('option:selected', $storeSelect).data('new-booking-form')) {
					$('.js-bookingform-old', module.$element).hide();
					$('.js-bookingform-new', module.$element).show();
					$('.js-bookingform-new-link').attr('href', $('option:selected', $storeSelect).data('new-booking-form-url'))
				} else {
					$('.js-bookingform-old', module.$element).show();
					$('.js-bookingform-new', module.$element).hide();
				}
			});

			$.ajax({
				type: 'GET',
				url: module.settings.storeServiceUrl,
				datatype: 'json',
				cache: false,
				success: function (response) {
					if (response) {
						var storeSelect = $(module.settings.storeSelect, module.$element);
						$('option[value="' + response.ID + '"]', storeSelect).prop('selected', true).trigger('change');
					}
				}
			});
		},

		listen: {
			selected: mo.event(function (module, e) {
				e.preventDefault();
				var optionVal = module.$element.find(module.settings.option).val();
				var desiredDateVal = module.$element.find(module.settings.desiredDate).val();
				var desiredTimeVal = module.$element.find(module.settings.desiredTime).val();

				var bookerName = module.$element.find(module.settings.fullname).val();
				var bookerEmail = module.$element.find(module.settings.email).val();

				var data = {
					isStorePageDropDown: module.settings.isStorePageDropDown,
					selectedValue: optionVal,
					desiredDate: desiredDateVal,
					desiredTime: desiredTimeVal,
					name: bookerName,
					email: bookerEmail,
					__RequestVerificationToken: module.$element.find('input[name=__RequestVerificationToken]').val(),
					currentBlockID: module.settings.currentBlockId,
					currentPageId: module.settings.currentPageId,
					message: module.$element.find(module.settings.messageFieldSelector).val(),
					phoneNumber: module.$element.find(module.settings.phoneNumberSelector).val(),
					gdprAgree: module.$element.find(module.settings.gdprAgree).is(':checked'),
					originPageName: module.$element.find(module.settings.originPageName).val()
				};

				$.ajax({
					type: "POST",
					url: "/store/sendbooking",
					data: data,
					success: function (response) {
						if (response) {
							if (response.url) {
								// Fix for GA4 to give it time to send response
								window.setTimeout(function () {
									window.location = response.url;
								}, 200);
							}
							else {
								module.$element.find(module.settings.sendStatus).removeClass("Status--warning").addClass("u-block");
								module.$element.find(module.settings.statuslabel).addClass("u-block");
								module.$element.find(module.settings.errorLabel).removeClass("u-block");
								module.$element.find(module.settings.form).addClass("u-hidden");
							}
							module.$element.trigger("postComplete", [{ eventLabel: module.$element.find(module.settings.option).find(":selected").text() }]);
						} else {
							module.$element.find(module.settings.sendStatus).show().addClass("u-block Status--warning");
							module.$element.find(module.settings.errorLabel).addClass("u-block").text("Det gick inte att skicka formuläret");
							return;
						}
					},
					error: function (jqXhr, textStatus, errorThrown) {
						module.$element.find(module.settings.sendStatus).show().addClass("u-block Status--warning");
						module.$element.find(module.settings.errorLabel).addClass("u-block").text("Det gick inte att skicka formuläret: " + errorThrown);
						return;
					}
				});
			}),
		},

		destroy: function (module) { }
	});
})();
(function () {
	"use strict";

	var moduleObj = moduler('kitchen-article-filter', {
		defaults: {},

		init: function (module) {
			$('.js-kitchen-article-filter-select', module.$element).change(function (e) {
				let selectedValue = $(this).val();
				let container = $('.js-kitchen-article-filter-list', module.$element);
				if (selectedValue == '') {
					$('.js-kitchen-article-filter-article', container).parent().show();
				} else {
					$('.js-kitchen-article-filter-article[data-type!="' + $(this).val() + '"]', container).parent().hide();
					$('.js-kitchen-article-filter-article[data-type="' + $(this).val() + '"]', container).parent().show();
				}
			});
		},

		listen: {},

		destroy: function (module) { }
	});

})();
(function () {
  "use strict";

  var moduleObj = moduler('price-history', {
    defaults: {
      info: '.js-price-history-info',
      infoDialogMessage: '.js-price-history-info-dialog-message'
    },
    init: function (module) {
      module.$element.on('click', module.settings.info, function (e) {
        moduleObj.openInfoDialog(module);
      });
    },
    openInfoDialog: function (module) {
      $(document).trigger(electrolux.events.dialogShowMessage, [null, module.settings.infoDialogMessage]);
    },
  });
})();

(function () {
	"use strict";

	var moduleObj = moduler('add-to-cart-v2', {
		defaults: {
			event: 'click',
			code: null,
			storePickup: false
		},

		init: function (module) {
			(module.$element).on(module.settings.event, function (e) {
				e.preventDefault();
				let storeId = module.settings.storePickup ? electrolux.utils.getSelectedStoreId() : -1;
				$(document).trigger(electrolux.events.addToCart, [module.settings.code, storeId]);
			});
		},
	});
})();
(function () {
  "use strict";

  var moduleObj = moduler('cart-v2', {
    defaults: {
      containerElement: '.js-cart-v2-container',
      element: '.js-mini-cart-element'
    },

    init: function (module) {
      moduleObj.loadCart(module);

      $(module.settings.element).click(function () {
        moduleObj.toggleCart(module);
      });

      $(document).on(electrolux.events.addToCart, function (e, code, storeId) {
        moduleObj.updateCart(module, code, 1, storeId);
      });

      $(module.settings.containerElement).on('click', '.js-minicart-close', function (e) {
        e.preventDefault();
        moduleObj.closeCart(module);
      });

      $(module.settings.containerElement).on('click', '.js-cart-change-quantity', function (e) {
        e.preventDefault();
        let code = $(this).data('code');
        let quantity = $(this).data('quantity');
        let storeId = $(this).data('storeid');
        moduleObj.updateCart(module, code, quantity, storeId);
      });

      $(module.settings.containerElement).on('click', '.js-cart-v2-switch-store', function (e) {
        e.preventDefault();

        $('.js-cart-v2-switch-online h3', module.settings.containerElement).removeClass('is-active');
        $('.js-cart-v2-switch-store h3', module.settings.containerElement).addClass('is-active');

        $('.js-cart-v2-store', module.settings.containerElement).removeClass('u-hidden');
        $('.js-cart-v2-online', module.settings.containerElement).addClass('u-hidden');
      });

      $(module.settings.containerElement).on('click', '.js-cart-v2-switch-online', function (e) {
        e.preventDefault();

        $('.js-cart-v2-switch-online h3', module.settings.containerElement).addClass('is-active');
        $('.js-cart-v2-switch-store h3', module.settings.containerElement).removeClass('is-active');

        $('.js-cart-v2-store', module.settings.containerElement).addClass('u-hidden');
        $('.js-cart-v2-online', module.settings.containerElement).removeClass('u-hidden');
      });
    },

    closeCart: function (module) {
      $('.js-cart-v2', module.settings.containerElement).removeClass('is-open');
      electrolux.utils.toggleScroll(false);
		},
    
    showCart: function (module) {
      $('.js-cart-v2', module.settings.containerElement).addClass('is-open');
      electrolux.utils.toggleScroll(true);
    },
    
    toggleCart: function (module) {
      $('.js-cart-v2', module.settings.containerElement).toggleClass('is-open');
      electrolux.utils.toggleScroll(!!$('.js-cart-v2', module.settings.containerElement).hasClass('is-open'));
    },

    updateQuantity: function (module, quantity) {
      let $quantity = $('.js-quantity', $(module.settings.element));
      if (quantity > 0) {
        $quantity.html(quantity);
        $quantity.show();
      } else {
        $quantity.html(quantity);
        $quantity.hide();
      }
    },

    updateCart: function (module, code, quantity, storeId) {
      $.ajax({
        url: '/checkout/cart/update',
        type: 'POST',
        data: { code: code, quantity: quantity, storeId: storeId },
        dataType: 'json',
        success: function (data) {
          if (data.isSuccessful) {
            $(module.settings.containerElement).html(data.html);
            moduleObj.updateQuantity(module, data.items);
            moduleObj.showCart(module);
          }
        },
        error: function (request, error) {
          alert("Request: " + JSON.stringify(request));
        }
      });
		},

    loadCart: function (module) {
      $.ajax({
        url: '/checkout/cart',
        type: 'GET',
        dataType: 'json',
        success: function (data) {
          if (data.isSuccessful) {
            $(module.settings.containerElement).html(data.html);
            moduleObj.updateQuantity(module, data.items);
          } else {
            alert('not successful');
          }
        },
        error: function (request, error) {
          alert("Request: " + JSON.stringify(request));
        }
      });
		}
  });
})();
(function () {
	"use strict";

	var moduleObj = moduler('external-kitchen-visitor', {
		defaults: {},

		init: function (module) {
			debugger;
			let cookie = electrolux.utils.getCookie('_externalKitchen');
			if (cookie != null && !isKitchenPage) {
				electrolux.utils.removeCookie('_externalKitchen');
				window.location.href = window.location.href;
			}
		},

		listen: {},

		destroy: function (module) { }
	});

})();
(function () {
  'use strict';

  var moduleObj = moduler('kitchen-booking', {
    defaults: {
      serviceUrl: null,
      currentWeek: null,
			storeCardSelector: '.js-kitchen-booking-store-card',
			storeId: 0,
			contentId: 0,
			currentPageId: 0,
			onStorePage: false
    },
    storeId: 0,
    slotId: 0,
    init: function (module) {
			var self = this;
			if (module.settings.storeId > 0) {
				moduleObj.storeId = module.settings.storeId;
			}
      $('.js-kitchen-booking-section-type', module.$element).hide();

              $('.js-kitchen-booking-section-form', module.$element).html('"\u003cdiv class=\"u-marginBxlg\"\u003e\r\n\t\u003cdiv class=\"SplitBorder SplitBorder--center u-marginBsm\"\u003e\r\n\t\t\u003ch3 class=\"h3 u-colorBGWhite SplitBorder-text u-marginBz u-textUppercase\"\u003e\r\n\t\t\tFyll i dina uppgifter\r\n\t\t\u003c/h3\u003e\r\n\t\t\u003cspan class=\"SplitBorder-line SplitBorderLine--h3\"\u003e\u003c/span\u003e\r\n\t\u003c/div\u003e\r\n\u003c/div\u003e\r\n\u003cdiv class=\"Flex-column-reverse Grid Grid--equalHeight Grid--gutterA u-marginBxlg\"\u003e\r\n\t\u003cdiv class=\"Grid-cell u-sm-size1of2\"\u003e\r\n\t\t\u003cdiv class=\"Confirm-meeting-form\"\u003e\r\n\t\t\t\u003cp class=\"Text-Color-Grey\"\u003e\r\n\t\t\t\tFyll i dina uppgifter så kontaktar vi dig för att bekräfta mötet.\r\n\t\t\t\u003c/p\u003e\r\n\t\t\t\u003cform action=\"/misc/kitchenbooking/book\" method=\"post\" class=\"js-kitchen-booking-form\"\u003e\r\n\t\t\t\t\u003cinput name=\"__RequestVerificationToken\" type=\"hidden\" value=\"tpUQG12wbcqbyXJgSWVdOSJvUKeCviwigWPjhMPwaJrpBNPMfzzURyWICYPOP80a7VnvPXGdchrdEmsqnlV9BgXvs_c1\" /\u003e\r\n\t\t\t\t\u003cinput type=\"hidden\" name=\"storeId\" value=\"19841\" /\u003e\r\n\t\t\t\t\u003cinput type=\"hidden\" name=\"slotId\" value=\"112339\" /\u003e\r\n\t\t\t\t\u003cinput type=\"hidden\" name=\"contentId\" value=\"12652\" /\u003e\r\n\t\t\t\t\u003cinput type=\"hidden\" name=\"originPageName\" value=\"K\u0026#246;ksbokning online\" /\u003e\r\n\t\t\t\t\u003cdiv class=\"Form\"\u003e\r\n\t\t\t\t\t\u003cdiv class=\"Grid Grid--gutterAsm\"\u003e\r\n\t\t\t\t\t\t\u003cdiv class=\"Grid-cell u-md-size1of1 Form-item\"\u003e\r\n\t\t\t\t\t\t\t\u003clabel class=\"Form-label\"\u003eDitt namn\u003c/label\u003e\r\n\t\t\t\t\t\t\t\u003cinput type=\"text\" class=\"Form-field\" name=\"name\" placeholder=\"Ditt namn\" required\r\n\t\t\t\t\t\t\t\t\t\t oninvalid=\"this.setCustomValidity(\u0027Namn är obligatoriskt\u0027)\" oninput=\"this.setCustomValidity(\u0027\u0027)\" /\u003e\r\n\t\t\t\t\t\t\u003c/div\u003e\r\n\t\t\t\t\t\t\u003cdiv class=\"Grid-cell u-md-size1of2 Form-item u-sd-paddingBz\"\u003e\r\n\t\t\t\t\t\t\t\u003clabel class=\"Form-label\"\u003eDin e-postadress*\u003c/label\u003e\r\n\t\t\t\t\t\t\t\u003cinput class=\"Form-field js-email\" name=\"email\" placeholder=\"Din e-postadress\" type=\"email\" required\r\n\t\t\t\t\t\t\t\t\t\t oninvalid=\"this.setCustomValidity(\u0027E-postadress är obligatorisk\u0027)\"\r\n\t\t\t\t\t\t\t\t\t\t oninput=\"this.setCustomValidity(\u0027\u0027)\" /\u003e\r\n\t\t\t\t\t\t\u003c/div\u003e\r\n\t\t\t\t\t\t\u003cdiv class=\"Grid-cell u-md-size1of2 Form-item u-sd-paddingBz\"\u003e\r\n\t\t\t\t\t\t\t\u003clabel class=\"Form-label\"\u003eDitt telefonnummer\u003c/label\u003e\r\n\t\t\t\t\t\t\t\u003cinput class=\"Form-field\" name=\"phone\" placeholder=\"Ditt telefonnummer\" type=\"tel\" required\r\n\t\t\t\t\t\t\t\t\t\t oninvalid=\"this.setCustomValidity(\u0027Telefonnummer är obligatoriskt\u0027)\"\r\n\t\t\t\t\t\t\t\t\t\t oninput=\"this.setCustomValidity(\u0027\u0027)\" /\u003e\r\n\t\t\t\t\t\t\u003c/div\u003e\r\n\t\t\t\t\t\t\u003cdiv class=\"Grid-cell u-md-size1of1 Form-item u-sd-paddingBz\"\u003e\r\n\t\t\t\t\t\t\t\u003clabel class=\"Form-label\"\u003eMeddelande\u003c/label\u003e\r\n\t\t\t\t\t\t\t\u003ctextarea class=\"Form-field FormField--textarea\" cols=\"20\" name=\"message\" placeholder=\"Meddelande\"\r\n\t\t\t\t\t\t\t\t\t\t\t\trows=\"4\"\u003e\u003c/textarea\u003e\r\n\t\t\t\t\t\t\u003c/div\u003e\r\n\t\t\t\t\t\t\u003cdiv class=\"Grid-cell u-lg-size4of8 Form-controls\"\u003e\r\n\t\t\t\t\t\t\t\t\u003cinput type=\"checkbox\" class=\"Checkbox-input\" id=\"privacyPolicy\" name=\"privacyPolicy\" required\r\n\t\t\t\t\t\t\t\t\t\t\t oninvalid=\"this.setCustomValidity(\u0027Integritetspolicy måste godkännas\u0027)\"\r\n\t\t\t\t\t\t\t\t\t\t\t oninput=\"this.setCustomValidity(\u0027\u0027)\" /\u003e\r\n\t\t\t\t\t\t\t\t\u003cinput name=\"privacyPolicy\" type=\"hidden\" value=\"false\" /\u003e\r\n\t\t\t\t\t\t\t\t\u003clabel class=\"Checkbox-label\" for=\"privacyPolicy\"\u003e\r\n\t\t\t\t\t\t\t\t\tL\u0026#228;s v\u0026#229;ran integritetspolicy\r\n\t\t\t\t\t\t\t\t\u003c/label\u003e\r\n\t\t\t\t\t\t\t\t\u003ca class=\"u-linkBorder u-inlineBlock u-textSmall u-marginLmd\"\r\n\t\t\t\t\t\t\t\t\t href=\"/avtal/integritetspolicy/\" target=\"_blank\"\u003e\r\n\t\t\t\t\t\t\t\t\tLäs mer\r\n\t\t\t\t\t\t\t\t\u003c/a\u003e\r\n\t\t\t\t\t\t\u003c/div\u003e\r\n\t\t\t\t\t\t\u003cdiv class=\"Grid-cell u-lg-size4of8 Form-controls\"\u003e\r\n\t\t\t\t\t\t\t\u003cbutton type=\"submit\" class=\"Button Button--small Form-buttonRight\"\u003e\r\n\t\t\t\t\t\t\t\tSkicka bokningsförfrågan\r\n\t\t\t\t\t\t\t\u003c/button\u003e\r\n\t\t\t\t\t\t\u003c/div\u003e\r\n\t\t\t\t\t\t\u003cdiv class=\"js-kitchen-booking-form-error validation-summary-errors Status Status--warning\" style=\"display:none;\"\u003e\r\n\t\t\t\t\t\t\tN\u0026#229;got gick tyv\u0026#228;rr fel, v\u0026#228;nligen f\u0026#246;rs\u0026#246;k igen senare.\r\n\t\t\t\t\t\t\u003c/div\u003e\r\n\t\t\t\t\t\u003c/div\u003e\r\n\t\t\t\t\u003c/div\u003e\r\n\t\t\t\u003c/form\u003e\r\n\t\t\u003c/div\u003e\r\n\t\u003c/div\u003e\r\n\t\u003cdiv class=\"Grid-cell u-sm-size1of2\"\u003e\r\n\t\t\u003cdiv class=\"Flex-container-center\"\u003e\r\n\t\t\t\u003cdiv class=\"Booking-confirmation\"\u003e\r\n\t\t\t\t\u003ch3\u003eSammanställning\u003c/h3\u003e\r\n\t\t\t\t\u003cdiv class=\"Content-wrapper\"\u003e\r\n\t\t\t\t\t\u003ch4\u003eVald butik\u003c/h4\u003e\r\n\t\t\t\t\t\u003cp class=\"Text-Color-Grey\"\u003eStockholm/T\u0026#228;by Fogdev\u0026#228;gen 1\u003c/p\u003e\r\n\t\t\t\t\t\r\n\t\t\t\t\t\u003ch4\u003eDatum\u003c/h4\u003e\r\n\t\t\t\t\t\u003cp class=\"Text-Color-Grey\"\u003e\r\n\t\t\t\t\t\ttorsdag 26 juni 2025\r\n\t\t\t\t\t\u003c/p\u003e\r\n\t\t\t\t\t\u003ch4\u003eTid\u003c/h4\u003e\r\n\t\t\t\t\t\u003cp class=\"Text-Color-Grey\"\u003e09:30 - 11:00\u003c/p\u003e\r\n\t\t\t\t\u003c/div\u003e\r\n\t\t\t\u003c/div\u003e\r\n\t\t\u003c/div\u003e\r\n\t\u003c/div\u003e\r\n\r\n\u003c/div\u003e\r\n"');


      $(module.$element).on('click', '.js-kitchen-booking-store-map-button', function (e) {
        $('.js-kitchen-booking-store-view-map', module.$element).show();
        $('.js-kitchen-booking-store-view-list', module.$element).hide();

        $('.js-kitchen-booking-store-list-button').addClass('Button--inverted');
        $('.js-kitchen-booking-store-map-button').removeClass('Button--inverted');
      });

      $(module.$element).on('click', '.js-kitchen-booking-store-list-button', function (e) {
        $('.js-kitchen-booking-store-view-map', module.$element).hide();
        $('.js-kitchen-booking-store-view-list', module.$element).show();

        $('.js-kitchen-booking-store-map-button').addClass('Button--inverted');
        $('.js-kitchen-booking-store-list-button').removeClass('Button--inverted');
      });

      $(module.$element).on('click', '.js-kitchen-booking-store-button', function (e) {
        e.preventDefault();
        moduleObj.storeId = $(this).data('storeid');
        $('.js-kitchen-booking-store-button').removeClass('Selected');
        $(this).addClass('Selected');
        $('.js-kitchen-booking-section-form', module.$element).hide();
        moduleObj.updateTimeSlots(module, module.settings.currentWeek);
        window.setTimeout(function () {
          moduleObj.smoothScroll(module, '.js-kitchen-booking-section-time-slot');
        }, $('.js-kitchen-booking-date-column').length > 0 ? 0 : 300);
      });

      $(module.$element).on('keyup', '.js-kitchen-booking-search-input', function (e) {
        let query = $('.js-kitchen-booking-search-input').val().toLowerCase();
        if (query.length > 0) {
          let hits = 0;
          $('.js-kitchen-booking-search-info').each(function (index, value) {
            if ($(value).text().toLowerCase().indexOf(query) == -1) {
              $(value).closest(module.settings.storeCardSelector).addClass('u-hidden');
            } else {
              hits++;
              $(value).closest(module.settings.storeCardSelector).removeClass('u-hidden');
            }
          });
          if (hits == 0) {
            $('.js-kitchen-booking-search-no-result').removeClass('u-hidden');
          } else {
            $('.js-kitchen-booking-search-no-result').addClass('u-hidden');
          }
        } else {
          $(module.settings.storeCardSelector).removeClass('u-hidden');
          $('.js-kitchen-booking-search-no-result').addClass('u-hidden');
        }
      });

      $(module.$element).on('click', '.js-kitchen-booking-previous-week, .js-kitchen-booking-next-week', function (e) {
        e.preventDefault();
        moduleObj.updateTimeSlots(module, $(this).data('date'));
      });

      $(module.$element).on('click', '.js-kitchen-booking-slot-button', function (e) {
        e.preventDefault();
        $('.js-kitchen-booking-slot-button').removeClass('Selected');
        $(this).addClass('Selected');
        moduleObj.slotId = $(this).data('slotid');
        moduleObj.loadForm(module);
      });

      $(module.$element).on('click', '.js-kitchen-booking-store-list-load-more', function (e) {
        e.preventDefault();
        $('.js-kitchen-booking-store-card:hidden:lt(9)').show();
        if ($('.js-kitchen-booking-store-card:hidden').length == 0) {
          $('.js-kitchen-booking-store-list-load-more').hide();
        }
      });

      $(document).on('map-marker-selected', function (e) {
        e.preventDefault();
        $('.js-kitchen-booking-section-time-slot', module.$element).html('');
        $('.js-kitchen-booking-section-form', module.$element).html('');
      });

      $(module.$element).on('submit', 'form.js-kitchen-booking-form', function (e) {
        $('.js-kitchen-booking-form-error').hide();
        e.preventDefault();
        $.post(module.settings.serviceUrl + 'book', $(this).serialize(), function (data) {
          if (data.success) {
						if (data.url != '') {
							window.setTimeout(function () {
								location.href = data.url;
							}, 350);
            } else {
              $('.js-kitchen-booking-section-time-slot', module.$element).html('');
              $('.js-kitchen-booking-section-form', module.$element).html('');
              $('.js-kitchen-booking-section-store').hide();
              $('.js-kitchen-booking-section-confirmation', module.$element).html(data.html);
            }
          } else {
            $('.js-kitchen-booking-form-error').show();
          }
        });
      });
			//moduleObj.updateStoreList(module);
			if (module.settings.onStorePage && module.settings.storeId > 0) {
				moduleObj.updateTimeSlots(module, module.settings.currentWeek);
			} else {
				moduleObj.loadStoreList(module);
				if (module.settings.storeId > 0) {
					let failSafe = 0;
					let intervalHandler = setInterval(function () {
						failSafe++;
						if ($('.js-kitchen-booking-store-button[data-storeid=' + module.settings.storeId + ']', module.$element).length > 0) {
							$('.js-kitchen-booking-store-button[data-storeid=' + module.settings.storeId + ']', module.$element).trigger('click');
							clearInterval(intervalHandler);
						} else if (failSafe > 100) {
							clearInterval(intervalHandler);
						}
					}, 100);
				}
			}
    },

    smoothScroll: function (module, selector) {
      if (selector.startsWith('.')) {
        selector = selector.slice(1);
      }
      var elements = document.getElementsByClassName(selector);
      if (elements.length > 0) {
        var element = elements[0];
        element.scrollIntoView({ behavior: 'smooth' });
      }
		},

		loadStoreList: function (module) {
			$.getJSON(module.settings.serviceUrl + 'index?contentId=' + module.settings.contentId + '&_' + new Date().getTime(), function (data) {
				$('.js-kitchen-booking-section-main', module.$element).html(data.html);
				$('.js-kitchen-booking-section-main', module.$element).show();
			});
		},

		loadForm: function (module) {
			$.getJSON(module.settings.serviceUrl + 'loadform?contentId=' + module.settings.contentId + '&storeId=' + moduleObj.storeId + '&slotid=' + moduleObj.slotId + '&currentPageId=' + module.settings.currentPageId + '&_' + new Date().getTime(), function (data) {
        $('.js-kitchen-booking-section-form', module.$element).html('"\u003cdiv class=\"u-marginBxlg\"\u003e\r\n\t\u003cdiv class=\"SplitBorder SplitBorder--center u-marginBsm\"\u003e\r\n\t\t\u003ch3 class=\"h3 u-colorBGWhite SplitBorder-text u-marginBz u-textUppercase\"\u003e\r\n\t\t\tFyll i dina uppgifter\r\n\t\t\u003c/h3\u003e\r\n\t\t\u003cspan class=\"SplitBorder-line SplitBorderLine--h3\"\u003e\u003c/span\u003e\r\n\t\u003c/div\u003e\r\n\u003c/div\u003e\r\n\u003cdiv class=\"Flex-column-reverse Grid Grid--equalHeight Grid--gutterA u-marginBxlg\"\u003e\r\n\t\u003cdiv class=\"Grid-cell u-sm-size1of2\"\u003e\r\n\t\t\u003cdiv class=\"Confirm-meeting-form\"\u003e\r\n\t\t\t\u003cp class=\"Text-Color-Grey\"\u003e\r\n\t\t\t\tFyll i dina uppgifter så kontaktar vi dig för att bekräfta mötet.\r\n\t\t\t\u003c/p\u003e\r\n\t\t\t\u003cform action=\"/misc/kitchenbooking/book\" method=\"post\" class=\"js-kitchen-booking-form\"\u003e\r\n\t\t\t\t\u003cinput name=\"__RequestVerificationToken\" type=\"hidden\" value=\"tpUQG12wbcqbyXJgSWVdOSJvUKeCviwigWPjhMPwaJrpBNPMfzzURyWICYPOP80a7VnvPXGdchrdEmsqnlV9BgXvs_c1\" /\u003e\r\n\t\t\t\t\u003cinput type=\"hidden\" name=\"storeId\" value=\"19841\" /\u003e\r\n\t\t\t\t\u003cinput type=\"hidden\" name=\"slotId\" value=\"112339\" /\u003e\r\n\t\t\t\t\u003cinput type=\"hidden\" name=\"contentId\" value=\"12652\" /\u003e\r\n\t\t\t\t\u003cinput type=\"hidden\" name=\"originPageName\" value=\"K\u0026#246;ksbokning online\" /\u003e\r\n\t\t\t\t\u003cdiv class=\"Form\"\u003e\r\n\t\t\t\t\t\u003cdiv class=\"Grid Grid--gutterAsm\"\u003e\r\n\t\t\t\t\t\t\u003cdiv class=\"Grid-cell u-md-size1of1 Form-item\"\u003e\r\n\t\t\t\t\t\t\t\u003clabel class=\"Form-label\"\u003eDitt namn\u003c/label\u003e\r\n\t\t\t\t\t\t\t\u003cinput type=\"text\" class=\"Form-field\" name=\"name\" placeholder=\"Ditt namn\" required\r\n\t\t\t\t\t\t\t\t\t\t oninvalid=\"this.setCustomValidity(\u0027Namn är obligatoriskt\u0027)\" oninput=\"this.setCustomValidity(\u0027\u0027)\" /\u003e\r\n\t\t\t\t\t\t\u003c/div\u003e\r\n\t\t\t\t\t\t\u003cdiv class=\"Grid-cell u-md-size1of2 Form-item u-sd-paddingBz\"\u003e\r\n\t\t\t\t\t\t\t\u003clabel class=\"Form-label\"\u003eDin e-postadress*\u003c/label\u003e\r\n\t\t\t\t\t\t\t\u003cinput class=\"Form-field js-email\" name=\"email\" placeholder=\"Din e-postadress\" type=\"email\" required\r\n\t\t\t\t\t\t\t\t\t\t oninvalid=\"this.setCustomValidity(\u0027E-postadress är obligatorisk\u0027)\"\r\n\t\t\t\t\t\t\t\t\t\t oninput=\"this.setCustomValidity(\u0027\u0027)\" /\u003e\r\n\t\t\t\t\t\t\u003c/div\u003e\r\n\t\t\t\t\t\t\u003cdiv class=\"Grid-cell u-md-size1of2 Form-item u-sd-paddingBz\"\u003e\r\n\t\t\t\t\t\t\t\u003clabel class=\"Form-label\"\u003eDitt telefonnummer\u003c/label\u003e\r\n\t\t\t\t\t\t\t\u003cinput class=\"Form-field\" name=\"phone\" placeholder=\"Ditt telefonnummer\" type=\"tel\" required\r\n\t\t\t\t\t\t\t\t\t\t oninvalid=\"this.setCustomValidity(\u0027Telefonnummer är obligatoriskt\u0027)\"\r\n\t\t\t\t\t\t\t\t\t\t oninput=\"this.setCustomValidity(\u0027\u0027)\" /\u003e\r\n\t\t\t\t\t\t\u003c/div\u003e\r\n\t\t\t\t\t\t\u003cdiv class=\"Grid-cell u-md-size1of1 Form-item u-sd-paddingBz\"\u003e\r\n\t\t\t\t\t\t\t\u003clabel class=\"Form-label\"\u003eMeddelande\u003c/label\u003e\r\n\t\t\t\t\t\t\t\u003ctextarea class=\"Form-field FormField--textarea\" cols=\"20\" name=\"message\" placeholder=\"Meddelande\"\r\n\t\t\t\t\t\t\t\t\t\t\t\trows=\"4\"\u003e\u003c/textarea\u003e\r\n\t\t\t\t\t\t\u003c/div\u003e\r\n\t\t\t\t\t\t\u003cdiv class=\"Grid-cell u-lg-size4of8 Form-controls\"\u003e\r\n\t\t\t\t\t\t\t\t\u003cinput type=\"checkbox\" class=\"Checkbox-input\" id=\"privacyPolicy\" name=\"privacyPolicy\" required\r\n\t\t\t\t\t\t\t\t\t\t\t oninvalid=\"this.setCustomValidity(\u0027Integritetspolicy måste godkännas\u0027)\"\r\n\t\t\t\t\t\t\t\t\t\t\t oninput=\"this.setCustomValidity(\u0027\u0027)\" /\u003e\r\n\t\t\t\t\t\t\t\t\u003cinput name=\"privacyPolicy\" type=\"hidden\" value=\"false\" /\u003e\r\n\t\t\t\t\t\t\t\t\u003clabel class=\"Checkbox-label\" for=\"privacyPolicy\"\u003e\r\n\t\t\t\t\t\t\t\t\tL\u0026#228;s v\u0026#229;ran integritetspolicy\r\n\t\t\t\t\t\t\t\t\u003c/label\u003e\r\n\t\t\t\t\t\t\t\t\u003ca class=\"u-linkBorder u-inlineBlock u-textSmall u-marginLmd\"\r\n\t\t\t\t\t\t\t\t\t href=\"/avtal/integritetspolicy/\" target=\"_blank\"\u003e\r\n\t\t\t\t\t\t\t\t\tLäs mer\r\n\t\t\t\t\t\t\t\t\u003c/a\u003e\r\n\t\t\t\t\t\t\u003c/div\u003e\r\n\t\t\t\t\t\t\u003cdiv class=\"Grid-cell u-lg-size4of8 Form-controls\"\u003e\r\n\t\t\t\t\t\t\t\u003cbutton type=\"submit\" class=\"Button Button--small Form-buttonRight\"\u003e\r\n\t\t\t\t\t\t\t\tSkicka bokningsförfrågan\r\n\t\t\t\t\t\t\t\u003c/button\u003e\r\n\t\t\t\t\t\t\u003c/div\u003e\r\n\t\t\t\t\t\t\u003cdiv class=\"js-kitchen-booking-form-error validation-summary-errors Status Status--warning\" style=\"display:none;\"\u003e\r\n\t\t\t\t\t\t\tN\u0026#229;got gick tyv\u0026#228;rr fel, v\u0026#228;nligen f\u0026#246;rs\u0026#246;k igen senare.\r\n\t\t\t\t\t\t\u003c/div\u003e\r\n\t\t\t\t\t\u003c/div\u003e\r\n\t\t\t\t\u003c/div\u003e\r\n\t\t\t\u003c/form\u003e\r\n\t\t\u003c/div\u003e\r\n\t\u003c/div\u003e\r\n\t\u003cdiv class=\"Grid-cell u-sm-size1of2\"\u003e\r\n\t\t\u003cdiv class=\"Flex-container-center\"\u003e\r\n\t\t\t\u003cdiv class=\"Booking-confirmation\"\u003e\r\n\t\t\t\t\u003ch3\u003eSammanställning\u003c/h3\u003e\r\n\t\t\t\t\u003cdiv class=\"Content-wrapper\"\u003e\r\n\t\t\t\t\t\u003ch4\u003eVald butik\u003c/h4\u003e\r\n\t\t\t\t\t\u003cp class=\"Text-Color-Grey\"\u003eStockholm/T\u0026#228;by Fogdev\u0026#228;gen 1\u003c/p\u003e\r\n\t\t\t\t\t\r\n\t\t\t\t\t\u003ch4\u003eDatum\u003c/h4\u003e\r\n\t\t\t\t\t\u003cp class=\"Text-Color-Grey\"\u003e\r\n\t\t\t\t\t\ttorsdag 26 juni 2025\r\n\t\t\t\t\t\u003c/p\u003e\r\n\t\t\t\t\t\u003ch4\u003eTid\u003c/h4\u003e\r\n\t\t\t\t\t\u003cp class=\"Text-Color-Grey\"\u003e09:30 - 11:00\u003c/p\u003e\r\n\t\t\t\t\u003c/div\u003e\r\n\t\t\t\u003c/div\u003e\r\n\t\t\u003c/div\u003e\r\n\t\u003c/div\u003e\r\n\r\n\u003c/div\u003e\r\n"');
        $('.js-kitchen-booking-section-form', module.$element).show();
      });
    },

    updateStoreList: function (module) {
      if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(function (position) {
					$.getJSON(module.settings.serviceUrl + 'storelist?contentId=' + module.settings.contentId + '&longitude=' + position.coords.longitude + '&latitude=' + position.coords.latitude, function (data) {
            $('.js-kitchen-booking-store-list', module.$element).html(data.html);
          });
        });
      }
    },

    updateTimeSlots: function (module, date) {
			$.getJSON(module.settings.serviceUrl + 'loadcalendar?contentId=' + module.settings.contentId + '&storeId=' + moduleObj.storeId + '&startDate=' + date + "&_" + new Date().getTime(), function (data) {
        $('.js-kitchen-booking-section-time-slot', module.$element).html(data.html);
      });
    },

    listen: {},

    destroy: function (module) {},
  });
})();

//(function () {
//	"use strict";

//	var moduleObj = moduler('store-stock', {
//		defaults: {
//			serviceUrl: '/misc/stock'
//		},

//		init: function (module) {
//			$(document).on(electrolux.events.selectedStoreChanged, function () {
//				$('.js-store-stock').each(function (index, value) {
//					$(value).data('store-stock-loaded', false);
//				});
//				$(document).trigger('load-store-stock');
//			});

//			$(document).on('load-store-stock', function () {
//				let productCodes = [];
//				$('.js-store-stock').each(function (index, value) {
//					let code = $(value).data('code');
//					if ($(value).data('store-stock-loaded') != true) {
//						if (code != null) {
//							productCodes.push(code);
//						}
//					}
//				});
//				if (productCodes.length > 0) {
//					$.ajax({
//						url: module.settings.serviceUrl,
//						cache: false,
//						method: 'POST',
//						data: { codes: productCodes }
//					}).done(function (response) {
//						if (response.success) {
//							$(response.stockInfo).each(function (index, value) {
//								let element = $('.js-store-stock[data-code=' + value.code + ']');
//								$(element).data('store-stock-loaded', true);
//								$(element).html(value.html);
//							});
//						}
//					});
//				}
//			});
//			$(document).trigger('load-store-stock');
//		},

//		listen: {},

//		destroy: function (module) { }
//	});

//})();
(function () {
  "use strict";

	var moduleObj = moduler('store-selector', {
		defaults: {
			trigger: '.js-store-selector-trigger',
			container: '.js-store-selector-container',
			storeCardSelector: '.js-store-selector-store-card',
			event: 'click',
			serviceUrl: '/misc/storeselector'
		},
		toggleScrollChanged: true,
		searchDebounsTimeoutHandler: null,
		releaseTrap: null,
    init: function (module) {
      moduleObj.loadStoreInMenu(module);

			$('body').on('click', function (e) {
				let $target = e.target != null ? $(e.target) : $(this);
				if ($(module.settings.container).hasClass('StoreSelector--is-open') && $target.closest(module.settings.container).length == 0) {
					moduleObj.closeStoreSelector(module);
				}
			});

			$(document).on('click', '.js-store-selector-no-change', function (e) {
				e.stopPropagation();
			});

			$(module.settings.container).on('click', '.js-store-selector-switch-to-home', function (e) {
				$('.js-store-selector-home-list', module.element).removeClass('u-hidden');
				$('.js-store-selector-home-list', module.element).addClass('u-flex');

				$('.js-store-selector-shop-list', module.element).addClass('u-hidden');
				$('.js-store-selector-shop-list', module.element).removeClass('u-flex');

				$('.js-store-selector-switch-to-home', module.element).addClass('Button--inverted');
				$('.js-store-selector-switch-to-shop', module.element).removeClass('Button--inverted');
			});

			$(module.settings.container).on('click', '.js-store-selector-switch-to-shop', function (e) {
				$('.js-store-selector-home-list', module.element).addClass('u-hidden');
				$('.js-store-selector-home-list', module.element).removeClass('u-flex');

				$('.js-store-selector-shop-list', module.element).removeClass('u-hidden');
				$('.js-store-selector-shop-list', module.element).addClass('u-flex');

				$('.js-store-selector-switch-to-home', module.element).removeClass('Button--inverted');
				$('.js-store-selector-switch-to-shop', module.element).addClass('Button--inverted');			
			});

      $(document).on(module.settings.event, module.settings.trigger, function (e) {
        e.preventDefault();
        moduleObj.loadStoreList(module);
        moduleObj.toggleStoreSelector(module);
      });

      $(module.settings.container).on('click', '.js-store-selector-close', function (e) {
        e.preventDefault();
        moduleObj.closeStoreSelector(module);
      });

		$(document).on('click', module.settings.storeCardSelector, function (e) {
        let storeId = $(this).data('id');
        $.ajax({
          url: module.settings.serviceUrl + '/selectstore',
          cache: false,
          method: 'POST',
          data: { storeId: storeId }
        }).done(function (response) {
          if (response.Success) {
            moduleObj.loadStoreList(module);
            moduleObj.loadStoreInMenu(module);
            moduleObj.closeStoreSelector(module);
          }
        });
      });

			$(module.settings.container).on('keyup', '.js-store-selector-search-input', function (e) {
				if (e.which <= 90 && e.which >= 48 || e.which >= 96 && e.which <= 105) {
					if (moduleObj.searchDebounsTimeoutHandler != null) {
						clearTimeout(moduleObj.searchDebounsTimeoutHandler);
					}
					moduleObj.searchDebounsTimeoutHandler = setTimeout(() => {
						let query = $('.js-store-selector-search-input').val().toLowerCase();
						$('.js-store-selector-loader').removeClass('u-hidden');
						$('.js-store-selector-store-container').addClass('u-hidden');
						moduleObj.searchStoreGoogle(query);
						setTimeout(() => {
							$('.js-store-selector-store-container').removeClass('u-hidden');
							$('.js-store-selector-loader').addClass('u-hidden');
						}, 500);
					}, 500);
				}
			});

			$(module.settings.container).on('keyup', '.js-store-selector-shop-search-input', function (e) {
				if (e.which <= 90 && e.which >= 48 || e.which >= 96 && e.which <= 105) {
					if (moduleObj.searchDebounsTimeoutHandler != null) {
						clearTimeout(moduleObj.searchDebounsTimeoutHandler);
					}
					moduleObj.searchDebounsTimeoutHandler = setTimeout(() => {
						let query = $('.js-store-selector-shop-search-input').val().toLowerCase();
						$('.js-store-selector-shop-loader').removeClass('u-hidden');
						$('.js-store-selector-shop-store-container').addClass('u-hidden');
						moduleObj.searchShop(module, query);
						setTimeout(() => {
							$('.js-store-selector-shop-store-container').removeClass('u-hidden');
							$('.js-store-selector-shop-loader').addClass('u-hidden');
						}, 500);
					}, 500);
				}
			});
		},

		searchShop: function (module, query) {
			if (query.length > 2) {
				let hits = 0;
				$('.js-store-selector-shop-store-card-search-content').each(function (index, value) {
					if ($(value).text().toLowerCase().indexOf(query) == -1) {
						$(value).closest(module.settings.storeCardSelector).addClass('u-hidden');
					} else {
						$(value).closest(module.settings.storeCardSelector).removeClass('u-hidden');
						hits++;
					}
				});
				if (hits == 0) {
					$('.js-store-selector-shop-no-result').removeClass('u-hidden');
				} else {
					$('.js-store-selector-shop-no-result').addClass('u-hidden');
				}
			} else {
				$(module.settings.storeCardSelector).removeClass('u-hidden');
				$('.js-store-selector-shop-no-result').addClass('u-hidden');
			}
		},

		searchStoreGoogle: function (query) {
			if (query.length > 2) {
				const geocoder = new google.maps.Geocoder();
				geocoder.geocode({
					address: query,
					componentRestrictions: {
						country: 'SE',
					}
				}, function (results, status) {
					if (status == 'OK') {
						let postalCodeLngLat = results[0].geometry.location;
						let $sortedItems;
						let getSorted = function () {
							return $(
								$('.js-store-selector-store-container .js-store-selector-store-card').toArray().sort(function (a, b) {
									let storeCoordinates = $(a).data("coordinates").split(',');
									let distance = electrolux.utils.calculateDistance(postalCodeLngLat.lat(), postalCodeLngLat.lng(), storeCoordinates[0], storeCoordinates[1]);
									storeCoordinates = $(b).data("coordinates").split(',');
									let distance2 = electrolux.utils.calculateDistance(postalCodeLngLat.lat(), postalCodeLngLat.lng(), storeCoordinates[0], storeCoordinates[1]);
									return distance - distance2;
								}));
						};
						$sortedItems = getSorted().clone();
						$('.js-store-selector-store-container').html($sortedItems);
					}
				})
			} else {
				let $sortedItems;
				let getSorted = function () {
					return $(
						$('.js-store-selector-store-container .js-store-selector-store-card').toArray().sort(function (a, b) {
							if ($(a).data('name') < $(b).data('name')) {
								return -1;
							}
							if ($(a).data('name') > $(b).data('name')) {
								return 1;
							}
							return 0;
						}));
				};
				$sortedItems = getSorted().clone();
				$('.js-store-selector-store-container').html($sortedItems);
			}
		},

	loadStoreInMenu: function (module) {
      let storeId = electrolux.utils.getSelectedStoreId();
      if (storeId != null) {
        $.ajax({
          url: module.settings.serviceUrl + '/SelectedStoreHeading',
          cache: false,
          method: 'GET',
          data: { storeId: storeId }
        }).done(function (response) {
          if (response.Success) {
            $('.js-our-stores-selected-store').html(response.Html);
			$('.js-our-stores-index-link').remove();
			$('.js-product-list-selected-store .js-product-list-selected-store-name').html(response.Store);
			$('.js-product-list-selected-store').removeClass('u-hidden');
          }
        });
      }
		},

    loadStoreList: function (module) {
      $.ajax({
        url: module.settings.serviceUrl,
        cache: false,
        method: 'GET'
      }).done(function (response) {
        if (response.Success) {
          $(module.settings.container).html(response.Html);
        }
      });
	},
    
	closeStoreSelector: function (module) {
		$("main").removeAttr("tabindex", "-1");
		$("main").removeAttr("aria-hidden");
		$('.js-store-selector-container').removeClass('StoreSelector--is-open');
		if (moduleObj.toggleScrollChanged) {
			electrolux.utils.toggleScroll(false);
		}
		moduleObj.releaseTrap.release();
	},
    
    showStoreSelector: function (module) {
      $('.js-store-selector-container').addClass('StoreSelector--is-open');
      electrolux.utils.toggleScroll(true);
    },
    

	toggleStoreSelector: function (module) {
		$("main").attr("aria-hidden", "true");
		$("main").attr("tabindex", "-1");
		$('.js-store-selector-container').toggleClass('StoreSelector--is-open');
		moduleObj.toggleScrollChanged = electrolux.utils.toggleScroll($('.js-store-selector-container').hasClass('StoreSelector--is-open'));
		setTimeout(() => {
			moduleObj.trapFocus($('.js-store-selector-container'));
		}, 400);	
	},

	trapFocus: function (element) {
		moduleObj.releaseTrap = trapFocus(element);
	}

  });
})();



function trapFocus(element) {
	const focusables = Array.from(
		element.find('a.all-butik-link, button.js-store-selector-store-card, button.js-store-selector-close, button.Tabs-item, input.js-store-selector-search-input, a.js-store-selector-no-change')
	);

	const firstFocusableEl = focusables[0];
	const lastFocusableEl = focusables.at(-1);

	// Store the element that had focus before the modal was opened
	const previousFocus = document.activeElement;

	// Set focus to first element
	firstFocusableEl.focus();

	function handleKeyDown(e) {
		if (e.key === 'Tab') {
			// If shift + tab and focus is on first element, move to last element
			if (e.shiftKey && document.activeElement === firstFocusableEl) {
				e.preventDefault();
				lastFocusableEl.focus();
			}
			// If tab and focus is on last element, move to first element
			else if (!e.shiftKey && document.activeElement === lastFocusableEl) {
				e.preventDefault();
				firstFocusableEl.focus();
			}
		}
	}

	// Add event listener for keydown
	element.on('keydown', handleKeyDown);

	// Return cleanup function
	return {
		release: () => {
			element.off('keydown', handleKeyDown);
			// Return focus to element that had it before modal opened
			previousFocus.focus(); 
		}
	};
}

(function () {
  "use strict";

  var moduleObj = moduler('store-stock-info', {
    defaults: {
      trigger: '.js-store-stock-info-trigger',
      container: '.js-store-stock-info-container',
      storeCardSelector: '.js-store-stock-info-card',
      event: 'click',
			serviceUrl: '/misc/storeselector'
		},

    init: function (module) {
      $('body').on('click', function () {
        if ($(module.settings.container).hasClass('StoreSelector--is-open') && $(this).closest(module.settings.container).length == 0) {
          moduleObj.closeStoreStockInfo(module);
        }
      });

			$(document).on(module.settings.event, module.settings.trigger, function (e) {
				let code = $(this).data('code');
        moduleObj.loadStoreList(module, code);
      });

      $(module.settings.container).on('click', '.js-store-stock-info-close', function (e) {
        e.preventDefault();
        moduleObj.closeStoreStockInfo(module);
      });

      $(document).on('click', module.settings.storeCardSelector, function (e) {
        let storeId = $(this).data('id');
        $.ajax({
          url: module.settings.serviceUrl + '/selectstore',
          cache: false,
          method: 'POST',
          data: { storeId: storeId }
        }).done(function (response) {
          if (response.Success) {
            moduleObj.loadStoreInMenu(module);
						moduleObj.closeStoreStockInfo(module);
						$(document).trigger(electrolux.events.selectedStoreChanged);
          }
        });
      });

      $(module.settings.container).on('keyup', '.js-store-stock-info-search-input', function (e) {
        let query = $('.js-store-stock-info-search-input').val().toLowerCase();
        if (query.length > 0) {
          let hits = 0;
          $('.js-store-stock-info-card-search-content').each(function (index, value) {
            if ($(value).text().toLowerCase().indexOf(query) == -1) {
              $(value).closest(module.settings.storeCardSelector).addClass('u-hidden');
            } else {
              hits++;
              $(value).closest(module.settings.storeCardSelector).removeClass('u-hidden');
            }
          });
          $('.js-store-stock-info-heading').addClass('u-hidden');
          if (hits == 0) {
            $('.js-store-stock-info-no-result').removeClass('u-hidden');
          } else {
            $('.js-store-stock-info-no-result').addClass('u-hidden');
                    }
        } else {
          $(module.settings.storeCardSelector).removeClass('u-hidden');
          $('.js-store-stock-info-heading').removeClass('u-hidden');
          $('.js-store-stock-info-no-result').addClass('u-hidden');
        }
      });
    },

    loadStoreInMenu: function (module) {
      let storeId = electrolux.utils.getSelectedStoreId();
      if (storeId != null) {
        $.ajax({
          url: module.settings.serviceUrl + '/SelectedStoreHeading',
          cache: false,
          method: 'GET',
          data: { storeId: storeId }
        }).done(function (response) {
          if (response.Success) {
            $('.js-our-stores-selected-store').html(response.Html);
						$('.js-our-stores-index-link').remove();
						$('.js-product-list-selected-store .js-product-list-selected-store-name').html(response.Store);
						$('.js-product-list-selected-store').removeClass('u-hidden');
          }
        });
      }
    },

    loadStoreList: function (module, code) {
      $.ajax({
        url: module.settings.serviceUrl + '/StoreStockInfo',
        cache: false,
				method: 'GET',
				data: { code: code }
      }).done(function (response) {
				if (response.Success) {
					$(module.settings.container).html(response.Html);
          moduleObj.toggleStoreStockInfo(module);
        }
      });
    },

    closeStoreStockInfo: function (module) {
      $('.js-store-stock-info-container').removeClass('StoreSelector--is-open');
      electrolux.utils.toggleScroll(false);

        },
    
    showStoreStockInfo: function (module) {
      $('.js-store-stock-info-container').addClass('StoreSelector--is-open');
      electrolux.utils.toggleScroll(true);
    },
    
    toggleStoreStockInfo: function (module) {
      $('.js-store-stock-info-container').toggleClass('StoreSelector--is-open');
      // toggle scroll if closing store selector  
    },
  });
})();
(function () {
	"use strict";

	var moduleObj = moduler('store-stock', {
		defaults: {
			serviceUrl: '/misc/stock'
		},

		init: function (module) {
			$(document).on(electrolux.events.selectedStoreChanged, function () {
				$('.js-store-stock').each(function (index, value) {
					$(value).data('store-stock-loaded', false);
				});
				$(document).trigger('load-store-stock');
			});

			$(document).on('load-store-stock', function () {
				let productCodes = [];
				$('.js-store-stock').each(function (index, value) {
					let code = $(value).data('code');
					if ($(value).data('store-stock-loaded') != true) {
						if (code != null) {
							productCodes.push(code);
						}
					}
				});
				if (productCodes.length > 0) {
					$.ajax({
						url: module.settings.serviceUrl,
						cache: false,
						method: 'POST',
						data: { codes: productCodes }
					}).done(function (response) {
						if (response.success) {
							$(response.stockInfo).each(function (index, value) {
								let element = $('.js-store-stock[data-code=' + value.code + ']');
								$(element).data('store-stock-loaded', true);
								$(element).html(value.html);
							});
						}
					});
				}
			});
			$(document).trigger('load-store-stock');
		},

		listen: {},

		destroy: function (module) { }
	});

})();
(function () {
  "use strict";

  var moduleObj = moduler('checkout-v3-additional-services', {
    defaults: {
    },
    endpoint: 'additionalservices',
    init: function (module) {
      $(module.$element).on('click', '.js-additions-submit', function (e) {
        e.preventDefault();
        electrolux.checkout.submitStep(module, moduleObj.endpoint);
      });

      $(module.$element).on('click', '.js-change', function (e) {
        e.preventDefault();
        electrolux.checkout.loadStep(module, moduleObj.endpoint);
      });

      $(document).on(electrolux.events.checkoutV3LoadAdditionalServices, function (e) {
        electrolux.checkout.loadStep(module, moduleObj.endpoint);
      });

      $(module.$element).on('click', 'input[type=checkbox].js-additional-services-checkbox', function (e) {
        let $checkbox = $(this);
        let $list = $checkbox.closest('.js-additional-services-checkbox-list');
        $('.js-additional-services-checkbox', $list).each(function (index, item) {
          if (!$(item).is($checkbox)) {
            $(item).prop('checked', false);
					}
        });
      });
    },
  });
})();
(function () {
  "use strict";

  var moduleObj = moduler('checkout-v3-address', {
    defaults: {
    },
    endpoint:'address',
    init: function (module) {
      $(module.$element).on('click', '.js-address-load', function (e) {
        e.preventDefault();
        electrolux.checkout.loadStep(module, moduleObj.endpoint);
      });

      $(module.$element).on('click', '.js-address-submit', function (e) {
        e.preventDefault();
        electrolux.checkout.submitStep(module, moduleObj.endpoint);
      });

      $(module.$element).on('change', '.js-address-toggle-address', function (e) {
        e.preventDefault();
        $('.js-address-billing', module.$element).toggleClass('u-hidden');
      });

      $(module.$element).on('click', '.js-change', function (e) {
        e.preventDefault();
        electrolux.checkout.loadStep(module, moduleObj.endpoint);
      });

      //$(module.$element).on('click', '.js-address-manual-address', function (e) {
      //  e.preventDefault();
      //  let data = $('form', module.$element).serialize();
      //  electrolux.checkout.postData(module, "address/manualaddress", data);
      //});

      //$(module.$element).on('click', '.js-address-load-address', function (e) {
      //  e.preventDefault();
      //  let data = $('form', module.$element).serialize();
      //  electrolux.checkout.postData(module, "address/loadaddress", data);
      //});

      $(document).on(electrolux.events.checkoutV3LoadAddress, function (e) {
        electrolux.checkout.loadStep(module, moduleObj.endpoint);
      });
    }
  });
})();
(function () {
  "use strict";

  var moduleObj = moduler('checkout-v3-payment', {
    defaults: {
    },
    endpoint:'payment',
    init: function (module) {
			$(module.$element).on('click', '.js-payment-submit', function (e) {
        e.preventDefault();
        electrolux.checkout.submitStep(module, moduleObj.endpoint);
      });

      $(module.$element).on('click', '.js-change', function (e) {
        e.preventDefault();
        electrolux.checkout.loadStep(module, moduleObj.endpoint);
			});

			$(module.$element).on('change', '.js-payment-agree-terms', function (e) {
				let $element = $('#dropin-container', module.$element);
				let $text = $('.js-payment-agree-text', module.$element);
				if ($(this).is(':checked')) {
					$element.removeClass('is-disabled');
					$text.hide();
				} else {
					$element.addClass('is-disabled');
					$text.show();
				}
			});

      $(document).on(electrolux.events.checkoutV3LoadPayment, function (e) {
        electrolux.checkout.loadStep(module, moduleObj.endpoint);
			});
    },
  });
})();
(function () {
  "use strict";

  var moduleObj = moduler('checkout-v3-shipping', {
    defaults: {
    },
    endpoint:'shipping',
    init: function (module) {
      $(module.$element).on('click', '.js-shipping-submit', function (e) {
        e.preventDefault();
        electrolux.checkout.submitStep(module, moduleObj.endpoint);
      });

      $(module.$element).on('click', '.js-change', function (e) {
        e.preventDefault();
        electrolux.checkout.loadStep(module, moduleObj.endpoint);
      });

      $(document).on(electrolux.events.checkoutV3LoadShipping, function (e) {
        electrolux.checkout.loadStep(module, moduleObj.endpoint);
      });
    },
  });
})();
(function () {
  "use strict";

  var moduleObj = moduler('checkout-v3-storepickup-address', {
    defaults: {
    },
    endpoint:'storepickupaddress',
    init: function (module) {
      $(module.$element).on('click', '.js-address-submit', function (e) {
        e.preventDefault();
        electrolux.checkout.submitStep(module, moduleObj.endpoint);
      });

      $(document).on(electrolux.events.checkoutV3LoadAddress, function (e) {
        electrolux.checkout.loadStep(module, moduleObj.endpoint);
      });
    }
  });
})();
(function () {
  "use strict";

  var moduleObj = moduler('checkout-v3-storepickup-summary', {
    defaults: {
    },
    endpoint:'storepickupsummary',
    init: function (module) {
      $(document).on(electrolux.events.checkoutV3LoadSummary, function (e) {
        electrolux.checkout.loadStep(module, moduleObj.endpoint);
      });

			$(module.$element).on('click', '.js-cart-change-quantity', function (e) {
        e.preventDefault();
        let code = $(this).data('code');
        let quantity = $(this).data('quantity');
        let storeId = $(this).data('storeid');
        electrolux.checkout.postData(module, moduleObj.endpoint + '/updatequantity', { code: code, quantity: quantity, storeId: storeId });
      });
    }
  });
})();
(function () {
  "use strict";

  var moduleObj = moduler('checkout-v3-summary', {
    defaults: {
    },
    endpoint:'summary',
    init: function (module) {
      $(document).on(electrolux.events.checkoutV3LoadSummary, function (e) {
        electrolux.checkout.loadStep(module, moduleObj.endpoint);
      });

      $(module.$element).on('click', '.js-cart-change-quantity', function (e) {
        e.preventDefault();
        let code = $(this).data('code');
        let quantity = $(this).data('quantity');
        let storeId = $(this).data('storeid');
        electrolux.checkout.postData(module, moduleObj.endpoint + '/updatequantity', { code: code, quantity: quantity, storeId: storeId });
      });

      $(module.$element).on('click', '.js-checkout-summary-coupon-code-toggle', function (e) {
        e.preventDefault();
        $('.js-checkout-summary-coupon-code-panel', module.$element).toggleClass('u-hidden');
      });

      $(module.$element).on('click', '.js-checkout-summary-coupon-code-submit-button', function (e) {
        e.preventDefault();
        let couponCode = $('.js-checkout-summary-coupon-code-input', module.$element).val();
        if (couponCode != '') {
          electrolux.checkout.postData(module, moduleObj.endpoint + '/handlecouponcode', { couponCode: couponCode }, function () {
            $('.js-checkout-summary-coupon-code-input', module.$element).val('');
					});
				}
      });

      $(module.$element).on('click', '.js-checkout-summary-coupon-code-remove', function (e) {
        electrolux.checkout.postData(module, moduleObj.endpoint + '/handlecouponcode', { couponCode: '' });
      });

      $(module.$element).on('click', '.js-checkout-summary-toggle', function (e) {
        $('.js-checkout-summary').toggleClass('CheckoutSummary--active');
        electrolux.utils.toggleScroll(!!$('.js-checkout-summary').hasClass('CheckoutSummary--active'));
      });
    }
  });
})();
var electrolux = electrolux || {};

electrolux.checkout = {
  postData: function (module, endpoint, data, callback) {
    $.ajax({
      url: '/checkout/' + endpoint,
      type: 'POST',
      data: data,
      dataType: 'json',
      success: function (data) {
        if (data.isSuccessful) {
          if (data.loadStep != 'none') {
            electrolux.checkout.closeStep(module);
            if (data.nextStep == 'addressStep') {
              $(document).trigger(electrolux.events.checkoutV3LoadAddress);
            } else if (data.loadStep == 'additionalServicesStep') {
              $(document).trigger(electrolux.events.checkoutV3LoadAdditionalServices);
            } else if (data.loadStep == 'shippingStep') {
              $(document).trigger(electrolux.events.checkoutV3LoadShipping);
            } else if (data.loadStep == 'paymentStep') {
              $(document).trigger(electrolux.events.checkoutV3LoadPayment);
            }
          }
          if (data.redirectUrl != null) {
            window.location.href = data.redirectUrl;
					}
          if (data.reloadSummary == true) {
            $(document).trigger(electrolux.events.checkoutV3LoadSummary);
          }
          if (data.reloadPayment == true) {
            $(document).trigger(electrolux.events.checkoutV3LoadPayment);
					}
          if (data.action == 'reload' && data.html != null) {
            module.$element.html(data.html);
          }
          if (data.removeAdditionalServices == true) {
            $('.js-checkout-step-additional-services').remove();
          }
        }
        if (data.errors.length > 0) {
          let errorList = $('.js-error-list', module.$element);
          errorList.empty();
          $.each(data.errors, function (index, value) {
            $('<li/>')
              .text(value)
              .appendTo(errorList);
          });
          $('.js-error-panel', module.$element).removeClass('u-hidden');
        }
        if (data.fieldValidationErrors.length>0) {
          $.each(data.fieldValidationErrors, function (index, value) {
            let valueParts = value.split('|');
            let element = $('span[data-valmsg-for="' + valueParts[0] + '"]');
            element.text(valueParts[1]);
            element.addClass('field-validation-error');
            element.removeClass('field-validation-valid');
          });
				}
        if (callback != null) {
          callback(data);
				}
      },
      error: function (request, error) {
        alert("Request: " + JSON.stringify(request));
      }
    });
  },

  loadStep: function (module, endpoint) {
    if ($('.js-main-form', module.$element).data('step') != null) {
      let step = parseInt($('.js-main-form', module.$element).data('step'));
      electrolux.checkout.changeStep(step);
    }
    $.ajax({
      url: '/checkout/' + endpoint,
      type: 'GET',
      dataType: 'json',
      success: function (data) {
        if (data.isSuccessful) {
          module.$element.html(data.html);
        } else {
          alert('not successful');
        }
      },
      error: function (request, error) {
        alert("Request: " + JSON.stringify(request));
      }
    });
  },

  submitStep: function (module, endpoint) {
    let $form = $('form', module.$element);
    if ($form.valid()) {
      electrolux.checkout.postData(module, endpoint, $form.serialize());
    }
  },

  closeStep: function (module) {
    $('.js-main-form', module.$element).addClass('u-hidden');
    $('.js-heading-closed', module.$element).addClass('u-hidden');
    $('.js-heading-change', module.$element).removeClass('u-hidden');
  },

  changeStep: function (currentStep) {
    $('.js-checkout-step', '.js-checkout').each(function (index, item) {
      $element = $(item);
      let itemStep = parseInt($('.js-main-form', $element).data('step'));
      $('.js-main-form', $element).addClass('u-hidden');
      if (itemStep > currentStep) {
        $('.js-heading-closed', $element).removeClass('u-hidden');
        $('.js-heading-change', $element).addClass('u-hidden');
      } else {
        $('.js-heading-closed', $element).addClass('u-hidden');
        $('.js-heading-change', $element).removeClass('u-hidden');
			}
    });
	}
};
(function () {
	"use strict";

	var moduleObj = moduler('compare-products-table', {
		defaults: {
			event: 'click',
			getCompareView: null,
			CompareServiceUrl: '/api/Compare',
			compareRemove: '.js-compare-table-remove',
			compareIndicator: '.js-compareIndicator',
			compareIndicatorUpdate: '.js-compareIndicator-update',
			clearSelector: '.js-clear-table'
		},
		init: function (module) {
			module.$element.on(module.settings.event, module.settings.compareRemove, module, moduleObj.listen.removeFromCompare);

			$(module.settings.clearSelector, module.$element).click(function (e) {
				e.preventDefault();
				moduleObj.clear(module);
			});
		},

		listen: {
			removeFromCompare: mo.event(function (module, e, data) {
				e.preventDefault();
				var $this = module.$element.find(e.currentTarget);
				var productCode = $this.data('productcode')

				$.ajax({
					type: 'POST',
					url: module.settings.CompareServiceUrl + '/remove',
					data: { productCode: productCode },
					cache: false
				})
					.done(function (response) {
						var url = location.href;
						url = url.replace(productCode, '');
						$.ajax({
							type: 'GET',
							url: url,
							data: $.extend({ partial: true }, null)
						}).done(function (compareHtml) {
							//ugly fix when compare table is empty and we redirect to start page
							if (compareHtml.indexOf('</html>') >= 0) {
								window.location = '/';
							} else {
								$('.js-compare-content', module.$element).html(compareHtml);
								history.pushState(null, null, url);
								$('.js-share-button', module.$element).data('url', url);
							}
						});
					});
			})
		},

		clear: function (module) {
			$.ajax({
				type: 'POST',
				url: module.settings.CompareServiceUrl + '/clear',
				cache: false
			})
				.done(function (response) {
					window.location.href = response.url;
				});
		},
		destroy: function (module) { }
	});

})();
(function () {
	"use strict";

	var moduleObj = moduler('compare-products', {
		defaults: {
			event: 'click',
			CompareServiceUrl: '/api/Compare',
			compareItemSelector: '.js-compareItem',
			compareIndicator: '.js-compareIndicator',
			compareIndicatorUpdate: '.js-compareIndicator-update',
			clearSelector: '.js-compare-clear'
		},
		maxCompareProducts: 4,
		init: function (module) {

			$(module.$element).on(module.settings.event, module.settings.compareItemSelector, function (e) {
				if ($(this).attr('type') == 'checkbox') {
					if ($(this).is(':checked')) {
						moduleObj.addToCompare(module, $(this));
					} else {
						moduleObj.removeFromCompare(module, $(this));
					}
				} else {
					moduleObj.toggleCompare(module, $(this));
				}
			});

			$(module.$element).on('click', module.settings.clearSelector, function (e) {
				e.preventDefault();
				moduleObj.clear(module, $(this));
			});

			moduleObj.loadCompare(module);
		},

		loadCompare: function (module) {
			$.ajax({
				type: 'POST',
				url: module.settings.CompareServiceUrl + '/List',
			})
				.done(function (response, textStatus, jqXHR) {
					if (typeof response !== 'object') {
						return;
					}
					$('.js-compareItem').each(function (index, value) {
						$(this).prop('checked', false);
					});
					$(response).each(function (index, value) {
						var group = value.GroupId;
						var code = value.Code;
						$('input[type=checkbox][data-productCode="' + code + '"]').prop('checked', true);
					});
					if (response.length > 0) {
						var $compareIndicator = module.$element.find(module.settings.compareIndicator);
						var $compareIndicatorUpdate = module.$element.find(module.settings.compareIndicatorUpdate);
						if (response.length > 0) {
							$($compareIndicator).show()
						}
						$compareIndicatorUpdate.html('<strong>' + response.length + ' produkter</strong>');
					}
				})
		},

		clear: function (module, $element) {
			moduleObj.callCompareService(module, $element, 'Clear');
			$('.js-compareItem').each(function (index, value) {
				$(this).prop('checked', false);
			});
		},

		toggleCompare: function (module, $element) {
			moduleObj.callCompareService(module, $element, 'Toggle');
		},
		addToCompare: function (module, $element) {
			moduleObj.callCompareService(module, $element, 'Add');
		},
		removeFromCompare: function (module, $element) {
			moduleObj.callCompareService(module, $element, 'Remove');
		},
		callCompareService: function (module, $element, method) {
			var productCode = $element.data('productcode')
			$.ajax({
				type: 'POST',
				url: module.settings.CompareServiceUrl + '/' + method,
				data: { productCode: productCode },
				cache: false
			})
			.done(function (response) {
				if (response.IsSuccess) {
					var $compareIndicator = module.$element.find(module.settings.compareIndicator);
					var $compareIndicatorUpdate = module.$element.find(module.settings.compareIndicatorUpdate);
					if (response.ProductsInCompare > 0) {
						$($compareIndicator).show();
						$compareIndicatorUpdate.html('<strong>' + response.ProductsInCompare + ' produkter</strong>');
						$compareIndicator.addClass("is-active");
						setTimeout(function () {
							$compareIndicator.removeClass("is-active");
						}, 3000);
					} else {
						$($compareIndicator).hide();
					}
				} else {
					$(document).trigger(electrolux.events.dialogShowMessage, ['', 'Det går inte att lägga till fler produkter för jämförelse i kategorin "' + response.CategoryName + '". Max 4 produkter per kategori.']);
					$element.prop('checked', false);
				}
			});
		},

		destroy: function (module) { }
	});
})();
(function () {
	"use strict";

	var moduleObj = moduler('favorite-item-list', {
		defaults: {
			serviceUrl: null
		},

		init: function (module) {
			$(document).on(electrolux.events.heartRemoved, function (e) {
				$.ajax({
					url: module.settings.serviceUrl,
					method: 'GET',
					cache: false
				}).done(function (data) {
					module.$element.html(data);
					$(document).trigger(electrolux.events.favoriteListUpdated);
					$(document).trigger(electrolux.events.lazyLoadImages);
				});
			});
		},

		destroy: function (module) { }
	});

})();
(function () {
	"use strict";

	var moduleObj = moduler('favorite-item-manager', {
		defaults: {
			emptyCssClass: 'Icon--wish-empty',
			activeCssClass: 'Icon--wish-active',
			baseServiceUrl: '/api/favoriteitem'
		},

		init: function (module) {
			$(document).on(electrolux.events.favoriteListUpdated, function () {
				moduleObj.updateHeartStatus(module);
			});

			$(document).on(electrolux.events.removeFromHeart, function (e, data) {
				moduleObj.updateFavorite(module, 'Remove', data);
			});

			$(document).on(electrolux.events.addToHeart, function (e, data) {
				moduleObj.updateFavorite(module, 'Add', data);
			});

			moduleObj.updateHeartStatus(module);
		},

		updateHeartStatus: function (module) {
			$.ajax({
				url: module.settings.baseServiceUrl + '/List',
				method: 'GET',
				dataType: 'json',
				cache: false
			}).done(function (data) {
				moduleObj.updateIcon(module, data.length);
				$.each($('.js-favorite-item'), function (index, value) {
					var settings = mo.utils.parseSettings($(value).attr('data-heart-toggler'));
					$.each(data, function (i, v) {
						if (v.ProductCode != null && v.ProductCode != '' && v.ProductCode == settings.productCode) {
							$(value).data('favorite-item-id', v.FavoriteItemId);
							$(value).removeClass(module.settings.emptyCssClass).addClass(module.settings.activeCssClass);
						} else if (v.TargetContentId > 0 && v.ImageContentId > 0 && v.TargetContentId == settings.targetContentId && v.ImageContentId == settings.imageContentId) {
							$(value).data('favorite-item-id', v.FavoriteItemId);
							$(value).removeClass(module.settings.emptyCssClass).addClass(module.settings.activeCssClass);
						}
					});
				});
				if (window.stButtons) {
					window.stButtons.locateElements();
				}
			});
		},

		updateFavorite: function (module, method, favoriteData) {
			$.ajax({
				url: module.settings.baseServiceUrl + '/' + method,
				method: 'POST',
				data: JSON.stringify(favoriteData),
				dataType: 'json',
				contentType: 'application/json'
			}).done(function (data) {
				if (method == 'Remove') {
					$(document).trigger(electrolux.events.heartRemoved);
				}
				moduleObj.updateIcon(module, data.NumberOfFavoriteItems);
			});
		},

		updateIcon: function (module, numberOfFavoriteItems) {
			$('.js-favorite-quantity').text(numberOfFavoriteItems);
			if (numberOfFavoriteItems > 0) {
				$('.js-favorite-quantity').show();
			} else {
				$('.js-favorite-quantity').hide();
			}
		},

		destroy: function (module) { }
	});
})();
(function () {
	"use strict";

	var moduleObj = moduler('filter', {
		defaults: {
			loadFilterServiceUrl: null
		},
		init: function (module) {
			$(module.$element).on('change', '.js-filter-checkbox', function (e) {
				moduleObj.updateFilter(module);
			});

			$(module.$element).on('click', '.js-filter-checkbox-selected-item', function (e) {
				e.preventDefault();
				var $parent = $(e.target).closest('.js-filter-item');
				var value = $(this).data('filterValue');
				if ($parent != null && value != null) {
					$('input[type=checkbox][data-filter-value="' + value + '"]:checked', $parent).prop('checked', false);
					moduleObj.updateFilter(module);
				}
			});

			$(module.$element).on('click', '.js-filter-range-selected-item', function (e) {
				e.preventDefault();
				var $parent = $(e.target).closest('.js-filter-item');
				var sliders = $('.js-filter-slider', $parent);
				if (sliders.length > 0) {
					var slider = sliders[0].noUiSlider;
					slider.set([slider.options.range.min, slider.options.range.max]);
					moduleObj.updateFilter(module);
				}
			});

			$(module.$element).on('click', '.js-filter-clear', function (e) {
				window.location.href = window.location.href.split('?')[0];
			});

			$(module.$element).on('menu-hidden', '.js-filter-expanded-menu', function (e) {
				var $target = $(e.currentTarget).closest('.Filter-option');
				if ($target != null && $target.data('filterType') == 'rangeSlider') {
					var sliders = $('.js-filter-slider', $target);
					if (sliders.length > 0) {
						var slider = sliders[0].noUiSlider;
						slider.set([sliders.data('min'), sliders.data('max')]);
					}
				} else if ($target != null && $target.data('filterType') == 'checkbox') {
					$('input[type=checkbox]', $target).each(function (key, value) {
						var selected = $(this).data('selected');
						$(this).prop('checked', selected);
					});
				}
			});
			moduleObj.initSliders(module);

			var filterQS = moduleObj.getParameterByName('filter');
			if (filterQS != '' && filterQS != null) {
				$('.js-filter-clear').removeClass('u-hidden');
			}
		},

		initSliders: function (module, counter) {
			if (counter == null) {
				counter = 0;
			}
			$('.js-filter-item', module.$element).each(function (key, value) {
				var type = $(value).data('filterType');
				if (type == 'rangeSlider') {
					var sliders = $('.js-filter-slider', $(value));
					var disabled = $('.js-filter-range-slider', $(value)).data('disabled');
					if (sliders.length > 0 && disabled == null) {
						if (sliders[0].noUiSlider == null) {
							if (counter != null && counter < 10) {
								setTimeout(function () {
									moduleObj.initSliders(module, ++counter);
								}, 200);
							}
							return;
						}
						sliders[0].noUiSlider.on('change', function (e) {
							moduleObj.updateFilter(module);
						});
					}
				}
			});
		},

		updateFilter: function (module) {
			// save current filter so when user updated or use the back button it will show the same result as when they left
			var filterQS = moduleObj.updateFilterQueryString(module);
			$.ajax({
				type: 'GET',
				url: module.settings.loadFilterServiceUrl + '?' + filterQS,
				success: function (response) {
					var openFilterId = $('.js-filter-menu.is-active', module.$element).attr('id');
					$('.js-filter', module.$element).html(response.html);
					moduleObj.initSliders(module);
					if (openFilterId != null) {
						$('#' + openFilterId).trigger('click');
					}
					if (filterQS != 'filter=' && filterQS != '') {
						$('.js-filter-clear').removeClass('u-hidden');
					}
				}
			});
			$(document).trigger(electrolux.events.filterUpdated);
		},

		updateFilterQueryString: function (module) {
			var filterItems = moduleObj.getSelectedFilterItems(module);
			if (filterItems == null) {
				return;
			}
			var hash = '';
			$.each(filterItems, function (index, value) {
				var values = '';
				if (value.selectedValues != null) {
					$.each(value.selectedValues, function () {
						values += this.replace('&', '§') + '|';
					});
					hash += value.filterType + '_' + value.name + '=' + values.substring(0, values.length - 1) + '&';
				}
			});
			hash = hash.substring(0, hash.length - 1);
			var url = moduleObj.updateQueryStringParam('filter', encodeURIComponent(hash));
			history.replaceState(null, document.title, url);
			return 'filter=' + encodeURIComponent(hash);
		},

		getSelectedFilterItems: function (module) {
			var filterItems = [];
			$('.js-filter-item', module.$element).each(function (key, value) {
				var type = $(value).data('filterType');
				var name = $(value).data('filterName');
				if (type == 'checkbox') {
					var values = [];
					$('input[type=checkbox]:checked', $(this)).each(function (index, element) {
						var value = $(this).data('filterValue');
						values.push(value.toString());
					});
					if (values.length > 0) {
						filterItems.push({
							filterType: 'checkbox',
							name: name,
							selectedValues: values
						});
					}
				} else if (type == 'rangeSlider') {
					var sliders = $('.js-filter-slider', $(value));
					var disabled = $('.js-filter-range-slider', $(value)).data('disabled');
					if (sliders.length > 0 && disabled == null) {
						var name = $(this).data('filterName');
						var range = sliders[0].noUiSlider.options.range;
						var values = sliders[0].noUiSlider.get();
						if (range.min != values[0] || range.max != values[1]) {
							filterItems.push({
								filterType: 'rangeSlider',
								name: name,
								selectedValues: values
							});
						}
					}
				}
			});
			return filterItems;
		},

		getParameterByName: function (name, url) {
			if (!url) {
				url = window.location.href;
			}
			name = name.replace(/[\[\]]/g, '\\$&');
			var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
				results = regex.exec(url);
			if (!results) {
				return null;
			} else if (!results[2]) {
				return '';
			} else {
				return decodeURIComponent(results[2].replace(/\+/g, ' '));
			}
		},

		updateQueryStringParam: function (key, value) {
			var baseUrl = [location.protocol, '//', location.host, location.pathname].join('');
			var urlQueryString = location.search;
			var newParam = key + '=' + value;
			var params = '?';

			// If the "search" string exists, then build params from it
			if (urlQueryString) {
				var updateRegex = new RegExp('([\?&])' + key + '[^&]*');
				var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');

				if (typeof value == 'undefined' || value == null || value == '') {
					params = urlQueryString.replace(removeRegex, "$1");
					params = params.replace(/[&;]$/, "");
				} else if (urlQueryString.match(updateRegex) !== null) {
					params = urlQueryString.replace(updateRegex, "$1" + newParam);
				} else {
					params = urlQueryString + '&' + newParam;
				}
			} else if (typeof value != 'undefined' && value != null && value != '') {
				params = '?' + newParam;
			}
			params = params == '?' ? '' : params;
			return baseUrl + params + location.hash;
		}
	});
}) ();
(function () {
	"use strict";

	var moduleObj = moduler('productlist-pager', {
		defaults: {
			showMoreSelector: '.js-show-more',
			productListContainer: '.js-productListContainer',
			productListSelector: '.js-productList',
			simpleFilterSelector: '.js-product-list-simple-filter',
			productItemSelector: '.js-product-item',
			pagerMessageSelector: '.js-pager-message',
			totalProductsSelector: '.js-total-products',
			sortOrderSelector: '.js-sort-order',
			pageSize: null,
			totalProducts: null,
			currentPage: 1
		},
		currentPage: 1,
		init: function (module) {
			moduleObj.currentPage = module.settings.currentPage;

			$(module.$element).on('click', module.settings.showMoreSelector, function (e) {
				e.preventDefault();
				moduleObj.currentPage++;
				var url = moduleObj.updateQueryStringParam('page', moduleObj.currentPage);
				window.history.replaceState(null, document.title, url);
				moduleObj.loadProducts(module, true);
			});

			$(module.$element).on('click', module.settings.simpleFilterSelector, function (e) {
				e.preventDefault();
				moduleObj.currentPage = 1;
				var categoryId = $(this).data('categoryid');
				var url = moduleObj.updateQueryStringParam('page', moduleObj.currentPage);
				url = moduleObj.updateQueryStringParam('categoryid', categoryId, url);
				window.history.replaceState(null, document.title, url);
				moduleObj.loadProducts(module, false);

				if (!$(this).hasClass('js-sub-category')) {
					$('.js-product-list-simple-filter', module.$element).removeClass('is-active');
					$(this).addClass('is-active');

					$('.js-sub-category', module.$element).removeClass('is-active');
					$('.js-sub-category-list', module.$element).addClass('u-hidden');
					$('.js-sub-category-list[data-categoryid=' + categoryId + ']', module.$element).removeClass('u-hidden');
				} else {
					$('.js-sub-category', module.$element).removeClass('is-active');
					$(this).addClass('is-active');
				}
			});

			$(document).on(electrolux.events.filterUpdated, function (e, currentFilter) {
				moduleObj.currentPage = 1;
				var url = moduleObj.updateQueryStringParam('page', null);
				window.history.replaceState(null, document.title, url);
				moduleObj.loadProducts(module, false);
			});

			$(document).on('change', module.settings.sortOrderSelector, function (e) {
				moduleObj.currentPage = 1;
				var url = moduleObj.updateQueryStringParam('page', null);
				url = moduleObj.updateQueryStringParam('sortorder', $(this).val(), url);
				window.history.replaceState(null, document.title, url);
				moduleObj.loadProducts(module, false);
			});
		},

		loadProducts: function (module, append) {
			var url = moduleObj.updateQueryStringParam('partial', true);
			$.ajax({
				type: 'GET',
				url: url
			}).done(function (data, status, xhr) {
				var productCount = parseInt(xhr.getResponseHeader('X-ProductCount'));
				var lastPage = xhr.getResponseHeader('X-LastPage');
				moduleObj.updateList(module, data.html, productCount, lastPage, append);
			});
		},

		updateList: function (module, htmlContent, productCount, lastPage, append) {
			if (append) {
				$(module.settings.productListContainer).append(htmlContent);
			} else {
				$(module.settings.productListContainer).html(htmlContent);
			}
			$(document).trigger(electrolux.events.lazyLoadImages);
			$(document).trigger(electrolux.events.productListUpdated);
			var showing = $(module.settings.productItemSelector, module.settings.productListSelector).length;
			if (showing > productCount) {
				showing = productCount;
			}
			moduleObj.updateMessage(module, showing, productCount);
			if (lastPage) {
				$(module.settings.showMoreSelector, module.$element).hide();
				$(module.settings.showMoreSelector, module.$element).addClass('u-hidden');
			} else {
				$(module.settings.showMoreSelector, module.$element).show();
				$(module.settings.showMoreSelector, module.$element).removeClass('u-hidden');
			}
			$(document).trigger('load-store-stock');
		},

		updateMessage: function (module, showing, totalProducts) {
			$(module.settings.pagerMessageSelector, module.$element).text('Visar ' + (totalProducts > 0 ? '1' : '0') + ' - ' + showing + ' av ' + totalProducts);
			if (totalProducts > 1 || totalProducts < 1) {
				$(module.settings.totalProductsSelector).text(totalProducts + ' produkter');
			} else {
				$(module.settings.totalProductsSelector).text(totalProducts + ' produkt');
			}
		},

		updateQueryStringParam: function (key, value, url) {
			var baseUrl = url ? url.split('?')[0] : [location.protocol, '//', location.host, location.pathname].join('');
			var urlQueryString = (url ? url.split('?')[1] : location.search) || '';
			var newParam = key + '=' + value;
			var params = '?';
			if (urlQueryString != '' && urlQueryString.indexOf('?') == -1) {
				urlQueryString = '?' + urlQueryString;
			}
			// If the "search" string exists, then build params from it
			if (urlQueryString) {
				var updateRegex = new RegExp('([\?&])' + key + '[^&]*');
				var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');

				if (typeof value == 'undefined' || value == null || value == '') {
					params = urlQueryString.replace(removeRegex, "$1");
					params = params.replace(/[&;]$/, "");
				} else if (urlQueryString.match(updateRegex) !== null) {
					params = urlQueryString.replace(updateRegex, "$1" + newParam);
				} else {
					params = urlQueryString + '&' + newParam;
				}
			} else if (typeof value != 'undefined' && value != null && value != '') {
				params = '?' + newParam;
			}
			params = params == '?' ? '' : params;
			return baseUrl + params + location.hash;
		}
	});
})();
(function () {
	"use strict";

	var moduleObj = moduler('store-list', {
		defaults: {
			serviceUrl: null
		},
		init: function (module) {

			$(module.$element).on('click', '.js-store-info', function (e) {
				debugger;
				e.preventDefault();
				let storeId = $(this).data('storeid');
				$.ajax({
					type: 'GET',
					url: module.settings.serviceUrl + '?storeId=' + storeId,
					success: function (response) {
						$('.js-store-info-container', module.$element).html(response.Html);
					}
				});
			});
		},
	});
})();
//# sourceMappingURL=modules.js.map
